/** CPC shared UI strings — default locale is Traditional Chinese.
 * Generated by scripts/sync_cpc_i18n.mjs — do not edit by hand.
 */

export const LOCALE_CODES = ["zh-Hant", "en", "ms", "vi", "th", "ko"] as const;

export type LocaleCode = (typeof LOCALE_CODES)[number];

export const LOCALE_LABELS: Record<LocaleCode, string> = {
	"zh-Hant": "繁體中文",
	"en": "English",
	"ms": "Bahasa Melayu",
	"vi": "Tiếng Việt",
	"th": "ไทย",
	"ko": "한국어",
};

export const DEFAULT_LOCALE: LocaleCode = "zh-Hant";

export type MessageCatalog = Record<string, string>;

const zhHant: MessageCatalog = {
	"common.language": "語言",
	"common.network": "網路",
	"common.wallet": "錢包",
	"common.cancel": "取消",
	"common.confirm": "確認",
	"common.refresh": "重新整理",
	"common.loading": "載入中…",
	"common.save": "儲存",
	"common.lock": "鎖定",
	"common.close": "關閉",
	"common.back": "返回",
	"common.copy": "複製",
	"common.error": "發生錯誤",
	"common.spot": "現貨",
	"common.buy": "買入",
	"common.sell": "賣出",
	"common.price": "價格",
	"common.quantity": "數量",
	"common.available": "可用",
	"common.settings": "設定",
	"common.detect": "檢測",
	"nav.dex": "DEX",
	"nav.bridge": "跨鏈橋",
	"nav.stake": "質押",
	"nav.genesis": "創世公示",
	"nav.apps": "應用",
	"nav.assets": "資產",
	"nav.send": "轉帳",
	"nav.trade": "交易",
	"nav.network": "網路",
	"nav.dapp": "DApp",
	"nav.crossChain": "跨鏈",
	"nav.market": "行情",
	"explorer.title": "DGC 瀏覽器",
	"explorer.tagline": "區塊瀏覽器",
	"wallet.title": "DGC 錢包",
	"wallet.tagline": "主網 · 地址餘額 · 質押",
	"wallet.welcome": "歡迎使用 DGC 錢包",
	"wallet.welcomeDesc": "設定擴充密碼保護錢包，類似 MetaMask。",
	"wallet.unlock": "解鎖錢包",
	"wallet.unlockDesc": "請輸入擴充密碼使用錢包。",
	"wallet.password": "擴充密碼",
	"wallet.passwordConfirm": "確認密碼",
	"wallet.passwordPlaceholder": "至少 8 位",
	"wallet.rememberUnlock": "保持解鎖",
	"wallet.create": "建立錢包",
	"wallet.import": "匯入錢包",
	"wallet.generateMnemonic": "產生助記詞",
	"wallet.mnemonic": "助記詞（12 / 24 詞）",
	"wallet.privateKey": "私鑰",
	"wallet.backupTitle": "備份助記詞",
	"wallet.backupDesc": "請抄寫在安全處。遺失將無法找回資產。",
	"wallet.backupAck": "我已安全備份助記詞",
	"wallet.backupDone": "完成建立",
	"wallet.addressBalance": "地址餘額",
	"wallet.totalBalance": "總餘額",
	"wallet.lockNow": "立即鎖定錢包",
	"wallet.export": "匯出錢包",
	"wallet.security": "錢包安全",
	"wallet.autoLock": "自動鎖定",
	"wallet.connectedSites": "已連線網站",
	"wallet.txHistory": "交易紀錄",
	"wallet.noTx": "暫無交易",
	"wallet.loadingWallet": "正在載入錢包…",
	"trade.pair": "DGC / DATA",
	"trade.buyDgc": "買入 DGC",
	"trade.sellDgc": "賣出 DGC",
	"trade.limitPrice": "限價",
	"trade.quantity": "數量",
	"trade.estimateSpend": "預計消耗 — DATA",
	"trade.estimateReceive": "預計收到 — DATA（扣費後）",
	"trade.bids": "買盤",
	"trade.asks": "賣盤",
	"trade.marketTrades": "市場成交",
	"trade.myTrades": "我的成交",
	"trade.openOrders": "目前委託",
	"trade.priceData": "價格(DATA)",
	"trade.qtyDgc": "數量(DGC)",
	"trade.lastPrice": "最新價",
	"trade.loadingMarket": "載入中…",
	"trade.refresh": "重新整理行情與成交",
	"sign.request": "交易簽名請求",
	"sign.approve": "批准並簽名",
	"sign.reject": "拒絕",
	"connect.request": "網站連線請求",
	"connect.approve": "允許連線",
	"connect.reject": "拒絕",
	"connect.desc": "批准後該網站可查看你的 DGC 地址，並請求交易簽名。可隨時在「網路 → 已連線網站」撤銷。",
	"language.title": "語言",
	"language.subtitle": "選擇介面語言，預設英語。",
	"settings.networkRpc": "網路與 RPC",
	"settings.walletSecurity": "錢包安全",
	"settings.walletManage": "錢包管理",
	"settings.connectedDapps": "已連線 DApp",
	"common.time": "時間",
	"common.side": "方向",
	"common.action": "操作",
	"common.status": "狀態",
	"common.account": "帳戶",
	"common.amount": "金額",
	"common.max": "全部",
	"common.empty": "暫無",
	"common.submitting": "提交中…",
	"common.connectWallet": "連接錢包",
	"common.disconnect": "斷開連接",
	"common.connecting": "連接中…",
	"common.loadMore": "載入更多",
	"common.all": "全部",
	"common.balance": "餘額",
	"common.spread": "價差",
	"trade.orderBook": "訂單簿",
	"trade.recentTrades": "最新成交",
	"trade.orderHistory": "歷史委託",
	"trade.tradeHistory": "成交記錄",
	"trade.bestBid": "買一",
	"trade.bestAsk": "賣一",
	"trade.change24h": "24h 漲跌",
	"trade.volume24h": "24h 量",
	"trade.turnover24h": "24h 額",
	"trade.trades24h": "24h 筆數",
	"trade.noTrades": "暫無成交",
	"trade.cancelOrder": "撤單",
	"trade.cancelling": "撤單中…",
	"trade.noOpenOrders": "暫無當前委託",
	"trade.noOrderHistory": "暫無歷史委託",
	"trade.connectToViewOrders": "請先連接錢包查看當前委託",
	"trade.statusOpen": "掛單中",
	"trade.statusFilled": "已成交",
	"trade.statusCancelled": "已撤銷",
	"trade.statusPartial": "部分成交",
	"trade.invalidPrice": "限價格式無效",
	"trade.enterQty": "請輸入 DGC 數量",
	"trade.qtyPositive": "DGC 數量須為正整數",
	"trade.bidSubmitted": "買單已提交",
	"trade.askSubmitted": "賣單已提交",
	"trade.cancelSubmitted": "撤單已提交",
	"trade.remaining": "剩餘",
	"trade.orderId": "訂單ID",
	"trade.taker": "主動方",
	"trade.noClob": "未配置 CLOB",
	"wallet.connect": "連接 DGC 錢包",
	"wallet.notDetected": "未偵測到 DGC Wallet",
	"wallet.downloadExt": "下載 DGC Wallet 擴充功能",
	"wallet.downloadApp": "下載 DGC Wallet",
	"wallet.appsCenter": "應用中心",
	"wallet.wrongWallet": "請連接 DGC Wallet",
	"wallet.disconnecting": "斷開中…",
	"wallet.viewBalance": "連接 DGC 錢包查看餘額",
	"send.recipient": "收款地址",
	"send.confirm": "確認發送",
	"send.token": "代幣",
	"stake.selectValidator": "請從列表中選擇驗證者",
	"stake.amount": "質押數量",
	"stake.myStakes": "我的質押",
	"stake.stakeDgc": "質押 DGC",
	"stake.noStakes": "暫無質押記錄",
	"stake.refreshValidators": "重新整理",
	"trade.orderQty": "委託量",
	"trade.noTradeHistory": "暫無成交記錄",
	"trade.remainingShort": "剩",
	"trade.clickFillPrice": "點擊填入限價",
	"trade.klineWindow": "K 線視窗",
	"trade.open24h": "24h 開",
	"trade.high24h": "24h 高",
	"trade.low24h": "24h 低",
	"trade.volume24hDgc": "24h 量 (DGC)",
	"trade.txExpired": "交易已過期，請重試",
	"trade.balanceLabel": "{symbol} 餘額",
	"wallet.connectFirst": "請先連接 DGC Wallet",
	"wallet.notFoundAlert": "未找到 DGC Wallet 擴充功能。請確認已安裝並啟用，然後重新整理本頁再試。",
	"wallet.installHint": "請下載安裝 Chrome 錢包擴充功能；或使用 DGC 錢包 APP 內建瀏覽器開啟本頁進行 Dapp 連接。",
	"wallet.siteEnabledHint": "當前站點 {origin}。安裝後請在 chrome://extensions 啟用擴充功能並重新整理本頁。",
	"wallet.notDetectedExt": "未偵測到 DGC Wallet 擴充功能",
	"send.success": "發送成功",
	"send.availableDash": "可用 —",
	"send.uxHint": "P-UX：優先從地址餘額轉出，Gas 由 DGC 地址餘額支付",
	"send.addCustomToken": "新增自訂 CLOB 代幣",
	"send.symbol": "符號",
	"send.typeTag": "TypeTag",
	"send.decimals": "小數位",
	"send.saveToList": "儲存到列表",
	"stake.submitted": "質押已提交",
	"stake.success": "質押成功",
	"stake.confirmTitle": "確認質押",
	"stake.confirmAction": "確認質押",
	"stake.selectValidatorLabel": "選擇驗證者",
	"stake.positions": "質押倉位",
	"stake.noPositions": "暫無質押倉位",
	"stake.lockHintShort": "鏈上本金鎖 180 epoch。鎖定期內可隨時提取收益；到期後可贖回本金。",
	"stake.newStake": "新建質押",
	"stake.enterAmount": "請輸入質押金額",
	"stake.confirmMessage": "將 {amount} DGC 質押到所選驗證者。\n本金鎖定 180 epoch，期間可隨時提取收益。",
	"stake.claimRewards": "提取質押收益",
	"stake.redeemPrincipal": "贖回質押本金",
	"stake.noPositionCount": "暫無倉位",
	"stake.positionCount": "共 {count} 筆",
	"apps.title": "應用",
	"apps.titleSuffix": "/ 生態中心",
	"apps.subtitle": "一站式存取 DGC 生態應用：全球購、RWAX 超級 App、DGC Wallet 原生錢包與鏈上工具。",
	"apps.mobileSubtitle": "全球購 · RWAX · DGC Wallet",
	"apps.viewAccount": "查看我的帳戶 →",
	"apps.featured": "精選應用",
	"apps.scanDownload": "掃碼下載",
	"apps.scanDownloadApk": "掃碼下載 APK",
	"apps.scanDownloadRwax": "掃碼下載 RWAX",
	"apps.mirrorDownload": "備用下載",
	"apps.chromeExt": "Chrome 擴充功能",
	"apps.globalShop": "全球購",
	"apps.globalShopDesc": "Data Global 跨境電商平台，支援多語言與多幣種，瀏覽潮流服飾、箱包鞋履與品牌專區，使用 DGC 錢包便捷結算。",
	"apps.openGlobalShop": "開啟全球購",
	"apps.tagEcommerce": "電商",
	"apps.globalShopApp": "全球購 APP",
	"apps.globalShopAppDesc": "行動端全球購用戶端，隨時隨地逛商城、查訂單、享促銷。右側掃碼即可安裝。",
	"apps.downloadGlobalShopApp": "下載全球購 APP",
	"apps.tagMobile": "行動端",
	"apps.walletDesc": "DGC 鏈原生錢包：管理資產、簽署 DApp 交易。本地下載、備用渠道與右側掃碼均可安裝 Android APK；亦提供 Chrome 擴充功能。",
	"apps.tagWallet": "錢包",
	"apps.rwaxDesc": "RWAX 超級 App：多鏈錢包、社交、DApp 瀏覽器與 DGC 官方瀏覽器一站整合。支援匯入 dgcprivkey / 助記詞，預設連接 DGC 生態。掃碼或點擊即可安裝 Android 用戶端。",
	"apps.downloadRwax": "下載 RWAX",
	"apps.tagSuperApp": "超級 App",
	"apps.onchainShortcuts": "鏈上快捷入口",
	"apps.dexTrade": "DEX 交易",
	"apps.dexTradeDesc": "現貨買賣 DGC",
	"apps.bridge": "跨鏈橋",
	"apps.bridgeDesc": "BNB USDT ↔ DATA（1:1）",
	"apps.stake": "質押",
	"apps.stakeDesc": "委託驗證者賺收益",
	"apps.explorer": "區塊瀏覽器",
	"apps.explorerDesc": "查交易與地址",
	"apps.myStatus": "我的鏈上狀態",
	"apps.totalBalance": "總餘額",
	"apps.viewAddress": "查看地址",
	"apps.connectToSeeBalance": "連接 DGC 錢包後顯示餘額",
	"stake.pageTitle": "質押",
	"stake.pageSubtitle": "委託 DGC 給驗證節點，參與網路共識並獲得質押獎勵。數量以 DGC 展示（1 DGC = 10⁹ MIST）。",
	"stake.epochProgress": "Epoch 進度",
	"stake.currentEpoch": "當前 Epoch",
	"stake.epochCycleAbout": "週期約 {duration}",
	"stake.latestCheckpoint": "最新 Checkpoint",
	"stake.checkpointHint": "鏈上進度參考",
	"stake.connectHint": "請在左側導航連接 DGC 錢包，查看餘額、委託明細並發起質押",
	"stake.staked": "已質押",
	"stake.viewAccount": "查看帳戶詳情",
	"stake.delegationDetails": "委託明細",
	"stake.tipGas": "• 質押與 Gas 均使用原生 DGC；請保留少量餘額支付手續費。",
	"stake.tipUnlock": "• 解質押需等待 epoch 解鎖週期（以鏈上 lock_until_epoch 為準）。",
	"stake.tipLeaderboard": "• 驗證者池質押排行見首頁 Leaderboards；",
	"stake.validatorsNetwork": "驗證者網路",
	"stake.networkStake": "全網 {symbol} 質押",
	"stake.networkStakeTip": "驗證者與委託者質押的 DGC 總量",
	"stake.avgDailyYield": "平均日化",
	"stake.avgDailyYieldTip": "全驗證者年化收益率 ÷365；鏈上樣本不足時按補貼參數估算",
	"stake.lastEpochReward": "上 Epoch 獎勵",
	"stake.lastEpochRewardTip": "上一 epoch 各驗證者池累計質押獎勵",
	"stake.activeValidators": "活躍驗證者",
	"stake.activeValidatorsTip": "當前 epoch 活躍驗證者數量",
	"stake.validatorMap": "驗證者分佈",
	"stake.mapLoading": "地圖載入中…",
	"stake.allValidators": "全部驗證者",
	"stake.validatorsLoadFailed": "驗證者資料載入失敗",
	"stake.colName": "名稱",
	"stake.colStake": "質押",
	"stake.colDaily": "日化",
	"stake.epochLoading": "Epoch 進度載入中…",
	"stake.epochProgressOf": "Epoch {epoch} 進度",
	"stake.remaining": "剩餘",
	"stake.lockProgress": "本金解鎖進度",
	"stake.noDelegations": "暫無委託記錄",
	"stake.fungibleCert": "Fungible 憑證",
	"stake.claimable": "可領取",
	"stake.activeEpoch": "啟動 Epoch",
	"stake.unlockEpoch": "解鎖 Epoch",
	"stake.epochsLeft": "剩餘 Epoch",
	"stake.lockPeriod": "鎖定期",
	"stake.claimableRewards": "可領取獎勵",
	"stake.principalUnlocked": "本金已解鎖，可贖回",
	"stake.redeemAfterUnlock": "解鎖後可贖回（Epoch {epoch}）",
	"genesis.title": "創世發行公示",
	"genesis.subtitle": "公開 DGC 創世分配，便於社群監督。總量 {total}（主幣 {symbol}）。點擊地址可查詢鏈上餘額。",
	"genesis.mobileSubtitle": "創世分配公示",
	"genesis.supplyCheck": "總量核對",
	"genesis.totalSupply": "創世總量",
	"genesis.tableSum": "分配表合計",
	"genesis.equalsTotal": "等於總量",
	"genesis.notEqualsTotal": "不等於總量",
	"genesis.liveValidators": "鏈上活躍驗證者",
	"genesis.reading": "讀取中…",
	"genesis.unavailable": "不可用",
	"genesis.expected": "預期 {count}",
	"genesis.compareConfig": "與創世配置比對（需已連接本網路 RPC）",
	"genesis.allocationDetail": "發行分配明細",
	"genesis.allocationIntro": "「創世分配」是計劃額度，不是即時餘額。點地址可查鏈上實際持幣。",
	"genesis.linear10yStrong": "線性 10 年",
	"genesis.allocationIntro2": "的四類池在 bootstrap 後裝入鏈上",
	"genesis.allocationIntro3": "，按時間線性 claim；平台生態無 vesting。「質押鎖」為驗證者自質押。",
	"genesis.colPurpose": "用途",
	"genesis.colAmount": "創世分配 (DGC)",
	"genesis.colPct": "佔比",
	"genesis.colVesting": "釋放 / 鎖定規則",
	"genesis.colAddress": "池地址（查鏈上餘額）",
	"genesis.seeStakePage": "見驗證者頁 / 質押頁",
	"genesis.pendingSync": "待同步",
	"genesis.total": "合計",
	"genesis.footerHint": "池地址餘額形態可能仍是 Coin 物件。線性 10 年池在完成 bootstrap-vesting 後，可在池地址頁查看可領額度、進度、領取記錄，並用對應錢包一鍵 claim。",
	"genesis.poolAddressPage": "池地址頁",
	"genesis.vesting.linear_10y": "線性 10 年",
	"genesis.vesting.none": "無鎖定（流通池）",
	"genesis.vesting.system": "系統池",
	"genesis.vesting.self_stake": "質押鎖 {epochs} epoch",
	"genesis.hint.linear_10y": "鏈上 vesting::linear::Wallet；按時間線性 claim。打開池地址頁可查看可領額度並領取。未 bootstrap 前可能仍是池地址上的 Coin",
	"genesis.hint.none": "無鏈上 vesting；可按營運規則轉出 / 使用",
	"genesis.hint.system": "按 epoch 補貼參數發放，非普通地址持幣",
	"genesis.hint.self_stake": "已進入驗證者質押池，受質押解鎖 epoch 約束",
	"genesis.pool.community": "社區建設",
	"genesis.pool.communityNote": "線性 10 年；創世打入池地址後由 bootstrap 裝入鏈上 Wallet",
	"genesis.pool.foundation": "基金會",
	"genesis.pool.foundationNote": "線性 10 年鏈上鎖倉",
	"genesis.pool.tech_support": "技術支援",
	"genesis.pool.tech_supportNote": "線性 10 年鏈上鎖倉",
	"genesis.pool.platform_ecosystem": "平台生態",
	"genesis.pool.platform_ecosystemNote": "無 vesting；營運 / 生態流通（多簽管理）",
	"genesis.pool.user_rewards": "用戶獎勵",
	"genesis.pool.user_rewardsNote": "線性 10 年鏈上鎖倉",
	"genesis.pool.validators": "創世驗證者自質押",
	"genesis.pool.validatorsNote": "{count} 名驗證者 × {each} DGC；本金鎖 {epochs} epoch",
	"genesis.pool.stake_subsidy_fund": "Stake Subsidy 基金",
	"genesis.pool.stake_subsidy_fundNote": "系統補貼池（創世打入 0x0）",
	"bridge.subtitle": "跨鏈資產為 DATA（非主幣 DGC），比例 1:1。BSC 側為官方 Binance-Peg USDT（BNB 鏈），DGC 鏈側 DATA（DGC Wallet），Relayer 自動清算。",
	"bridge.mobileSubtitle": "DATA ↔ BNB USDT · 1:1",
	"bridge.buyTitle": "用 BNB USDT 購買 DATA",
	"bridge.sellTitle": "賣出 DATA 換取 BNB USDT",
	"bridge.balance": "餘額",
	"bridge.toReceiveData": "To (DATA 預計收到)",
	"bridge.toReceiveUsdt": "To (BNB 預計收到)",
	"bridge.fromLockData": "From (DATA 鎖定)",
	"bridge.cpcRecipient": "DGC 鏈接收地址",
	"bridge.bscRecipient": "BNB 鏈收 USDT 目標地址",
	"bridge.recipientPlaceholder": "輸入 0x... 或 D… 格式的收款地址",
	"bridge.currentWallet": "當前錢包",
	"bridge.connectBscFirst": "請先連接 BSC 錢包",
	"bridge.connectCpcFirst": "請先連接 DGC 錢包",
	"bridge.switchMainnet": "請切換為 BSC 主網環境",
	"bridge.escrowMissing": "Escrow 充值合約未部署",
	"bridge.lockUsdtToData": "鎖定 {amount} {usdt} → DATA",
	"bridge.lockDataToUsdt": "鎖定 {amount} {data} → {usdt}",
	"bridge.bscBusy": "BSC 智能合約互動中…",
	"bridge.cpcBusy": "交易序列化提交中…",
	"bridge.dataBridgeStatus": "DATA 橋端狀態",
	"bridge.treasuryLocked": "金庫總鎖定",
	"bridge.gatewayRpc": "閘道 RPC 回應",
	"bridge.detecting": "檢測中",
	"bridge.bnbUsdtStatus": "BNB / USDT 狀態",
	"bridge.targetNetwork": "目標網路",
	"bridge.usdtContract": "BNB USDT 合約",
	"bridge.escrow": "Escrow 託管",
	"bridge.configMissing": "配置缺失",
	"bridge.nodeStatus": "節點狀態",
	"bridge.networkMatch": "網路匹配",
	"bridge.switchNetwork": "請切換網路",
	"bridge.notConnected": "未連接",
	"bridge.recentLocks": "最近 DATA 鎖定流水",
	"bridge.forUsdt": "→ 換取 BNB USDT",
	"bridge.noLocks": "暫無當前網路的跨鏈鎖定記錄",
	"bridge.colAmount": "鎖定數量",
	"bridge.colEstimate": "預計換得",
	"bridge.colRecipient": "接收地址",
	"bridge.colAction": "操作",
	"bridge.details": "詳情 →",
	"bridge.showRecent5": "顯示最近 5 條記錄",
	"bridge.refreshStatus": "重新整理狀態",
	"bridge.backHome": "← 返回首頁",
	"bridge.noConfig": "未偵測到橋配置。請先完成鏈上 Bridge 部署，並執行 ./cpc.sh stack start 或 ./cpc.sh client fetch-stack-config 同步 stack-config。",
	"bridge.connectMetaMask": "連接 MetaMask",
	"bridge.installEvm": "請安裝 MetaMask 或其它 EVM 錢包",
	"bridge.connectBsc": "連接 BSC 錢包",
	"bridge.noEvm": "未偵測到 EVM 錢包",
	"bridge.disconnect": "斷開",
	"bridge.ok": "正常",
	"bridge.fail": "異常",
	"bridge.processing": "處理中...",
	"bridge.useCurrent": "使用當前",
	"bridge.needBscRecipient": "請填寫或連接 BSC 收款地址",
	"bridge.needCpcRecipient": "請填寫 DGC 鏈收款地址",
	"bridge.escrowDeployHint": "Escrow 未配置：先在 BSC 主網部署 CpcUsdtEscrow",
	"bridge.mainnetTokenOnly": "目前配置為 BSC 主網 token，請取消勾選測試網",
	"bridge.lockedDataOk": "已鎖定 {amount} {data}，relayer 將向 {recipient}… 支付約 {usdtAmount} {usdt}",
	"bridge.lockedUsdtOk": "已鎖定 {amount} {usdt} → DATA（BSC tx {tx}…）",
	"bridge.noConfigLocalTitle": "本地開發請先部署 Bridge：",
	"bridge.noConfigSource": "配置真源：Push Hub /v1/stack-config（離線兜底 docs/generated/cpc-stack-config.json）。",
	"send.titleLeading": "鏈上",
	"send.badge": "鏈上轉帳",
	"send.fail": "轉帳失敗",
	"send.listSaved": "已儲存到列表",
	"send.recipientRequired": "請輸入收款地址",
	"send.amountRequired": "請輸入金額",
	"send.amountInvalid": "金額無效",
	"send.tokenPreset": "預設",
	"send.tokenCustom": "自訂",
	"send.balanceLine": "可用 {balance} {symbol}（地址餘額）· 總 {total}",
	"send.balanceLooseSuffix": " · 零散 {loose}",
	"send.decimalsHint": "小數位 (預設 9)",
	"home.titleLeading": "我的",
	"home.bridgeTitle": "跨鏈橋 USDT ↔ DGC",
	"home.bridgeSubtitle": "BSC 入金 · DGC 出金至 BSC / ETH",
	"common.loadMoreFailed": "載入更多失敗",
	"wallet.consolidateSkipped": "無需合併（無零散 Coin）",
	"wallet.consolidateDone": "合併完成",
	"wallet.consolidateLoose": "合併零散 DGC",
	"wallet.looseCoinHint": "存在 {amount} DGC 零散 Coin，建議合併到地址餘額後再大額操作。",
	"wallet.addressCopied": "地址已複製",
	"wallet.addressUnavailable": "地址不可用",
	"time.relativeDays": "{n} 天前",
	"time.relativeHours": "{n} 小時前",
	"time.relativeMinutes": "{n} 分鐘前",
	"time.justNow": "剛剛",
	"tx.direction.sent": "發出",
	"tx.direction.received": "收款",
	"tx.direction.other": "其他",
	"tx.status.success": "成功",
	"tx.status.failure": "失敗",
	"tx.status.unknown": "未知",
	"tx.detailLeading": "交易",
	"tx.detailHighlight": "詳情",
	"tx.explorerMissing": "未設定區塊瀏覽器地址",
	"tx.linkCopied": "連結已複製",
	"settings.probing": "檢測中…",
	"settings.rpcReachable": "RPC 可達 · Chain {chain}",
	"settings.rpcSaved": "RPC 已儲存",
	"settings.addedSwitched": "已新增並切換",
	"settings.lockPrefsSaved": "鎖定設定已儲存",
	"settings.exportTitle": "匯出錢包",
	"settings.backupInfo": "備份資訊",
	"settings.exportNoMnemonic": "（私鑰匯入錢包，無助記詞）\n\n私鑰:\n{pk}\n\n地址:\n{addr}",
	"settings.exportWithMnemonic": "助記詞:\n{mn}\n\n私鑰:\n{pk}\n\n地址:\n{addr}",
	"settings.lockTitle": "鎖定錢包",
	"settings.lockMessage": "鎖定後需重新輸入密碼才能使用。",
	"settings.lockNowAction": "立即鎖定",
	"settings.lockBrowserOnly": "僅關閉瀏覽器",
	"settings.lockMinutes": "{n} 分鐘",
	"settings.lock1h": "1 小時",
	"settings.lock8h": "8 小時",
	"settings.networkTitleLeading": "網路",
	"settings.networkTitleHighlight": "與 RPC",
	"settings.currentNetwork": "目前網路",
	"settings.currentNetworkRpc": "目前網路 RPC",
	"settings.saveRpc": "儲存 RPC",
	"settings.addCustomNetwork": "新增自訂網路",
	"settings.networkName": "名稱",
	"settings.walletChainOptional": "Wallet chain（可選）",
	"settings.probeRpc": "檢測 RPC",
	"settings.addAndSwitch": "新增並切換",
	"settings.noCustomNetwork": "無自訂網路",
	"settings.securityTitleLeading": "錢包",
	"settings.securityTitleHighlight": "安全",
	"settings.rememberUnlockDefault": "解鎖時預設勾選「保持解鎖」",
	"settings.currentLock": "目前：{label}",
	"settings.saveLockPrefs": "儲存鎖定設定",
	"settings.connectedTitleLeading": "已連線",
	"settings.noConnectedSites": "暫無已連線站點",
	"dapp.titleHighlight": "瀏覽器",
	"dapp.tabDiscover": "發現",
	"dapp.tabBrowser": "瀏覽",
	"dapp.tabHistory": "歷史",
	"dapp.vconsoleEnabled": "vConsole 已開啟",
	"dapp.vconsoleDisabled": "vConsole 已關閉",
	"dapp.vconsoleEnabledHint": "vConsole 已開啟（右下角綠鈕）",
	"dapp.vconsoleClose": "關閉 vConsole",
	"dapp.vconsoleOpen": "開啟 vConsole",
	"dapp.requestFailed": "DApp 請求失敗: {error}",
	"dapp.addTitle": "添加 DApp",
	"dapp.urlLabel": "URL",
	"dapp.addedToMy": "已添加到我的 DApp",
	"dapp.deleteBookmarkTitle": "刪除書籤",
	"dapp.deleteBookmarkMessage": "移除「{name}」？",
	"dapp.deleteConfirm": "刪除",
	"dapp.clearHistoryTitle": "清空歷史",
	"dapp.clearHistoryMessage": "確定清空全部瀏覽記錄？",
	"dapp.clearConfirm": "清空",
	"dapp.searchHint": "搜尋或輸入 DApp URL",
	"dapp.addDapp": "添加 DApp",
	"dapp.recommended": "推薦 DApp",
	"dapp.noRecommended": "暫無推薦",
	"dapp.myBookmarks": "我的收藏",
	"dapp.customAdd": "自訂添加",
	"dapp.noBookmarksYet": "還沒有收藏，可添加常用 DApp",
	"dapp.presetTag": "預設",
	"dapp.browsingHistory": "瀏覽記錄",
	"dapp.noBrowsingHistory": "暫無瀏覽記錄",
	"dapp.add": "添加",
	"dapp.goBack": "後退",
	"dapp.goForward": "前進",
	"dapp.collapseBookmarks": "收起書籤",
	"dapp.expandBookmarks": "展開書籤",
	"dapp.urlInputHint": "輸入或貼上 URL",
	"dapp.go": "前往",
	"dapp.bookmarkCurrentPage": "收藏目前頁面",
	"dapp.webViewInitializing": "初始化 WebView…",
	"common.retry": "重試",
	"wallet.myWallets": "我的錢包",
	"wallet.listCount": "{n} 個",
	"wallet.importNew": "匯入新錢包",
	"wallet.importLocalHint": "金鑰僅在本地加密儲存，請勿截圖或傳送給他人。",
	"wallet.nameOptional": "錢包名稱（選填）",
	"wallet.mnemonicHint": "12 / 24 個單詞，空格分隔",
	"wallet.privateKeyHint": "dgcprivkey1… 或 64 位 hex / Base64",
	"wallet.confirmImport": "確認匯入",
	"wallet.enterPrivateKey": "請輸入私鑰",
	"wallet.enterMnemonic": "請輸入助記詞",
	"wallet.added": "錢包已添加",
	"wallet.currentAccount": "目前帳戶",
	"wallet.currentBadge": "目前",
	"wallet.hdAccountCount": "{n} 個 HD 帳戶",
	"wallet.exportMnemonic": "匯出助記詞",
	"wallet.exportPrivateKey": "匯出私鑰",
	"wallet.exportPasswordTitle": "驗證安全密碼",
	"wallet.exportPasswordHint": "請輸入擴充密碼以繼續。請勿將金鑰洩露給任何人。",
	"wallet.exportPasswordEmpty": "請輸入擴充密碼",
	"wallet.exportWarning": "任何人取得後都能掌控你的資產。請勿截圖或傳送給他人。",
	"wallet.exportCopied": "已複製",
	"wallet.noMnemonicToExport": "此錢包由私鑰匯入，沒有助記詞",
	"wallet.exportVerify": "驗證",
	"stake.confirmClaimMessage": "收益將入賬到地址餘額（非零散 Coin）。\n預估收益 {amount} DGC",
	"stake.confirmRedeemMessage": "本金約 {amount} DGC 將入賬地址餘額。\n此操作不可撤銷。",
	"stake.redeemSuccess": "贖回成功",
	"stake.claimSuccess": "領取成功",
	"stake.networkStakeBadge": "全網質押",
	"stake.validatorPoolTotalCaption": "DGC 驗證者池總量",
	"stake.avgCommission": "平均佣金",
	"stake.lockedPrincipal": "鎖定本金",
	"stake.positionValueEst": "持倉市值（估）",
	"stake.lockedChip": "鎖定中",
	"stake.redeemableChip": "可贖回",
	"stake.unlockedChip": "已到期",
	"stake.statusActive": "活躍",
	"stake.statusPending": "待啟動",
	"stake.principalLabel": "本金",
	"trade.tabTrade": "交易",
	"trade.tabMarket": "行情",
	"trade.loadMarketFailed": "行情載入失敗，請稍後重試",
	"trade.enterQtyShort": "請輸入數量",
	"trade.orderBookUnavailable": "訂單簿暫不可用",
	"trade.noOrdersInBook": "暫無掛單",
	"trade.turnover24hData": "24h額(DATA)",
	"trade.kline": "K 線",
	"trade.noKlineData": "暫無 K 線資料",
	"trade.klineLegend": "MA(7) · 成交量",
	"trade.fillDetailLeading": "成交",
	"trade.fillDetailHighlight": "詳情",
	"trade.noOnchainDigest": "暫無鏈上 Digest",
	"trade.copyDigest": "複製 Digest",
	"trade.digestCopied": "Digest 已複製",
	"trade.onchainDetail": "鏈上詳情",
	"tx.sender": "發送方",
	"tx.checkpoint": "檢查點",
	"tx.gasBudget": "Gas 預算",
	"tx.computation": "計算",
	"tx.storage": "儲存",
	"tx.rebate": "返還",
	"tx.balanceChanges": "餘額變動",
	"tx.commands": "指令",
	"tx.digestCopied": "Digest 已複製",
	"tx.onchainDetail": "鏈上詳情",
	"receive.title": "收款",
	"receive.networkOnlyHint": "僅支援 DGC 網路資產",
	"receive.copyAddress": "複製地址",
	"receive.saveImage": "儲存圖片",
	"receive.shareText": "DGC 收款地址 {address}",
	"receive.imageFailed": "無法產生圖片",
	"receive.encodeFailed": "圖片編碼失敗",
	"receive.saveFailed": "儲存失敗: {error}",
	"recipient.needValidAddress": "請先輸入有效收款地址",
	"recipient.saveContact": "儲存聯絡人",
	"recipient.editLabel": "編輯備註",
	"recipient.labelName": "備註名稱",
	"recipient.labelHint": "例如：Alice、交易所",
	"recipient.savedOk": "已儲存聯絡人",
	"recipient.deleteContact": "刪除聯絡人",
	"recipient.removeRecent": "從歷史移除",
	"recipient.deleteContactMessage": "將刪除「{name}」的儲存記錄。",
	"recipient.removeRecentMessage": "將從最近使用中移除此地址。",
	"recipient.saveAsContact": "儲存為聯絡人",
	"recipient.noSaved": "暫無儲存的聯絡人",
	"recipient.noRecent": "暫無最近使用的地址",
	"recipient.hint": "發送成功後會自動加入最近使用；點「儲存」可新增備註聯絡人。",
	"recipient.contactsTab": "聯絡人{count}",
	"recipient.recentTab": "最近{count}",
	"common.paste": "貼上",
	"common.delete": "刪除",
	"common.new": "新建",
	"dapp.connectTitle": "連接 DApp",
	"dapp.connectFailed": "連接失敗",
	"dapp.walletLockedHint": "錢包已鎖定，請先解鎖後再連接",
	"dapp.signFailed": "簽名失敗",
	"dapp.signRequest": "簽名請求",
	"dapp.signAndExecute": "簽名並執行",
	"dapp.signOnly": "簽名",
	"mall.payLeading": "商城",
	"mall.payHighlight": "支付",
	"mall.amountDueData": "應付 DATA",
	"mall.orderNumber": "訂單號",
	"mall.merchantAddress": "收款地址",
	"mall.payerAddress": "付款地址",
	"mall.dataBalance": "DATA 餘額",
	"mall.confirmPay": "確認支付",
	"mall.walletLocked": "錢包未解鎖",
	"mall.returnAppFailed": "無法返回商城 App，請手動切換",
	"mall.paySuccess": "支付成功",
	"account.switchTitle": "切換錢包 / 帳戶",
	"account.count": "{n} 個帳戶",
	"account.hdAccounts": "HD 帳戶",
	"account.numbered": "帳戶 {n}",
	"account.inUse": "目前使用",
	"account.tapToSwitch": "點擊切換",
	"stake.principalMatured": "本金已到期，可贖回",
	"stake.lockHintWithActive": "啟動 epoch {activeEpoch} · 解鎖 epoch {unlockEpoch} · 還剩 {epochsLeft} epoch",
	"stake.lockHintUnlockOnly": "解鎖 epoch {unlockEpoch} · 還剩 {epochsLeft} epoch",
	"stake.poolTokenShare": "池代幣份額 {amount}",
	"stake.requestEpoch": "請求 epoch",
	"stake.claimRewardsBtn": "提取收益",
	"stake.redeemPrincipalBtn": "贖回本金",
	"stake.noValidatorsAvailable": "暫無可用驗證者",
	"stake.validatorFieldLabel": "驗證者",
	"stake.addressLabel": "地址",
	"stake.stakePool": "質押池",
	"stake.commission": "佣金",
	"stake.votingPower": "權重",
	"stake.validatorAddressCopied": "驗證者地址已複製",
	"mall.returnFailed": "無法返回商城 App，請手動切換",
	"mall.titleLeading": "商城",
	"mall.titleHighlight": "支付",
	"mall.amountDue": "應付 DATA",
	"bridge.usdtLockedSnack": "USDT 已鎖定 · 交易 {digest}",
	"bridge.dgcLockedSnack": "DGC 已鎖定 · Digest {digest}",
	"common.cannotOpenBrowser": "無法開啟瀏覽器",
	"tx.explorerLinkFailed": "無法開啟瀏覽器連結",
	"bridge.pageTitleHighlight": "跨鏈橋",
	"bridge.walletAccountLine": "{wallet} · {account}",
	"bridge.tabSwap": "兌換",
	"bridge.directionUsdtToDgc": "USDT → DGC",
	"bridge.ethRelayerHint": "提現到 ETH 由 Relayer 在 DGC 鎖定後自動結算。",
	"bridge.fromBsc": "From（BSC USDT）",
	"bridge.fromDgc": "From（DGC DATA）",
	"bridge.evmRecipientLabel": "{chain} 收款地址",
	"bridge.lockUsdtToDgc": "鎖定 USDT → DGC",
	"bridge.lockDgcToTarget": "鎖定 DGC → {target}",
	"bridge.myBridgeRecords": "我的跨鏈記錄",
	"bridge.noLocalRecords": "暫無本地跨鏈記錄",
	"bridge.onChainLocksAccount": "鏈上鎖定（本帳戶）",
	"bridge.noOnChainLockEvents": "暫無鏈上鎖定事件",
	"bridge.networkRecentLocks": "全網近期鎖定",
	"connect.failed": "連接失敗",
	"connect.lockedHint": "錢包已鎖定，請先解鎖後再連接",
	"sign.failed": "簽名失敗",
	"sign.signAndExecute": "簽名並執行",
	"sign.signOnly": "簽名",
	"recipient.noSavedContacts": "暫無儲存的聯絡人",
	"recipient.noRecentAddresses": "暫無最近使用的地址",
	"recipient.contacts": "聯絡人",
	"recipient.recent": "最近",
	"receive.dgcOnly": "僅支援 DGC 網路資產",
	"bridge.statusConfirmed": "已確認",
	"bridge.introInboundTitle": "充值 USDT → DATA",
	"bridge.introInboundBody": "在 BSC 鎖定官方 USDT；Relayer 按 1:1 在 DGC 側發放 DATA。",
	"bridge.introOutboundEthBody": "在 DGC 鎖定 DATA；Relayer 在以太坊發放 USDT。",
	"bridge.introOutboundBscBody": "在 DGC 鎖定 DATA；Relayer 在 BNB 鏈發放 USDT。",
	"bridge.webVersion": "網頁版",
	"bridge.inboundEscrowUnavailable": "BSC Escrow 不可用，請檢查跨鏈配置。",
	"bridge.balanceWithAmount": "餘額 {amount}",
	"bridge.exchangeRate": "兌換比率",
	"bridge.exchangeRateValue": "1 DATA ≈ {rate} USDT",
	"bridge.bscInbound": "BSC 入金",
	"bridge.ethOutbound": "ETH 出金",
	"bridge.statusReady": "就緒",
	"bridge.txIdLabel": "交易 ID",
	"bridge.txIdCopied": "交易 ID 已複製",
	"bridge.copyTxId": "複製交易 ID",
	"trade.unlockToViewOrders": "解鎖錢包後查看委託",
	"trade.partialQtyLine": "已成交 {filled} / {total}",
	"trade.orderHistoryLine": "{side} · {qty} @ {price}",
	"trade.fillQtyLine": "{qty} DGC",
	"trade.estimateSpendAmount": "預計消耗 {amount} DATA",
	"trade.estimateReceiveAmount": "預計收到 {amount} DATA",
	"receive.imageRenderFailed": "無法產生圖片",
	"receive.imageEncodeFailed": "圖片編碼失敗",
	"recipient.validRequired": "請先輸入有效收款地址",
	"recipient.contactSaved": "已儲存聯絡人",
	"recipient.removeFromHistory": "從最近中移除",
	"recipient.deleteSavedMessage": "刪除聯絡人 {name}？",
	"recipient.hintEmpty": "貼上地址或選擇聯絡人",
	"tx.computationCost": "計算",
	"tx.storageCost": "儲存",
	"tx.storageRebate": "返還",
	"tx.onChainDetail": "鏈上詳情",
	"tx.noDigest": "暫無鏈上 Digest",
	"tx.copyDigest": "複製 Digest",
	"trade.marketLoadFailed": "行情載入失敗，請稍後重試",
	"bridge.tabRecords": "記錄",
	"bridge.directionDgcWithdraw": "DGC 提現",
	"bridge.introOutboundTitle": "提現 DATA → EVM",
	"bridge.statusNotConfigured": "未配置",
	"wallet.shellSubtitle": "地址餘額 · 質押 · 自訂網路",
	"wallet.totalBalanceLine": "總餘額 {total} DGC · {chain}",
	"trade.clobToken": "CLOB 代幣",
	"trade.openOrderMeta": "{time} · 委託 {qty} DGC · 剩餘 {remaining} DGC",
	"trade.orderTimeQtyLine": "{time} · 數量 {qty}",
	"trade.fillTimeQtyLine": "{time} · 數量 {qty} DGC",
	"qr.title": "掃碼",
	"qr.flashlight": "閃光燈",
	"qr.unrecognized": "無法識別：請掃商城支付碼或 DGC 收款地址",
	"qr.hint": "支援商城支付碼（固定 DATA 金額）或 DGC 收款地址",
	"home.multiChainAssets": "多鏈資產",
	"home.refreshBalances": "重新整理餘額",
	"home.suiMainnet": "Sui 主網",
	"home.rpcUnavailable": "RPC 不可用",
	"wallet.addressLabel": "錢包地址",
	"wallet.looseBalance": "零散",
	"stake.poolBalanceLine": "池餘額 {balance} DGC",
	"depth.liveBook": "即時盤口",
	"depth.noData": "暫無盤口數據",
	"sign.gasEstimating": "Gas 估算中…",
	"common.processing": "處理中…",
	"common.copied": "已複製",
	"common.copyFailed": "複製失敗",
	"common.loadFailed": "載入失敗",
	"common.deleted": "已刪除",
	"common.holding": "持有",
	"common.summary": "概要",
	"common.type": "類型",
	"wallet.mergeToAddressBalance": "合併到地址餘額",
	"wallet.reloadExtensionMultiToken": "擴充後台未更新：請在 chrome://extensions 重新載入 DGC Wallet 以使用多代幣轉帳",
	"wallet.selectToken": "請選擇代幣",
	"wallet.networkSwitched": "已切換網路",
	"wallet.unlocked": "已解鎖",
	"wallet.lockedToast": "已鎖定",
	"wallet.created": "錢包已建立",
	"wallet.imported": "錢包已匯入",
	"wallet.accountSwitched": "已切換帳戶",
	"wallet.accountRenamed": "已重新命名",
	"wallet.accountDeleted": "已刪除帳戶",
	"wallet.accountAdded": "已新增帳戶",
	"wallet.accountNamePrompt": "帳戶名稱",
	"wallet.deleteAccountPasswordPrompt": "刪除帳戶需驗證擴充密碼",
	"wallet.tokenAdded": "已新增代幣",
	"wallet.configSaved": "市場設定已儲存",
	"wallet.backupMnemonicToast": "請備份助記詞",
	"wallet.regenerateMnemonic": "請重新產生助記詞",
	"wallet.lockConfirmExt": "確定鎖定擴充錢包？鏈上質押本金鎖不受影響。",
	"wallet.decryptedWarn": "已解密，請勿截圖或分享",
	"wallet.mnemonicCopied": "助記詞已複製",
	"wallet.exportNoMnemonic": "（自私鑰匯入的舊錢包無助記詞記錄）",
	"wallet.consolidateMerged": "已合併 {amount} DGC 到地址餘額",
	"wallet.looseCoinHintExt": "有鬆散 Coin（{loose}），地址餘額主顯示為 0。點下方合併到 P-UX 地址餘額。",
	"wallet.looseApprox": "約 {amount} DGC",
	"wallet.looseCoinCount": "{count} 個 Coin",
	"wallet.unlockToShow": "解鎖後顯示",
	"wallet.chainIdShort": "鏈 {id}…",
	"wallet.chainIdEmpty": "鏈 ID —",
	"wallet.connectAllowed": "已允許連接",
	"wallet.signed": "已簽名",
	"wallet.onchainReportCopied": "已複製鏈上詳情",
	"trade.anchor": "錨定",
	"trade.priceHighToLow": "價高→低",
	"trade.priceLowToHigh": "價低→高",
	"trade.bidsDepthAria": "買盤五檔",
	"trade.asksDepthAria": "賣盤五檔",
	"trade.marketConfig": "市場設定",
	"trade.saveMarketConfig": "儲存市場設定",
	"trade.clickRefreshToLoad": "點擊右上角重新整理載入",
	"trade.debugSource": "成交查詢原始資料",
	"trade.copyJson": "複製 JSON",
	"trade.holdings": "持有",
	"trade.fillLimitTitle": "點擊填入限價 {price} DATA",
	"trade.noMyTrades": "暫無我的成交",
	"trade.noMarketTradesRefresh": "暫無市場成交 · 點重新整理載入",
	"trade.pushHubLive": "Push Hub 即時推送 · {url}",
	"trade.pushHubDisconnected": "Push Hub 未連線：{err}（{url}）",
	"trade.pushHubConnecting": "Push Hub 連線中… {url}",
	"trade.pushHubDepth": "Push Hub 即時五檔（買 {bids} / 賣 {asks} 檔）",
	"trade.pushHubOfflineWs": "Push Hub 未連線 — 盤口與成交走 WS pub",
	"trade.tradesQueryFailed": "成交查詢失敗：{err}",
	"trade.debugNoResponse": "background 未回應 getClobTradesDebug",
	"trade.debugNoResponseHint": "getClobTradesDebug 無回應",
	"trade.buildMismatch": "⚠ background 版本 {bg} ≠ popup {popup} · 請到 chrome://extensions 重新載入擴充",
	"trade.debugSummaryRpc": "RPC {rpc} · 原始 RPC {rawRpc} · SDK {sdk} · 解析 {parsed} · build {build}",
	"trade.debugParsed": "解析 {count} 筆 · build {build}",
	"trade.debugNoJson": "build {build} · 無 tradeDebugJson",
	"trade.pushHubTradesFailed": "Push Hub 成交載入失敗：{err}",
	"trade.orderBookUnreachableWithTrades": "OrderBook 不可達 · Push Hub {count} 筆成交",
	"trade.orderBookUnreachableRpc": "OrderBook 在 RPC 上不可達（檢查 registry/orderbook 設定）",
	"trade.pushHubTradeCounts": "Push Hub · {market} 筆市場成交 · 我的 {mine} 筆",
	"trade.marketNotConfigured": "未設定市場 · verify 後重新載入擴充",
	"tx.timeUnknown": "時間未知",
	"tx.detailTitle": "交易詳情",
	"tx.paid": "實付",
	"tx.noBalanceChanges": "無餘額變動記錄",
	"tx.digestTitle": "交易 Digest",
	"tx.direction.cancel": "撤單",
	"tx.direction.buy": "買入",
	"tx.direction.sell": "賣出",
	"settings.mainnetRpc": "主網 RPC",
	"settings.dgcMainnetProd": "DGC 主網（生產）",
	"settings.customNodePlaceholder": "自訂節點",
	"settings.exportDesc": "匯出前需驗證擴充密碼。請勿洩露助記詞與私鑰。",
	"settings.showExport": "顯示匯出內容",
	"settings.mnemonicShort": "助記詞",
	"settings.privateKeySui": "私鑰 (Sui Bech32)",
	"settings.copyMnemonic": "複製助記詞",
	"settings.securityNoticeTitle": "安全提示",
	"settings.securityNoticeBody": "助記詞與私鑰經密碼加密存於本機；鎖定後記憶體金鑰會清除。",
	"settings.lockBrowserRecommend": "僅關閉瀏覽器 / 手動鎖定（建議）",
	"settings.lock15minIdle": "15 分鐘無操作後鎖定",
	"settings.currentChainId": "目前鏈 ID: {id}",
	"settings.probeFirst": "請先通過 RPC 檢測",
	"settings.networkAdded": "網路已新增",
	"settings.rpcReachableShort": "可達 · chain id: {chain}",
	"stake.onchainReportSummary": "鏈上詳情（與 query_cpc_account_onchain 腳本一致）",
	"stake.onchainReportHint": "與終端 <code>node scripts/query_cpc_account_onchain.mjs --owner …</code> 輸出對比；點「重新整理」質押列表時一併更新。",
	"stake.reloadDetailsOnly": "僅重新整理詳情",
	"stake.expandToLoad": "展開後自動載入…",
	"stake.selectedLine": "已選: {name} ({address})",
	"stake.poolIn": "池內 {amount} DGC",
	"stake.lockEnded": "本金鎖已結束",
	"stake.claimAnytimeTitle": "無需等待本金鎖到期；僅提取獎勵部分",
	"stake.claimConfirmExt": "提取質押收益？\n收益將記入地址餘額（P-UX，不產生鬆散 Coin）；FungibleStakedSui 的池代幣 value 會減少，鎖定本金仍在池內。",
	"stake.redeemConfirmExt": "確認贖回本金 {amount} DGC？\n需已過 lock_until epoch（{epoch}）。",
	"stake.redeemAfterEpoch": "本金需至 epoch {epoch} 才可贖回（還剩 {left} epoch）",
	"stake.currentEpochSuffix": "{hint} · 目前 epoch {epoch}",
	"stake.reloadBackground": "載入失敗: 擴充後台未更新。請開啟 chrome://extensions ，對 DGC Wallet 點「重新載入」，再開啟本頁重試。",
	"stake.loadFailedWithMsg": "載入失敗: {msg}",
	"stake.commissionLine": "佣金 {rate}",
	"stake.votingPowerLine": "權重 {power}",
	"stake.principalLockLabel": "本金鎖",
	"sign.submitChain": "確認後簽名並提交到 DGC 鏈",
	"sign.signOnlyDesc": "確認後僅簽名（由網站自行提交）",
	"sign.gasOnConfirm": "確認時估算",
	"sign.senderFilledByWallet": "（由錢包補全 sender）",
	"sign.userRejected": "使用者拒絕簽名",
	"connect.siteDisconnected": "已中斷網站連線",
	"connect.userRejected": "使用者拒絕連線",
	"dapp.tagOfficial": "官方",
	"dapp.tagRecommended": "推薦",
	"dapp.discover.explorerDesc": "區塊瀏覽器 · 查交易與物件",
	"dapp.discover.shopName": "GlobalData 商城",
	"dapp.discover.shopDesc": "Data Global 跨境商城",
	"dapp.openExplorer": "打開 DGC Explorer",
	"dapp.quickLinks": "快捷入口",
	"dapp.nameLabel": "名稱",
	"dapp.urlEmpty": "URL 不能為空",
	"dapp.urlInvalid": "URL 格式無效",
	"dapp.urlAlreadyBookmarked": "該 URL 已在收藏中",
	"dapp.preconnectSkipped": "DGC 預連線跳過: {error}",
	"dapp.scanQr": "掃碼",
	"bridge.historyTitle": "跨鏈交易歷史",
	"bridge.historySubtitle": "目前地址的雙向記錄：鎖 DATA 換 USDT，鎖 USDT 換 DATA",
	"bridge.colDirection": "方向",
	"bridge.dirDataToUsdt": "DATA → USDT",
	"bridge.dirUsdtToData": "USDT → DATA",
	"bridge.historyNeedWallet": "請先連接 DGC Wallet，查看目前地址的跨鏈記錄",
	"bridge.historyOpen": "我的記錄",
	"bridge.historyBackToBridge": "返回跨鏈橋",
	"bridge.historyAutoRefresh": "自動刷新中",
	"bridge.colTime": "時間",
	"bridge.historyAddress": "地址",
};

const en: MessageCatalog = {
	"common.language": "Language",
	"common.network": "Network",
	"common.wallet": "Wallet",
	"common.cancel": "Cancel",
	"common.confirm": "Confirm",
	"common.refresh": "Refresh",
	"common.loading": "Loading…",
	"common.save": "Save",
	"common.lock": "Lock",
	"common.close": "Close",
	"common.back": "Back",
	"common.copy": "Copy",
	"common.error": "Something went wrong",
	"common.spot": "Spot",
	"common.buy": "Buy",
	"common.sell": "Sell",
	"common.price": "Price",
	"common.quantity": "Quantity",
	"common.available": "Available",
	"common.settings": "Settings",
	"common.detect": "Probe",
	"nav.dex": "DEX",
	"nav.bridge": "Bridge",
	"nav.stake": "Stake",
	"nav.genesis": "Genesis",
	"nav.apps": "Apps",
	"nav.assets": "Assets",
	"nav.send": "Send",
	"nav.trade": "Trade",
	"nav.network": "Network",
	"nav.dapp": "DApp",
	"nav.crossChain": "Bridge",
	"nav.market": "Market",
	"explorer.title": "DGC Explorer",
	"explorer.tagline": "Explorer",
	"wallet.title": "DGC Wallet",
	"wallet.tagline": "Mainnet · address balance · staking",
	"wallet.welcome": "Welcome to DGC Wallet",
	"wallet.welcomeDesc": "Set an extension password to protect your wallet, similar to MetaMask.",
	"wallet.unlock": "Unlock wallet",
	"wallet.unlockDesc": "Enter your extension password to use the wallet.",
	"wallet.password": "Extension password",
	"wallet.passwordConfirm": "Confirm password",
	"wallet.passwordPlaceholder": "At least 8 characters",
	"wallet.rememberUnlock": "Stay unlocked",
	"wallet.create": "Create wallet",
	"wallet.import": "Import wallet",
	"wallet.generateMnemonic": "Generate mnemonic",
	"wallet.mnemonic": "Mnemonic (12 / 24 words)",
	"wallet.privateKey": "Private key",
	"wallet.backupTitle": "Back up mnemonic",
	"wallet.backupDesc": "Write it down somewhere safe. Lost keys cannot be recovered.",
	"wallet.backupAck": "I have safely backed up my mnemonic",
	"wallet.backupDone": "Finish setup",
	"wallet.addressBalance": "Address balance",
	"wallet.totalBalance": "Total balance",
	"wallet.lockNow": "Lock wallet now",
	"wallet.export": "Export wallet",
	"wallet.security": "Wallet security",
	"wallet.autoLock": "Auto-lock",
	"wallet.connectedSites": "Connected sites",
	"wallet.txHistory": "Transaction history",
	"wallet.noTx": "No transactions yet",
	"wallet.loadingWallet": "Loading wallet…",
	"trade.pair": "DGC / DATA",
	"trade.buyDgc": "Buy DGC",
	"trade.sellDgc": "Sell DGC",
	"trade.limitPrice": "Limit price",
	"trade.quantity": "Quantity",
	"trade.estimateSpend": "Est. cost — DATA",
	"trade.estimateReceive": "Est. receive — DATA (after fees)",
	"trade.bids": "Bids",
	"trade.asks": "Asks",
	"trade.marketTrades": "Market trades",
	"trade.myTrades": "My trades",
	"trade.openOrders": "Open orders",
	"trade.priceData": "Price (DATA)",
	"trade.qtyDgc": "Qty (DGC)",
	"trade.lastPrice": "Last price",
	"trade.loadingMarket": "Loading market…",
	"trade.refresh": "Refresh market",
	"sign.request": "Signature request",
	"sign.approve": "Approve & sign",
	"sign.reject": "Reject",
	"connect.request": "Connection request",
	"connect.approve": "Allow connection",
	"connect.reject": "Reject",
	"connect.desc": "This site can see your DGC address and request signatures. Revoke anytime under Network → Connected sites.",
	"language.title": "Language",
	"language.subtitle": "Choose display language. Default is English.",
	"settings.networkRpc": "Network & RPC",
	"settings.walletSecurity": "Wallet security",
	"settings.walletManage": "Wallet management",
	"settings.connectedDapps": "Connected DApps",
	"common.time": "Time",
	"common.side": "Side",
	"common.action": "Action",
	"common.status": "Status",
	"common.account": "Account",
	"common.amount": "Amount",
	"common.max": "Max",
	"common.empty": "None",
	"common.submitting": "Submitting…",
	"common.connectWallet": "Connect wallet",
	"common.disconnect": "Disconnect",
	"common.connecting": "Connecting…",
	"common.loadMore": "Load more",
	"common.all": "All",
	"common.balance": "Balance",
	"common.spread": "Spread",
	"trade.orderBook": "Order book",
	"trade.recentTrades": "Recent trades",
	"trade.orderHistory": "Order history",
	"trade.tradeHistory": "Trade history",
	"trade.bestBid": "Best bid",
	"trade.bestAsk": "Best ask",
	"trade.change24h": "24h change",
	"trade.volume24h": "24h volume",
	"trade.turnover24h": "24h turnover",
	"trade.trades24h": "24h trades",
	"trade.noTrades": "No trades yet",
	"trade.cancelOrder": "Cancel",
	"trade.cancelling": "Cancelling…",
	"trade.noOpenOrders": "No open orders",
	"trade.noOrderHistory": "No order history",
	"trade.connectToViewOrders": "Connect wallet to view open orders",
	"trade.statusOpen": "Open",
	"trade.statusFilled": "Filled",
	"trade.statusCancelled": "Cancelled",
	"trade.statusPartial": "Partial",
	"trade.invalidPrice": "Invalid limit price",
	"trade.enterQty": "Enter DGC quantity",
	"trade.qtyPositive": "Quantity must be a positive integer",
	"trade.bidSubmitted": "Buy order submitted",
	"trade.askSubmitted": "Sell order submitted",
	"trade.cancelSubmitted": "Cancel submitted",
	"trade.remaining": "Remaining",
	"trade.orderId": "Order ID",
	"trade.taker": "Taker",
	"trade.noClob": "CLOB not configured",
	"wallet.connect": "Connect DGC Wallet",
	"wallet.notDetected": "DGC Wallet not detected",
	"wallet.downloadExt": "Download DGC Wallet extension",
	"wallet.downloadApp": "Download DGC Wallet",
	"wallet.appsCenter": "Apps center",
	"wallet.wrongWallet": "Please connect DGC Wallet",
	"wallet.disconnecting": "Disconnecting…",
	"wallet.viewBalance": "Connect DGC Wallet to view balance",
	"send.recipient": "Recipient",
	"send.confirm": "Confirm send",
	"send.token": "Token",
	"stake.selectValidator": "Select a validator",
	"stake.amount": "Stake amount",
	"stake.myStakes": "My stakes",
	"stake.stakeDgc": "Stake DGC",
	"stake.noStakes": "No stake records",
	"stake.refreshValidators": "Refresh",
	"trade.orderQty": "Order qty",
	"trade.noTradeHistory": "No trade history",
	"trade.remainingShort": "left",
	"trade.clickFillPrice": "Click to fill limit price",
	"trade.klineWindow": "Chart window",
	"trade.open24h": "24h open",
	"trade.high24h": "24h high",
	"trade.low24h": "24h low",
	"trade.volume24hDgc": "24h vol (DGC)",
	"trade.txExpired": "Transaction expired, please retry",
	"trade.balanceLabel": "{symbol} balance",
	"wallet.connectFirst": "Please connect DGC Wallet first",
	"wallet.notFoundAlert": "DGC Wallet extension not found. Install and enable it, then refresh this page.",
	"wallet.installHint": "Install the Chrome extension, or open this page in the DGC Wallet app browser.",
	"wallet.siteEnabledHint": "Current site {origin}. After install, enable the extension in chrome://extensions and refresh.",
	"wallet.notDetectedExt": "DGC Wallet extension not detected",
	"send.success": "Sent successfully",
	"send.availableDash": "Available —",
	"send.uxHint": "Prefers address balance; gas is paid from DGC address balance",
	"send.addCustomToken": "Add custom CLOB token",
	"send.symbol": "Symbol",
	"send.typeTag": "TypeTag",
	"send.decimals": "Decimals",
	"send.saveToList": "Save to list",
	"stake.submitted": "Stake submitted",
	"stake.success": "Stake successful",
	"stake.confirmTitle": "Confirm stake",
	"stake.confirmAction": "Confirm stake",
	"stake.selectValidatorLabel": "Select validator",
	"stake.positions": "Stake positions",
	"stake.noPositions": "No stake positions",
	"stake.lockHintShort": "Principal locks for 180 epochs. Rewards can be claimed anytime; redeem principal after unlock.",
	"stake.newStake": "New stake",
	"stake.enterAmount": "Enter stake amount",
	"stake.confirmMessage": "Stake {amount} DGC to the selected validator.\nPrincipal locks for 180 epochs; rewards can be claimed anytime.",
	"stake.claimRewards": "Claim stake rewards",
	"stake.redeemPrincipal": "Redeem stake principal",
	"stake.noPositionCount": "No positions",
	"stake.positionCount": "{count} positions",
	"apps.title": "Apps",
	"apps.titleSuffix": "/ Ecosystem",
	"apps.subtitle": "One place for DGC apps: Global Shop, RWAX Super App, DGC Wallet, and on-chain tools.",
	"apps.mobileSubtitle": "Global Shop · RWAX · DGC Wallet",
	"apps.viewAccount": "View my account →",
	"apps.featured": "Featured apps",
	"apps.scanDownload": "Scan to download",
	"apps.scanDownloadApk": "Scan to download APK",
	"apps.scanDownloadRwax": "Scan to download RWAX",
	"apps.mirrorDownload": "Mirror download",
	"apps.chromeExt": "Chrome extension",
	"apps.globalShop": "Global Shop",
	"apps.globalShopDesc": "Data Global cross-border commerce with multi-language and multi-currency support. Browse fashion, bags, footwear and brands; pay with DGC Wallet.",
	"apps.openGlobalShop": "Open Global Shop",
	"apps.tagEcommerce": "Commerce",
	"apps.globalShopApp": "Global Shop APP",
	"apps.globalShopAppDesc": "Mobile Global Shop client — shop, track orders, and catch deals anytime. Scan the QR to install.",
	"apps.downloadGlobalShopApp": "Download Global Shop APP",
	"apps.tagMobile": "Mobile",
	"apps.walletDesc": "Native DGC wallet: manage assets and sign DApp transactions. Install the Android APK via download, mirror, or QR; Chrome extension also available.",
	"apps.tagWallet": "Wallet",
	"apps.rwaxDesc": "RWAX Super App: multi-chain wallet, social, DApp browser and official DGC browser. Import dgcprivkey / mnemonic; defaults to the DGC ecosystem. Scan or tap to install Android.",
	"apps.downloadRwax": "Download RWAX",
	"apps.tagSuperApp": "Super App",
	"apps.onchainShortcuts": "On-chain shortcuts",
	"apps.dexTrade": "DEX trading",
	"apps.dexTradeDesc": "Spot trade DGC",
	"apps.bridge": "Bridge",
	"apps.bridgeDesc": "BNB USDT ↔ DATA (1:1)",
	"apps.stake": "Stake",
	"apps.stakeDesc": "Delegate to validators and earn",
	"apps.explorer": "Block explorer",
	"apps.explorerDesc": "Look up txs and addresses",
	"apps.myStatus": "My on-chain status",
	"apps.totalBalance": "Total balance",
	"apps.viewAddress": "View address",
	"apps.connectToSeeBalance": "Connect DGC Wallet to see balance",
	"stake.pageTitle": "Stake",
	"stake.pageSubtitle": "Delegate DGC to validators, secure the network, and earn rewards. Amounts are shown in DGC (1 DGC = 10⁹ MIST).",
	"stake.epochProgress": "Epoch progress",
	"stake.currentEpoch": "Current epoch",
	"stake.epochCycleAbout": "Cycle ~ {duration}",
	"stake.latestCheckpoint": "Latest checkpoint",
	"stake.checkpointHint": "On-chain progress reference",
	"stake.connectHint": "Connect DGC Wallet in the sidebar to view balances, positions, and stake.",
	"stake.staked": "Staked",
	"stake.viewAccount": "View account details",
	"stake.delegationDetails": "Delegation details",
	"stake.tipGas": "• Staking and gas use native DGC; keep a small balance for fees.",
	"stake.tipUnlock": "• Unstaking waits for the epoch unlock period (see on-chain lock_until_epoch).",
	"stake.tipLeaderboard": "• Validator pool rankings are on the home Leaderboards; ",
	"stake.validatorsNetwork": "Validator network",
	"stake.networkStake": "Network {symbol} stake",
	"stake.networkStakeTip": "Total DGC staked by validators and delegators",
	"stake.avgDailyYield": "Avg daily yield",
	"stake.avgDailyYieldTip": "Validator APY ÷ 365; estimated from subsidy params when samples are thin",
	"stake.lastEpochReward": "Last epoch rewards",
	"stake.lastEpochRewardTip": "Sum of staking rewards across validator pools last epoch",
	"stake.activeValidators": "Active validators",
	"stake.activeValidatorsTip": "Active validators in the current epoch",
	"stake.validatorMap": "Validator map",
	"stake.mapLoading": "Loading map…",
	"stake.allValidators": "All validators",
	"stake.validatorsLoadFailed": "Failed to load validator data",
	"stake.colName": "Name",
	"stake.colStake": "Stake",
	"stake.colDaily": "Daily",
	"stake.epochLoading": "Loading epoch progress…",
	"stake.epochProgressOf": "Epoch {epoch} progress",
	"stake.remaining": "remaining",
	"stake.lockProgress": "Principal unlock progress",
	"stake.noDelegations": "No delegations yet",
	"stake.fungibleCert": "Fungible certificate",
	"stake.claimable": "Claimable",
	"stake.activeEpoch": "Active epoch",
	"stake.unlockEpoch": "Unlock epoch",
	"stake.epochsLeft": "Epochs left",
	"stake.lockPeriod": "Lock period",
	"stake.claimableRewards": "Claimable rewards",
	"stake.principalUnlocked": "Principal unlocked — redeemable",
	"stake.redeemAfterUnlock": "Redeem after unlock (Epoch {epoch})",
	"genesis.title": "Genesis issuance",
	"genesis.subtitle": "Public DGC genesis allocations for community oversight. Total {total} (main coin {symbol}). Tap an address to view on-chain balance.",
	"genesis.mobileSubtitle": "Genesis allocations",
	"genesis.supplyCheck": "Supply check",
	"genesis.totalSupply": "Genesis total",
	"genesis.tableSum": "Allocation sum",
	"genesis.equalsTotal": "Matches total",
	"genesis.notEqualsTotal": "Does not match total",
	"genesis.liveValidators": "Live active validators",
	"genesis.reading": "Loading…",
	"genesis.unavailable": "Unavailable",
	"genesis.expected": "expected {count}",
	"genesis.compareConfig": "Compared with genesis config (RPC connected)",
	"genesis.allocationDetail": "Allocation details",
	"genesis.allocationIntro": "“Genesis allocation” is the planned amount, not a live balance. Open an address to see actual holdings. The four ",
	"genesis.linear10yStrong": "linear 10-year",
	"genesis.allocationIntro2": " pools are loaded into on-chain ",
	"genesis.allocationIntro3": " after bootstrap and claim linearly over time; platform ecosystem has no vesting. “Stake lock” is validator self-stake.",
	"genesis.colPurpose": "Purpose",
	"genesis.colAmount": "Genesis allocation (DGC)",
	"genesis.colPct": "Share",
	"genesis.colVesting": "Unlock / lock rules",
	"genesis.colAddress": "Pool address (on-chain balance)",
	"genesis.seeStakePage": "See validators / stake page",
	"genesis.pendingSync": "Pending sync",
	"genesis.total": "Total",
	"genesis.footerHint": "Pool balances may still be Coin objects. After bootstrap-vesting, open the pool address page to view claimable amounts, progress, history, and claim with the matching wallet.",
	"genesis.poolAddressPage": "pool address page",
	"genesis.vesting.linear_10y": "Linear 10 years",
	"genesis.vesting.none": "No lock (circulating)",
	"genesis.vesting.system": "System pool",
	"genesis.vesting.self_stake": "Stake lock {epochs} epochs",
	"genesis.hint.linear_10y": "On-chain vesting::linear::Wallet; claim over time. Open the pool address page for claimable amount. Before bootstrap it may still be Coins on the pool address.",
	"genesis.hint.none": "No on-chain vesting; transferable per ops rules",
	"genesis.hint.system": "Paid via epoch subsidy params, not a normal address balance",
	"genesis.hint.self_stake": "In the validator stake pool; subject to unlock epochs",
	"genesis.pool.community": "Community",
	"genesis.pool.communityNote": "Linear 10 years; bootstrap loads Wallet after genesis mint to pool",
	"genesis.pool.foundation": "Foundation",
	"genesis.pool.foundationNote": "Linear 10-year on-chain lock",
	"genesis.pool.tech_support": "Tech support",
	"genesis.pool.tech_supportNote": "Linear 10-year on-chain lock",
	"genesis.pool.platform_ecosystem": "Platform ecosystem",
	"genesis.pool.platform_ecosystemNote": "No vesting; ops / ecosystem float (multisig)",
	"genesis.pool.user_rewards": "User rewards",
	"genesis.pool.user_rewardsNote": "Linear 10-year on-chain lock",
	"genesis.pool.validators": "Genesis validator self-stake",
	"genesis.pool.validatorsNote": "{count} validators × {each} DGC; principal lock {epochs} epochs",
	"genesis.pool.stake_subsidy_fund": "Stake subsidy fund",
	"genesis.pool.stake_subsidy_fundNote": "System subsidy pool (genesis to 0x0)",
	"bridge.subtitle": "Bridged asset is DATA (not main coin DGC), 1:1. BSC side is official Binance-Peg USDT; DGC side is DATA (DGC Wallet). Relayer settles automatically.",
	"bridge.mobileSubtitle": "DATA ↔ BNB USDT · 1:1",
	"bridge.buyTitle": "Buy DATA with BNB USDT",
	"bridge.sellTitle": "Sell DATA for BNB USDT",
	"bridge.balance": "Balance",
	"bridge.toReceiveData": "To (DATA estimated)",
	"bridge.toReceiveUsdt": "To (BNB USDT estimated)",
	"bridge.fromLockData": "From (DATA lock)",
	"bridge.cpcRecipient": "DGC chain recipient",
	"bridge.bscRecipient": "BNB USDT recipient",
	"bridge.recipientPlaceholder": "Enter 0x… or D… recipient address",
	"bridge.currentWallet": "Current wallet",
	"bridge.connectBscFirst": "Connect BSC wallet first",
	"bridge.connectCpcFirst": "Connect DGC Wallet first",
	"bridge.switchMainnet": "Switch to BSC mainnet",
	"bridge.escrowMissing": "Escrow contract not deployed",
	"bridge.lockUsdtToData": "Lock {amount} {usdt} → DATA",
	"bridge.lockDataToUsdt": "Lock {amount} {data} → {usdt}",
	"bridge.bscBusy": "BSC contract interaction…",
	"bridge.cpcBusy": "Submitting transaction…",
	"bridge.dataBridgeStatus": "DATA bridge status",
	"bridge.treasuryLocked": "Treasury locked",
	"bridge.gatewayRpc": "Gateway RPC",
	"bridge.detecting": "Checking",
	"bridge.bnbUsdtStatus": "BNB / USDT status",
	"bridge.targetNetwork": "Target network",
	"bridge.usdtContract": "BNB USDT contract",
	"bridge.escrow": "Escrow",
	"bridge.configMissing": "Not configured",
	"bridge.nodeStatus": "Node status",
	"bridge.networkMatch": "Network matched",
	"bridge.switchNetwork": "Switch network",
	"bridge.notConnected": "Not connected",
	"bridge.recentLocks": "Recent DATA locks",
	"bridge.forUsdt": "→ for BNB USDT",
	"bridge.noLocks": "No bridge lock records on this network",
	"bridge.colAmount": "Locked amount",
	"bridge.colEstimate": "Est. receive",
	"bridge.colRecipient": "Recipient",
	"bridge.colAction": "Action",
	"bridge.details": "Details →",
	"bridge.showRecent5": "Showing latest 5",
	"bridge.refreshStatus": "Refresh status",
	"bridge.backHome": "← Back home",
	"bridge.noConfig": "Bridge config not found. Deploy on-chain Bridge, then run ./cpc.sh stack start or ./cpc.sh client fetch-stack-config.",
	"bridge.connectMetaMask": "Connect MetaMask",
	"bridge.installEvm": "Install MetaMask or another EVM wallet",
	"bridge.connectBsc": "Connect BSC wallet",
	"bridge.noEvm": "No EVM wallet detected",
	"bridge.disconnect": "Disconnect",
	"bridge.ok": "OK",
	"bridge.fail": "Error",
	"bridge.processing": "Processing…",
	"bridge.useCurrent": "Use current",
	"bridge.needBscRecipient": "Enter or connect a BSC recipient address",
	"bridge.needCpcRecipient": "Enter a DGC chain recipient address",
	"bridge.escrowDeployHint": "Escrow not configured: deploy CpcUsdtEscrow on BSC mainnet first",
	"bridge.mainnetTokenOnly": "Current config uses BSC mainnet tokens; uncheck testnet",
	"bridge.lockedDataOk": "Locked {amount} {data}; relayer will pay ~{usdtAmount} {usdt} to {recipient}…",
	"bridge.lockedUsdtOk": "Locked {amount} {usdt} → DATA (BSC tx {tx}…)",
	"bridge.noConfigLocalTitle": "Local development: deploy Bridge first:",
	"bridge.noConfigSource": "Config source: Push Hub /v1/stack-config (offline fallback docs/generated/cpc-stack-config.json).",
	"send.titleLeading": "On-chain",
	"send.badge": "On-chain transfer",
	"send.fail": "Transfer failed",
	"send.listSaved": "Saved to list",
	"send.recipientRequired": "Enter recipient address",
	"send.amountRequired": "Enter amount",
	"send.amountInvalid": "Invalid amount",
	"send.tokenPreset": "Default",
	"send.tokenCustom": "Custom",
	"send.balanceLine": "Available {balance} {symbol} (address balance) · Total {total}",
	"send.balanceLooseSuffix": " · Loose {loose}",
	"send.decimalsHint": "Decimals (default 9)",
	"home.titleLeading": "My",
	"home.bridgeTitle": "Cross-chain bridge USDT ↔ DGC",
	"home.bridgeSubtitle": "BSC deposit · DGC withdraw to BSC / ETH",
	"common.loadMoreFailed": "Failed to load more",
	"wallet.consolidateSkipped": "No merge needed (no loose coins)",
	"wallet.consolidateDone": "Merge complete",
	"wallet.consolidateLoose": "Merge loose DGC",
	"wallet.looseCoinHint": "You have {amount} DGC in loose coins; merge into address balance before large transfers.",
	"wallet.addressCopied": "Address copied",
	"wallet.addressUnavailable": "Address unavailable",
	"time.relativeDays": "{n} days ago",
	"time.relativeHours": "{n} hours ago",
	"time.relativeMinutes": "{n} minutes ago",
	"time.justNow": "Just now",
	"tx.direction.sent": "Sent",
	"tx.direction.received": "Received",
	"tx.direction.other": "Other",
	"tx.status.success": "Success",
	"tx.status.failure": "Failed",
	"tx.status.unknown": "Unknown",
	"tx.detailLeading": "Transaction",
	"tx.detailHighlight": "details",
	"tx.explorerMissing": "Explorer URL not configured",
	"tx.linkCopied": "Link copied",
	"settings.probing": "Probing…",
	"settings.rpcReachable": "RPC reachable · Chain {chain}",
	"settings.rpcSaved": "RPC saved",
	"settings.addedSwitched": "Added and switched",
	"settings.lockPrefsSaved": "Lock settings saved",
	"settings.exportTitle": "Export wallet",
	"settings.backupInfo": "Backup info",
	"settings.exportNoMnemonic": "(Imported via private key — no mnemonic)\n\nPrivate key:\n{pk}\n\nAddress:\n{addr}",
	"settings.exportWithMnemonic": "Mnemonic:\n{mn}\n\nPrivate key:\n{pk}\n\nAddress:\n{addr}",
	"settings.lockTitle": "Lock wallet",
	"settings.lockMessage": "You will need to enter your password again after locking.",
	"settings.lockNowAction": "Lock now",
	"settings.lockBrowserOnly": "Browser close only",
	"settings.lockMinutes": "{n} minutes",
	"settings.lock1h": "1 hour",
	"settings.lock8h": "8 hours",
	"settings.networkTitleLeading": "Network",
	"settings.networkTitleHighlight": "& RPC",
	"settings.currentNetwork": "Current network",
	"settings.currentNetworkRpc": "Current network RPC",
	"settings.saveRpc": "Save RPC",
	"settings.addCustomNetwork": "Add custom network",
	"settings.networkName": "Name",
	"settings.walletChainOptional": "Wallet chain (optional)",
	"settings.probeRpc": "Probe RPC",
	"settings.addAndSwitch": "Add & switch",
	"settings.noCustomNetwork": "No custom networks",
	"settings.securityTitleLeading": "Wallet",
	"settings.securityTitleHighlight": "security",
	"settings.rememberUnlockDefault": "Check “Stay unlocked” by default",
	"settings.currentLock": "Current: {label}",
	"settings.saveLockPrefs": "Save lock settings",
	"settings.connectedTitleLeading": "Connected",
	"settings.noConnectedSites": "No connected sites",
	"dapp.titleHighlight": "Browser",
	"dapp.tabDiscover": "Discover",
	"dapp.tabBrowser": "Browse",
	"dapp.tabHistory": "History",
	"dapp.vconsoleEnabled": "vConsole enabled",
	"dapp.vconsoleDisabled": "vConsole disabled",
	"dapp.vconsoleEnabledHint": "vConsole enabled (green button bottom-right)",
	"dapp.vconsoleClose": "Turn off vConsole",
	"dapp.vconsoleOpen": "Turn on vConsole",
	"dapp.requestFailed": "DApp request failed: {error}",
	"dapp.addTitle": "Add DApp",
	"dapp.urlLabel": "URL",
	"dapp.addedToMy": "Added to My DApps",
	"dapp.deleteBookmarkTitle": "Delete bookmark",
	"dapp.deleteBookmarkMessage": "Remove \"{name}\"?",
	"dapp.deleteConfirm": "Delete",
	"dapp.clearHistoryTitle": "Clear history",
	"dapp.clearHistoryMessage": "Clear all browsing history?",
	"dapp.clearConfirm": "Clear",
	"dapp.searchHint": "Search or enter DApp URL",
	"dapp.addDapp": "Add DApp",
	"dapp.recommended": "Recommended DApps",
	"dapp.noRecommended": "No recommendations",
	"dapp.myBookmarks": "My bookmarks",
	"dapp.customAdd": "Custom add",
	"dapp.noBookmarksYet": "No bookmarks yet. Add your favorite DApps.",
	"dapp.presetTag": "Preset",
	"dapp.browsingHistory": "Browsing history",
	"dapp.noBrowsingHistory": "No browsing history",
	"dapp.add": "Add",
	"dapp.goBack": "Go back",
	"dapp.goForward": "Go forward",
	"dapp.collapseBookmarks": "Collapse bookmarks",
	"dapp.expandBookmarks": "Expand bookmarks",
	"dapp.urlInputHint": "Enter or paste URL",
	"dapp.go": "Go",
	"dapp.bookmarkCurrentPage": "Bookmark this page",
	"dapp.webViewInitializing": "Initializing WebView…",
	"common.retry": "Retry",
	"wallet.myWallets": "My wallets",
	"wallet.listCount": "{n}",
	"wallet.importNew": "Import new wallet",
	"wallet.importLocalHint": "Keys are stored encrypted locally only. Do not screenshot or share.",
	"wallet.nameOptional": "Wallet name (optional)",
	"wallet.mnemonicHint": "12 / 24 words, space-separated",
	"wallet.privateKeyHint": "dgcprivkey1… or 64-char hex / Base64",
	"wallet.confirmImport": "Confirm import",
	"wallet.enterPrivateKey": "Enter private key",
	"wallet.enterMnemonic": "Enter mnemonic",
	"wallet.added": "Wallet added",
	"wallet.currentAccount": "Current account",
	"wallet.currentBadge": "Current",
	"wallet.hdAccountCount": "{n} HD accounts",
	"wallet.exportMnemonic": "Export mnemonic",
	"wallet.exportPrivateKey": "Export private key",
	"wallet.exportPasswordTitle": "Verify security password",
	"wallet.exportPasswordHint": "Enter your extension password to continue. Never share the secret.",
	"wallet.exportPasswordEmpty": "Enter the extension password",
	"wallet.exportWarning": "Anyone with this can control your assets. Do not screenshot or send it.",
	"wallet.exportCopied": "Copied",
	"wallet.noMnemonicToExport": "This wallet was imported from a private key and has no mnemonic",
	"wallet.exportVerify": "Verify",
	"stake.confirmClaimMessage": "Rewards credit to address balance (not loose coins).\nEstimated rewards {amount} DGC",
	"stake.confirmRedeemMessage": "About {amount} DGC principal will credit to address balance.\nThis cannot be undone.",
	"stake.redeemSuccess": "Principal redeemed",
	"stake.claimSuccess": "Rewards claimed",
	"stake.networkStakeBadge": "Network stake",
	"stake.validatorPoolTotalCaption": "Total DGC in validator pools",
	"stake.avgCommission": "Avg commission",
	"stake.lockedPrincipal": "Locked principal",
	"stake.positionValueEst": "Position value (est.)",
	"stake.lockedChip": "Locked",
	"stake.redeemableChip": "Redeemable",
	"stake.unlockedChip": "Matured",
	"stake.statusActive": "Active",
	"stake.statusPending": "Pending activation",
	"stake.principalLabel": "Principal",
	"trade.tabTrade": "Trade",
	"trade.tabMarket": "Market",
	"trade.loadMarketFailed": "Failed to load market. Please try again.",
	"trade.enterQtyShort": "Enter quantity",
	"trade.orderBookUnavailable": "Order book unavailable",
	"trade.noOrdersInBook": "No orders in book",
	"trade.turnover24hData": "24h turnover (DATA)",
	"trade.kline": "Candles",
	"trade.noKlineData": "No candle data",
	"trade.klineLegend": "MA(7) · Volume",
	"trade.fillDetailLeading": "Fill",
	"trade.fillDetailHighlight": "details",
	"trade.noOnchainDigest": "No on-chain digest",
	"trade.copyDigest": "Copy digest",
	"trade.digestCopied": "Digest copied",
	"trade.onchainDetail": "On-chain details",
	"tx.sender": "Sender",
	"tx.checkpoint": "Checkpoint",
	"tx.gasBudget": "Gas budget",
	"tx.computation": "Computation",
	"tx.storage": "Storage",
	"tx.rebate": "Rebate",
	"tx.balanceChanges": "Balance changes",
	"tx.commands": "Commands",
	"tx.digestCopied": "Digest copied",
	"tx.onchainDetail": "On-chain details",
	"receive.title": "Receive",
	"receive.networkOnlyHint": "DGC network assets only",
	"receive.copyAddress": "Copy address",
	"receive.saveImage": "Save image",
	"receive.shareText": "DGC receive address {address}",
	"receive.imageFailed": "Could not generate image",
	"receive.encodeFailed": "Image encode failed",
	"receive.saveFailed": "Save failed: {error}",
	"recipient.needValidAddress": "Enter a valid recipient address first",
	"recipient.saveContact": "Save contact",
	"recipient.editLabel": "Edit label",
	"recipient.labelName": "Label",
	"recipient.labelHint": "e.g. Alice, exchange",
	"recipient.savedOk": "Contact saved",
	"recipient.deleteContact": "Delete contact",
	"recipient.removeRecent": "Remove from recent",
	"recipient.deleteContactMessage": "Delete saved contact “{name}”.",
	"recipient.removeRecentMessage": "Remove this address from recent recipients.",
	"recipient.saveAsContact": "Save as contact",
	"recipient.noSaved": "No saved contacts",
	"recipient.noRecent": "No recent addresses",
	"recipient.hint": "Successful sends are added to recent; tap Save to add a labeled contact.",
	"recipient.contactsTab": "Contacts{count}",
	"recipient.recentTab": "Recent{count}",
	"common.paste": "Paste",
	"common.delete": "Delete",
	"common.new": "New",
	"dapp.connectTitle": "Connect DApp",
	"dapp.connectFailed": "Connection failed",
	"dapp.walletLockedHint": "Wallet is locked. Unlock before connecting.",
	"dapp.signFailed": "Signing failed",
	"dapp.signRequest": "Signature request",
	"dapp.signAndExecute": "Sign & execute",
	"dapp.signOnly": "Sign",
	"mall.payLeading": "Mall",
	"mall.payHighlight": "Pay",
	"mall.amountDueData": "Amount due (DATA)",
	"mall.orderNumber": "Order No.",
	"mall.merchantAddress": "Merchant",
	"mall.payerAddress": "Payer",
	"mall.dataBalance": "DATA balance",
	"mall.confirmPay": "Confirm payment",
	"mall.walletLocked": "Wallet is locked",
	"mall.returnAppFailed": "Could not return to the mall app. Switch manually.",
	"mall.paySuccess": "Payment successful",
	"account.switchTitle": "Switch wallet / account",
	"account.count": "{n} accounts",
	"account.hdAccounts": "HD accounts",
	"account.numbered": "Account {n}",
	"account.inUse": "In use",
	"account.tapToSwitch": "Tap to switch",
	"stake.principalMatured": "Principal matured — redeemable",
	"stake.lockHintWithActive": "Active epoch {activeEpoch} · Unlock epoch {unlockEpoch} · {epochsLeft} epochs left",
	"stake.lockHintUnlockOnly": "Unlock epoch {unlockEpoch} · {epochsLeft} epochs left",
	"stake.poolTokenShare": "Pool token share {amount}",
	"stake.requestEpoch": "Request epoch",
	"stake.claimRewardsBtn": "Claim rewards",
	"stake.redeemPrincipalBtn": "Redeem principal",
	"stake.noValidatorsAvailable": "No validators available",
	"stake.validatorFieldLabel": "Validator",
	"stake.addressLabel": "Address",
	"stake.stakePool": "Stake pool",
	"stake.commission": "Commission",
	"stake.votingPower": "Weight",
	"stake.validatorAddressCopied": "Validator address copied",
	"mall.returnFailed": "Cannot return to mall app — switch manually",
	"mall.titleLeading": "Mall",
	"mall.titleHighlight": "Pay",
	"mall.amountDue": "Amount due (DATA)",
	"bridge.usdtLockedSnack": "USDT locked · tx {digest}",
	"bridge.dgcLockedSnack": "DGC locked · digest {digest}",
	"common.cannotOpenBrowser": "Cannot open browser",
	"tx.explorerLinkFailed": "Failed to open explorer link",
	"bridge.pageTitleHighlight": "Bridge",
	"bridge.walletAccountLine": "{wallet} · {account}",
	"bridge.tabSwap": "Swap",
	"bridge.directionUsdtToDgc": "USDT → DGC",
	"bridge.ethRelayerHint": "ETH withdrawals are settled by the relayer after DGC lock.",
	"bridge.fromBsc": "From (BSC USDT)",
	"bridge.fromDgc": "From (DGC DATA)",
	"bridge.evmRecipientLabel": "{chain} recipient",
	"bridge.lockUsdtToDgc": "Lock USDT → DGC",
	"bridge.lockDgcToTarget": "Lock DGC → {target}",
	"bridge.myBridgeRecords": "My bridge records",
	"bridge.noLocalRecords": "No local bridge records yet",
	"bridge.onChainLocksAccount": "On-chain locks (this account)",
	"bridge.noOnChainLockEvents": "No on-chain lock events",
	"bridge.networkRecentLocks": "Recent network locks",
	"connect.failed": "Connection failed",
	"connect.lockedHint": "Wallet locked — unlock before connecting",
	"sign.failed": "Signing failed",
	"sign.signAndExecute": "Sign and execute",
	"sign.signOnly": "Sign",
	"recipient.noSavedContacts": "No saved contacts",
	"recipient.noRecentAddresses": "No recent addresses",
	"recipient.contacts": "Contacts",
	"recipient.recent": "Recent",
	"receive.dgcOnly": "DGC network assets only",
	"bridge.statusConfirmed": "Confirmed",
	"bridge.introInboundTitle": "Deposit USDT → DATA",
	"bridge.introInboundBody": "Lock BNB-chain USDT in escrow; Relayer mints DATA 1:1 on DGC.",
	"bridge.introOutboundEthBody": "Lock DATA on DGC; Relayer pays USDT on Ethereum.",
	"bridge.introOutboundBscBody": "Lock DATA on DGC; Relayer pays USDT on BNB Chain.",
	"bridge.webVersion": "Web version",
	"bridge.inboundEscrowUnavailable": "BSC escrow unavailable — check bridge config.",
	"bridge.balanceWithAmount": "Balance {amount}",
	"bridge.exchangeRate": "Exchange rate",
	"bridge.exchangeRateValue": "1 DATA ≈ {rate} USDT",
	"bridge.bscInbound": "BSC inbound",
	"bridge.ethOutbound": "ETH outbound",
	"bridge.statusReady": "Ready",
	"bridge.txIdLabel": "Tx ID",
	"bridge.txIdCopied": "Tx ID copied",
	"bridge.copyTxId": "Copy Tx ID",
	"trade.unlockToViewOrders": "Unlock wallet to view orders",
	"trade.partialQtyLine": "Filled {filled} / {total}",
	"trade.orderHistoryLine": "{side} · {qty} @ {price}",
	"trade.fillQtyLine": "{qty} DGC",
	"trade.estimateSpendAmount": "Est. cost {amount} DATA",
	"trade.estimateReceiveAmount": "Est. receive {amount} DATA",
	"receive.imageRenderFailed": "Could not generate image",
	"receive.imageEncodeFailed": "Image encode failed",
	"recipient.validRequired": "Enter a valid recipient address first",
	"recipient.contactSaved": "Contact saved",
	"recipient.removeFromHistory": "Remove from recent",
	"recipient.deleteSavedMessage": "Delete contact {name}?",
	"recipient.hintEmpty": "Paste an address or pick a contact",
	"tx.computationCost": "Computation",
	"tx.storageCost": "Storage",
	"tx.storageRebate": "Rebate",
	"tx.onChainDetail": "On-chain details",
	"tx.noDigest": "No on-chain digest",
	"tx.copyDigest": "Copy digest",
	"trade.marketLoadFailed": "Failed to load market. Please try again later.",
	"bridge.tabRecords": "Records",
	"bridge.directionDgcWithdraw": "DGC withdraw",
	"bridge.introOutboundTitle": "Withdraw DATA → EVM",
	"bridge.statusNotConfigured": "Not configured",
	"wallet.shellSubtitle": "Address balance · staking · custom networks",
	"wallet.totalBalanceLine": "Total {total} DGC · {chain}",
	"trade.clobToken": "CLOB token",
	"trade.openOrderMeta": "{time} · Order {qty} DGC · Remaining {remaining} DGC",
	"trade.orderTimeQtyLine": "{time} · Qty {qty}",
	"trade.fillTimeQtyLine": "{time} · Qty {qty} DGC",
	"qr.title": "Scan",
	"qr.flashlight": "Flashlight",
	"qr.unrecognized": "Unrecognized: scan mall pay code or a DGC receive address",
	"qr.hint": "Supports mall pay codes (fixed DATA amount) or DGC receive addresses",
	"home.multiChainAssets": "Multi-chain assets",
	"home.refreshBalances": "Refresh balances",
	"home.suiMainnet": "Sui mainnet",
	"home.rpcUnavailable": "RPC unavailable",
	"wallet.addressLabel": "Wallet address",
	"wallet.looseBalance": "Loose",
	"stake.poolBalanceLine": "Pool balance {balance} DGC",
	"depth.liveBook": "Live order book",
	"depth.noData": "No depth data",
	"sign.gasEstimating": "Estimating gas…",
	"common.processing": "Processing…",
	"common.copied": "Copied",
	"common.copyFailed": "Copy failed",
	"common.loadFailed": "Failed to load",
	"common.deleted": "Deleted",
	"common.holding": "Holding",
	"common.summary": "Summary",
	"common.type": "Type",
	"wallet.mergeToAddressBalance": "Merge to address balance",
	"wallet.reloadExtensionMultiToken": "Extension background outdated: reload DGC Wallet in chrome://extensions to enable multi-token transfers",
	"wallet.selectToken": "Select a token",
	"wallet.networkSwitched": "Network switched",
	"wallet.unlocked": "Unlocked",
	"wallet.lockedToast": "Locked",
	"wallet.created": "Wallet created",
	"wallet.imported": "Wallet imported",
	"wallet.accountSwitched": "Account switched",
	"wallet.accountRenamed": "Renamed",
	"wallet.accountDeleted": "Account deleted",
	"wallet.accountAdded": "Account added",
	"wallet.accountNamePrompt": "Account name",
	"wallet.deleteAccountPasswordPrompt": "Enter extension password to delete account",
	"wallet.tokenAdded": "Token added",
	"wallet.configSaved": "Market config saved",
	"wallet.backupMnemonicToast": "Please back up your mnemonic",
	"wallet.regenerateMnemonic": "Please regenerate the mnemonic",
	"wallet.lockConfirmExt": "Lock the extension wallet? On-chain stake principal locks are unaffected.",
	"wallet.decryptedWarn": "Decrypted — do not screenshot or share",
	"wallet.mnemonicCopied": "Mnemonic copied",
	"wallet.exportNoMnemonic": "(Imported from private key — no mnemonic on record)",
	"wallet.consolidateMerged": "Merged {amount} DGC into address balance",
	"wallet.looseCoinHintExt": "Loose coins ({loose}); address balance shows 0. Merge below into P-UX address balance.",
	"wallet.looseApprox": "~{amount} DGC",
	"wallet.looseCoinCount": "{count} coins",
	"wallet.unlockToShow": "Unlock to view",
	"wallet.chainIdShort": "Chain {id}…",
	"wallet.chainIdEmpty": "Chain ID —",
	"wallet.connectAllowed": "Connection allowed",
	"wallet.signed": "Signed",
	"wallet.onchainReportCopied": "On-chain details copied",
	"trade.anchor": "Peg",
	"trade.priceHighToLow": "High → low",
	"trade.priceLowToHigh": "Low → high",
	"trade.bidsDepthAria": "Bid depth (5 levels)",
	"trade.asksDepthAria": "Ask depth (5 levels)",
	"trade.marketConfig": "Market config",
	"trade.saveMarketConfig": "Save market config",
	"trade.clickRefreshToLoad": "Tap refresh (top-right) to load",
	"trade.debugSource": "Trade query source data",
	"trade.copyJson": "Copy JSON",
	"trade.holdings": "Holding",
	"trade.fillLimitTitle": "Click to fill limit price {price} DATA",
	"trade.noMyTrades": "No trades of yours yet",
	"trade.noMarketTradesRefresh": "No market trades · tap refresh to load",
	"trade.pushHubLive": "Push Hub live · {url}",
	"trade.pushHubDisconnected": "Push Hub disconnected: {err} ({url})",
	"trade.pushHubConnecting": "Push Hub connecting… {url}",
	"trade.pushHubDepth": "Push Hub live depth (bid {bids} / ask {asks})",
	"trade.pushHubOfflineWs": "Push Hub offline — book & trades via WS pub",
	"trade.tradesQueryFailed": "Trade query failed: {err}",
	"trade.debugNoResponse": "Background did not respond to getClobTradesDebug",
	"trade.debugNoResponseHint": "getClobTradesDebug no response",
	"trade.buildMismatch": "⚠ Background build {bg} ≠ popup {popup} · reload the extension in chrome://extensions",
	"trade.debugSummaryRpc": "RPC {rpc} · raw RPC {rawRpc} · SDK {sdk} · parsed {parsed} · build {build}",
	"trade.debugParsed": "Parsed {count} · build {build}",
	"trade.debugNoJson": "build {build} · no tradeDebugJson",
	"trade.pushHubTradesFailed": "Push Hub trades failed: {err}",
	"trade.orderBookUnreachableWithTrades": "OrderBook unreachable · Push Hub {count} trades",
	"trade.orderBookUnreachableRpc": "OrderBook unreachable on RPC (check registry/orderbook config)",
	"trade.pushHubTradeCounts": "Push Hub · {market} market trades · mine {mine}",
	"trade.marketNotConfigured": "Market not configured · verify then reload extension",
	"tx.timeUnknown": "Time unknown",
	"tx.detailTitle": "Transaction details",
	"tx.paid": "Paid",
	"tx.noBalanceChanges": "No balance changes",
	"tx.digestTitle": "Transaction digest",
	"tx.direction.cancel": "Cancel",
	"tx.direction.buy": "Buy",
	"tx.direction.sell": "Sell",
	"settings.mainnetRpc": "Mainnet RPC",
	"settings.dgcMainnetProd": "DGC mainnet (production)",
	"settings.customNodePlaceholder": "Custom node",
	"settings.exportDesc": "Verify your extension password before export. Never share mnemonic or private key.",
	"settings.showExport": "Show export content",
	"settings.mnemonicShort": "Mnemonic",
	"settings.privateKeySui": "Private key (Sui Bech32)",
	"settings.copyMnemonic": "Copy mnemonic",
	"settings.securityNoticeTitle": "Security tip",
	"settings.securityNoticeBody": "Mnemonic and private key are encrypted on this device; keys are cleared from memory when locked.",
	"settings.lockBrowserRecommend": "Browser close / manual lock only (recommended)",
	"settings.lock15minIdle": "Lock after 15 minutes idle",
	"settings.currentChainId": "Current chain ID: {id}",
	"settings.probeFirst": "Probe RPC first",
	"settings.networkAdded": "Network added",
	"settings.rpcReachableShort": "Reachable · chain id: {chain}",
	"stake.onchainReportSummary": "On-chain details (same as query_cpc_account_onchain)",
	"stake.onchainReportHint": "Compare with terminal <code>node scripts/query_cpc_account_onchain.mjs --owner …</code>; updates when you refresh stakes.",
	"stake.reloadDetailsOnly": "Refresh details only",
	"stake.expandToLoad": "Expands to load automatically…",
	"stake.selectedLine": "Selected: {name} ({address})",
	"stake.poolIn": "Pool {amount} DGC",
	"stake.lockEnded": "Principal lock ended",
	"stake.claimAnytimeTitle": "No need to wait for principal unlock; claims rewards only",
	"stake.claimConfirmExt": "Claim stake rewards?\nRewards credit to address balance (P-UX, no loose coins); FungibleStakedSui pool-token value decreases; locked principal stays in the pool.",
	"stake.redeemConfirmExt": "Redeem principal {amount} DGC?\nRequires lock_until epoch ({epoch}) to have passed.",
	"stake.redeemAfterEpoch": "Principal redeemable at epoch {epoch} ({left} epochs left)",
	"stake.currentEpochSuffix": "{hint} · current epoch {epoch}",
	"stake.reloadBackground": "Load failed: extension background outdated. Open chrome://extensions, reload DGC Wallet, then reopen this page.",
	"stake.loadFailedWithMsg": "Load failed: {msg}",
	"stake.commissionLine": "Commission {rate}",
	"stake.votingPowerLine": "Weight {power}",
	"stake.principalLockLabel": "Principal lock",
	"sign.submitChain": "Sign and submit to DGC chain after confirm",
	"sign.signOnlyDesc": "Sign only after confirm (site submits)",
	"sign.gasOnConfirm": "Estimated on confirm",
	"sign.senderFilledByWallet": "(sender filled by wallet)",
	"sign.userRejected": "User rejected signature",
	"connect.siteDisconnected": "Site disconnected",
	"connect.userRejected": "User rejected connection",
	"dapp.tagOfficial": "Official",
	"dapp.tagRecommended": "Featured",
	"dapp.discover.explorerDesc": "Block explorer · txs & objects",
	"dapp.discover.shopName": "GlobalData Shop",
	"dapp.discover.shopDesc": "Data Global cross-border shop",
	"dapp.openExplorer": "Open DGC Explorer",
	"dapp.quickLinks": "Quick links",
	"dapp.nameLabel": "Name",
	"dapp.urlEmpty": "URL cannot be empty",
	"dapp.urlInvalid": "Invalid URL",
	"dapp.urlAlreadyBookmarked": "URL already in bookmarks",
	"dapp.preconnectSkipped": "DGC preconnect skipped: {error}",
	"dapp.scanQr": "Scan",
	"bridge.historyTitle": "Cross-chain history",
	"bridge.historySubtitle": "Both directions for this address: DATA → USDT and USDT → DATA",
	"bridge.colDirection": "Direction",
	"bridge.dirDataToUsdt": "DATA → USDT",
	"bridge.dirUsdtToData": "USDT → DATA",
	"bridge.historyNeedWallet": "Connect DGC Wallet to view this address’s bridge history",
	"bridge.historyOpen": "My records",
	"bridge.historyBackToBridge": "Back to bridge",
	"bridge.colTime": "Time",
	"bridge.historyAddress": "Address",
	"bridge.historyAutoRefresh": "Auto-refreshing",
};

const ms: MessageCatalog = {
	"common.language": "Bahasa",
	"common.network": "Rangkaian",
	"common.wallet": "Dompet",
	"common.cancel": "Batal",
	"common.confirm": "Sahkan",
	"common.refresh": "Muat semula",
	"common.loading": "Memuatkan…",
	"common.save": "Simpan",
	"common.lock": "Kunci",
	"common.close": "Tutup",
	"common.back": "Kembali",
	"common.copy": "Salin",
	"common.error": "Berlaku ralat",
	"common.spot": "Spot",
	"common.buy": "Beli",
	"common.sell": "Jual",
	"common.price": "Harga",
	"common.quantity": "Kuantiti",
	"common.available": "Tersedia",
	"common.settings": "Tetapan",
	"common.detect": "Uji",
	"nav.dex": "DEX",
	"nav.bridge": "Jambatan",
	"nav.stake": "Stake",
	"nav.genesis": "Genesis",
	"nav.apps": "Aplikasi",
	"nav.assets": "Aset",
	"nav.send": "Hantar",
	"nav.trade": "Dagangan",
	"nav.network": "Rangkaian",
	"nav.dapp": "DApp",
	"nav.crossChain": "Merentas rantai",
	"nav.market": "Pasaran",
	"explorer.title": "DGC Explorer",
	"explorer.tagline": "Explorer",
	"wallet.title": "DGC Wallet",
	"wallet.tagline": "Mainnet · baki alamat · staking",
	"wallet.welcome": "Selamat datang ke DGC Wallet",
	"wallet.welcomeDesc": "Tetapkan kata laluan sambungan untuk melindungi dompet anda.",
	"wallet.unlock": "Buka kunci dompet",
	"wallet.unlockDesc": "Masukkan kata laluan sambungan untuk menggunakan dompet.",
	"wallet.password": "Kata laluan sambungan",
	"wallet.passwordConfirm": "Sahkan kata laluan",
	"wallet.passwordPlaceholder": "Sekurang-kurangnya 8 aksara",
	"wallet.rememberUnlock": "Kekal dibuka",
	"wallet.create": "Cipta dompet",
	"wallet.import": "Import dompet",
	"wallet.generateMnemonic": "Jana mnemonik",
	"wallet.mnemonic": "Mnemonik (12 / 24 perkataan)",
	"wallet.privateKey": "Kunci peribadi",
	"wallet.backupTitle": "Sandarkan mnemonik",
	"wallet.backupDesc": "Tulis di tempat selamat. Kunci hilang tidak boleh dipulihkan.",
	"wallet.backupAck": "Saya telah menyandarkan mnemonik dengan selamat",
	"wallet.backupDone": "Selesai cipta",
	"wallet.addressBalance": "Baki alamat",
	"wallet.totalBalance": "Jumlah baki",
	"wallet.lockNow": "Kunci dompet sekarang",
	"wallet.export": "Eksport dompet",
	"wallet.security": "Keselamatan dompet",
	"wallet.autoLock": "Kunci automatik",
	"wallet.connectedSites": "Laman tersambung",
	"wallet.txHistory": "Sejarah transaksi",
	"wallet.noTx": "Tiada transaksi lagi",
	"wallet.loadingWallet": "Memuatkan dompet…",
	"trade.pair": "DGC / DATA",
	"trade.buyDgc": "Beli DGC",
	"trade.sellDgc": "Jual DGC",
	"trade.limitPrice": "Harga had",
	"trade.quantity": "Kuantiti",
	"trade.estimateSpend": "Anggaran kos — DATA",
	"trade.estimateReceive": "Anggaran terima — DATA (selepas yuran)",
	"trade.bids": "Bidaan",
	"trade.asks": "Tawaran",
	"trade.marketTrades": "Dagangan pasaran",
	"trade.myTrades": "Dagangan saya",
	"trade.openOrders": "Pesanan terbuka",
	"trade.priceData": "Harga (DATA)",
	"trade.qtyDgc": "Kuantiti (DGC)",
	"trade.lastPrice": "Harga terakhir",
	"trade.loadingMarket": "Memuatkan pasaran…",
	"trade.refresh": "Muat semula pasaran",
	"sign.request": "Permintaan tandatangan",
	"sign.approve": "Lulus & tandatangan",
	"sign.reject": "Tolak",
	"connect.request": "Permintaan sambungan",
	"connect.approve": "Benarkan sambungan",
	"connect.reject": "Tolak",
	"connect.desc": "Laman ini boleh melihat alamat DGC anda dan meminta tandatangan. Batalkan bila-bila masa di Rangkaian → Laman tersambung.",
	"language.title": "Bahasa",
	"language.subtitle": "Pilih bahasa paparan. Lalai ialah English.",
	"settings.networkRpc": "Rangkaian & RPC",
	"settings.walletSecurity": "Keselamatan dompet",
	"settings.walletManage": "Pengurusan dompet",
	"settings.connectedDapps": "DApp tersambung",
	"common.time": "Masa",
	"common.side": "Arah",
	"common.action": "Tindakan",
	"common.status": "Status",
	"common.account": "Akaun",
	"common.amount": "Jumlah",
	"common.max": "Maks",
	"common.empty": "Tiada",
	"common.submitting": "Menghantar…",
	"common.connectWallet": "Sambung dompet",
	"common.disconnect": "Putuskan",
	"common.connecting": "Menyambung…",
	"common.loadMore": "Muat lagi",
	"common.all": "Semua",
	"common.balance": "Baki",
	"common.spread": "Spread",
	"trade.orderBook": "Buku pesanan",
	"trade.recentTrades": "Dagangan terbaru",
	"trade.orderHistory": "Sejarah pesanan",
	"trade.tradeHistory": "Sejarah dagangan",
	"trade.bestBid": "Bida terbaik",
	"trade.bestAsk": "Tanya terbaik",
	"trade.change24h": "Perubahan 24j",
	"trade.volume24h": "Volum 24j",
	"trade.turnover24h": "Pusing ganti 24j",
	"trade.trades24h": "Dagangan 24j",
	"trade.noTrades": "Tiada dagangan",
	"trade.cancelOrder": "Batal",
	"trade.cancelling": "Membatalkan…",
	"trade.noOpenOrders": "Tiada pesanan terbuka",
	"trade.noOrderHistory": "Tiada sejarah pesanan",
	"trade.connectToViewOrders": "Sambung dompet untuk melihat pesanan",
	"trade.statusOpen": "Terbuka",
	"trade.statusFilled": "Penuh",
	"trade.statusCancelled": "Dibatalkan",
	"trade.statusPartial": "Separa",
	"trade.invalidPrice": "Harga had tidak sah",
	"trade.enterQty": "Masukkan kuantiti DGC",
	"trade.qtyPositive": "Kuantiti mesti integer positif",
	"trade.bidSubmitted": "Pesanan beli dihantar",
	"trade.askSubmitted": "Pesanan jual dihantar",
	"trade.cancelSubmitted": "Pembatalan dihantar",
	"trade.remaining": "Baki",
	"trade.orderId": "ID pesanan",
	"trade.taker": "Pengambil",
	"trade.noClob": "CLOB belum dikonfigurasi",
	"wallet.connect": "Sambung DGC Wallet",
	"wallet.notDetected": "DGC Wallet tidak dikesan",
	"wallet.downloadExt": "Muat turun sambungan DGC Wallet",
	"wallet.downloadApp": "Muat turun DGC Wallet",
	"wallet.appsCenter": "Pusat aplikasi",
	"wallet.wrongWallet": "Sila sambung DGC Wallet",
	"wallet.disconnecting": "Memutuskan…",
	"wallet.viewBalance": "Sambung DGC Wallet untuk melihat baki",
	"send.recipient": "Penerima",
	"send.confirm": "Sahkan hantar",
	"send.token": "Token",
	"stake.selectValidator": "Pilih validator",
	"stake.amount": "Jumlah stake",
	"stake.myStakes": "Stake saya",
	"stake.stakeDgc": "Stake DGC",
	"stake.noStakes": "Tiada rekod stake",
	"stake.refreshValidators": "Muat semula",
	"trade.orderQty": "Kuantiti pesanan",
	"trade.noTradeHistory": "Tiada sejarah dagangan",
	"trade.remainingShort": "baki",
	"trade.clickFillPrice": "Klik untuk isi harga had",
	"trade.klineWindow": "Tetingkap carta",
	"trade.open24h": "Buka 24j",
	"trade.high24h": "Tinggi 24j",
	"trade.low24h": "Rendah 24j",
	"trade.volume24hDgc": "Vol 24j (DGC)",
	"trade.txExpired": "Transaksi tamat tempoh, cuba lagi",
	"trade.balanceLabel": "Baki {symbol}",
	"wallet.connectFirst": "Sila sambung DGC Wallet dahulu",
	"wallet.notFoundAlert": "Sambungan DGC Wallet tidak dijumpai. Pasang dan dayakan, kemudian muat semula halaman ini.",
	"wallet.installHint": "Pasang sambungan Chrome, atau buka halaman ini dalam pelayar APP DGC Wallet.",
	"wallet.siteEnabledHint": "Laman semasa {origin}. Selepas pasang, dayakan di chrome://extensions dan muat semula.",
	"wallet.notDetectedExt": "Sambungan DGC Wallet tidak dikesan",
	"send.success": "Berjaya dihantar",
	"send.availableDash": "Tersedia —",
	"send.uxHint": "Utamakan baki alamat; gas dibayar dari baki alamat DGC",
	"send.addCustomToken": "Tambah token CLOB tersuai",
	"send.symbol": "Simbol",
	"send.typeTag": "TypeTag",
	"send.decimals": "Perpuluhan",
	"send.saveToList": "Simpan ke senarai",
	"stake.submitted": "Stake dihantar",
	"stake.success": "Stake berjaya",
	"stake.confirmTitle": "Sahkan stake",
	"stake.confirmAction": "Sahkan stake",
	"stake.selectValidatorLabel": "Pilih validator",
	"stake.positions": "Kedudukan stake",
	"stake.noPositions": "Tiada kedudukan stake",
	"stake.lockHintShort": "Prinsipal dikunci 180 epoch. Ganjaran boleh dituntut bila-bila; tebus prinsipal selepas buka kunci.",
	"stake.newStake": "Stake baharu",
	"stake.enterAmount": "Masukkan jumlah stake",
	"stake.confirmMessage": "Stake {amount} DGC kepada validator dipilih.\nPrinsipal dikunci 180 epoch; ganjaran boleh dituntut bila-bila.",
	"stake.claimRewards": "Tuntut ganjaran stake",
	"stake.redeemPrincipal": "Tebus prinsipal stake",
	"stake.noPositionCount": "Tiada kedudukan",
	"stake.positionCount": "{count} kedudukan",
	"apps.title": "Aplikasi",
	"apps.titleSuffix": "/ Ekosistem",
	"apps.subtitle": "Akses aplikasi DGC: Global Shop, RWAX Super App, DGC Wallet dan alat on-chain.",
	"apps.mobileSubtitle": "Global Shop · RWAX · DGC Wallet",
	"apps.viewAccount": "Lihat akaun saya →",
	"apps.featured": "Aplikasi pilihan",
	"apps.scanDownload": "Imbas untuk muat turun",
	"apps.scanDownloadApk": "Imbas muat turun APK",
	"apps.scanDownloadRwax": "Imbas muat turun RWAX",
	"apps.mirrorDownload": "Muat turun alternatif",
	"apps.chromeExt": "Sambungan Chrome",
	"apps.globalShop": "Global Shop",
	"apps.globalShopDesc": "Platform e-dagang rentas sempadan Data Global dengan pelbagai bahasa dan mata wang. Layari fesyen dan jenama; bayar dengan DGC Wallet.",
	"apps.openGlobalShop": "Buka Global Shop",
	"apps.tagEcommerce": "E-dagang",
	"apps.globalShopApp": "Global Shop APP",
	"apps.globalShopAppDesc": "Klien mudah alih Global Shop — beli-belah, jejaki pesanan dan tawaran. Imbas QR untuk pasang.",
	"apps.downloadGlobalShopApp": "Muat turun Global Shop APP",
	"apps.tagMobile": "Mudah alih",
	"apps.walletDesc": "Dompet asli DGC: urus aset dan tandatangan transaksi DApp. Pasang APK Android melalui muat turun, cermin atau QR; sambungan Chrome juga tersedia.",
	"apps.tagWallet": "Dompet",
	"apps.rwaxDesc": "RWAX Super App: dompet multi-rantai, sosial, pelayar DApp dan pelayar rasmi DGC. Import dgcprivkey / mnemonik; lalai ke ekosistem DGC.",
	"apps.downloadRwax": "Muat turun RWAX",
	"apps.tagSuperApp": "Super App",
	"apps.onchainShortcuts": "Pintasan on-chain",
	"apps.dexTrade": "Dagangan DEX",
	"apps.dexTradeDesc": "Dagangan spot DGC",
	"apps.bridge": "Jambatan",
	"apps.bridgeDesc": "BNB USDT ↔ DATA (1:1)",
	"apps.stake": "Stake",
	"apps.stakeDesc": "Wakil kepada validator dan dapat ganjaran",
	"apps.explorer": "Penjelajah blok",
	"apps.explorerDesc": "Cari tx dan alamat",
	"apps.myStatus": "Status on-chain saya",
	"apps.totalBalance": "Jumlah baki",
	"apps.viewAddress": "Lihat alamat",
	"apps.connectToSeeBalance": "Sambung DGC Wallet untuk melihat baki",
	"stake.pageTitle": "Stake",
	"stake.pageSubtitle": "Wakil DGC kepada validator, selamatkan rangkaian dan dapat ganjaran. Jumlah dalam DGC (1 DGC = 10⁹ MIST).",
	"stake.epochProgress": "Kemajuan epoch",
	"stake.currentEpoch": "Epoch semasa",
	"stake.epochCycleAbout": "Kitaran ~ {duration}",
	"stake.latestCheckpoint": "Checkpoint terkini",
	"stake.checkpointHint": "Rujukan kemajuan on-chain",
	"stake.connectHint": "Sambung DGC Wallet di bar sisi untuk melihat baki, kedudukan dan stake.",
	"stake.staked": "Distake",
	"stake.viewAccount": "Lihat butiran akaun",
	"stake.delegationDetails": "Butiran delegasi",
	"stake.tipGas": "• Stake dan gas guna DGC asli; simpan baki kecil untuk yuran.",
	"stake.tipUnlock": "• Unstake menunggu tempoh buka kunci epoch (lihat lock_until_epoch).",
	"stake.tipLeaderboard": "• Ranking pool validator di Leaderboards laman utama; ranking pengguna perlukan Indexer.",
	"stake.validatorsNetwork": "Rangkaian validator",
	"stake.networkStake": "Stake {symbol} rangkaian",
	"stake.networkStakeTip": "Jumlah DGC distake oleh validator dan pendelegasi",
	"stake.avgDailyYield": "Hasil harian purata",
	"stake.avgDailyYieldTip": "APY validator ÷ 365; dianggarkan dari subsidi bila sampel nipis",
	"stake.lastEpochReward": "Ganjaran epoch lepas",
	"stake.lastEpochRewardTip": "Jumlah ganjaran stake merentas pool epoch lepas",
	"stake.activeValidators": "Validator aktif",
	"stake.activeValidatorsTip": "Validator aktif dalam epoch semasa",
	"stake.validatorMap": "Peta validator",
	"stake.mapLoading": "Memuatkan peta…",
	"stake.allValidators": "Semua validator",
	"stake.validatorsLoadFailed": "Gagal memuatkan data validator",
	"stake.colName": "Nama",
	"stake.colStake": "Stake",
	"stake.colDaily": "Harian",
	"stake.epochLoading": "Memuatkan kemajuan epoch…",
	"stake.epochProgressOf": "Kemajuan epoch {epoch}",
	"stake.remaining": "baki",
	"stake.lockProgress": "Kemajuan buka kunci prinsipal",
	"stake.noDelegations": "Tiada delegasi lagi",
	"stake.fungibleCert": "Sijil fungible",
	"stake.claimable": "Boleh dituntut",
	"stake.activeEpoch": "Epoch aktif",
	"stake.unlockEpoch": "Epoch buka kunci",
	"stake.epochsLeft": "Epoch tinggal",
	"stake.lockPeriod": "Tempoh kunci",
	"stake.claimableRewards": "Ganjaran boleh dituntut",
	"stake.principalUnlocked": "Prinsipal dibuka — boleh ditebus",
	"stake.redeemAfterUnlock": "Tebus selepas buka kunci (Epoch {epoch})",
	"genesis.title": "Penerbitan genesis",
	"genesis.subtitle": "Peruntukan genesis DGC awam untuk pengawasan komuniti. Jumlah {total} (syiling utama {symbol}). Ketik alamat untuk melihat baki on-chain.",
	"genesis.mobileSubtitle": "Peruntukan genesis",
	"genesis.supplyCheck": "Semakan bekalan",
	"genesis.totalSupply": "Jumlah genesis",
	"genesis.tableSum": "Jumlah jadual",
	"genesis.equalsTotal": "Padan jumlah",
	"genesis.notEqualsTotal": "Tidak padan jumlah",
	"genesis.liveValidators": "Validator aktif on-chain",
	"genesis.reading": "Memuat…",
	"genesis.unavailable": "Tidak tersedia",
	"genesis.expected": "dijangka {count}",
	"genesis.compareConfig": "Dibanding dengan konfigurasi genesis (RPC disambung)",
	"genesis.allocationDetail": "Butiran peruntukan",
	"genesis.allocationIntro": "“Peruntukan genesis” ialah jumlah dirancang, bukan baki langsung. Buka alamat untuk pegangan sebenar. Empat kolam ",
	"genesis.linear10yStrong": "linear 10 tahun",
	"genesis.allocationIntro2": " dimuat ke ",
	"genesis.allocationIntro3": " on-chain selepas bootstrap dan dituntut secara linear; ekosistem platform tiada vesting. “Kunci stake” ialah self-stake validator.",
	"genesis.colPurpose": "Tujuan",
	"genesis.colAmount": "Peruntukan genesis (DGC)",
	"genesis.colPct": "Bahagian",
	"genesis.colVesting": "Peraturan buka / kunci",
	"genesis.colAddress": "Alamat kolam (baki on-chain)",
	"genesis.seeStakePage": "Lihat halaman validator / stake",
	"genesis.pendingSync": "Menunggu sync",
	"genesis.total": "Jumlah",
	"genesis.footerHint": "Baki kolam mungkin masih objek Coin. Selepas bootstrap-vesting, buka halaman alamat kolam untuk jumlah claimable, kemajuan, sejarah dan claim dengan dompet yang sepadan.",
	"genesis.poolAddressPage": "halaman alamat kolam",
	"genesis.vesting.linear_10y": "Linear 10 tahun",
	"genesis.vesting.none": "Tiada kunci (beredar)",
	"genesis.vesting.system": "Kolam sistem",
	"genesis.vesting.self_stake": "Kunci stake {epochs} epoch",
	"genesis.hint.linear_10y": "vesting::linear::Wallet on-chain; claim mengikut masa. Buka halaman alamat kolam untuk claimable. Sebelum bootstrap mungkin masih Coin.",
	"genesis.hint.none": "Tiada vesting on-chain; boleh dipindah ikut peraturan ops",
	"genesis.hint.system": "Dibayar melalui parameter subsidi epoch, bukan baki alamat biasa",
	"genesis.hint.self_stake": "Dalam kolam stake validator; tertakluk epoch buka kunci",
	"genesis.pool.community": "Komuniti",
	"genesis.pool.communityNote": "Linear 10 tahun; bootstrap memuat Wallet selepas mint genesis",
	"genesis.pool.foundation": "Yayasan",
	"genesis.pool.foundationNote": "Kunci on-chain linear 10 tahun",
	"genesis.pool.tech_support": "Sokongan teknikal",
	"genesis.pool.tech_supportNote": "Kunci on-chain linear 10 tahun",
	"genesis.pool.platform_ecosystem": "Ekosistem platform",
	"genesis.pool.platform_ecosystemNote": "Tiada vesting; ops / float ekosistem (multisig)",
	"genesis.pool.user_rewards": "Ganjaran pengguna",
	"genesis.pool.user_rewardsNote": "Kunci on-chain linear 10 tahun",
	"genesis.pool.validators": "Self-stake validator genesis",
	"genesis.pool.validatorsNote": "{count} validator × {each} DGC; kunci prinsipal {epochs} epoch",
	"genesis.pool.stake_subsidy_fund": "Dana subsidi stake",
	"genesis.pool.stake_subsidy_fundNote": "Kolam subsidi sistem (genesis ke 0x0)",
	"bridge.subtitle": "Aset jambatan ialah DATA (bukan DGC), 1:1. Sisi BSC ialah Binance-Peg USDT rasmi; sisi DGC ialah DATA. Relayer selesaikan automatik.",
	"bridge.mobileSubtitle": "DATA ↔ BNB USDT · 1:1",
	"bridge.buyTitle": "Beli DATA dengan BNB USDT",
	"bridge.sellTitle": "Jual DATA untuk BNB USDT",
	"bridge.balance": "Baki",
	"bridge.toReceiveData": "Ke (anggaran DATA)",
	"bridge.toReceiveUsdt": "Ke (anggaran BNB USDT)",
	"bridge.fromLockData": "Dari (kunci DATA)",
	"bridge.cpcRecipient": "Penerima rantai DGC",
	"bridge.bscRecipient": "Penerima BNB USDT",
	"bridge.recipientPlaceholder": "Masukkan alamat 0x… atau D…",
	"bridge.currentWallet": "Dompet semasa",
	"bridge.connectBscFirst": "Sambung dompet BSC dahulu",
	"bridge.connectCpcFirst": "Sambung DGC Wallet dahulu",
	"bridge.switchMainnet": "Tukar ke BSC mainnet",
	"bridge.escrowMissing": "Kontrak escrow belum diguna",
	"bridge.lockUsdtToData": "Kunci {amount} {usdt} → DATA",
	"bridge.lockDataToUsdt": "Kunci {amount} {data} → {usdt}",
	"bridge.bscBusy": "Interaksi kontrak BSC…",
	"bridge.cpcBusy": "Menghantar transaksi…",
	"bridge.dataBridgeStatus": "Status jambatan DATA",
	"bridge.treasuryLocked": "Perbendaharaan terkunci",
	"bridge.gatewayRpc": "RPC gateway",
	"bridge.detecting": "Menyemak",
	"bridge.bnbUsdtStatus": "Status BNB / USDT",
	"bridge.targetNetwork": "Rangkaian sasaran",
	"bridge.usdtContract": "Kontrak BNB USDT",
	"bridge.escrow": "Escrow",
	"bridge.configMissing": "Belum dikonfigurasi",
	"bridge.nodeStatus": "Status nod",
	"bridge.networkMatch": "Rangkaian sepadan",
	"bridge.switchNetwork": "Tukar rangkaian",
	"bridge.notConnected": "Tidak disambung",
	"bridge.recentLocks": "Kunci DATA terkini",
	"bridge.forUsdt": "→ untuk BNB USDT",
	"bridge.noLocks": "Tiada rekod kunci jambatan pada rangkaian ini",
	"bridge.colAmount": "Jumlah dikunci",
	"bridge.colEstimate": "Anggaran terima",
	"bridge.colRecipient": "Penerima",
	"bridge.colAction": "Tindakan",
	"bridge.details": "Butiran →",
	"bridge.showRecent5": "Menunjukkan 5 terkini",
	"bridge.refreshStatus": "Muat semula status",
	"bridge.backHome": "← Kembali ke laman utama",
	"bridge.noConfig": "Konfigurasi jambatan tidak dijumpai. Deploy Bridge on-chain, kemudian jalankan ./cpc.sh stack start atau fetch-stack-config.",
	"bridge.connectMetaMask": "Sambung MetaMask",
	"bridge.installEvm": "Pasang MetaMask atau dompet EVM lain",
	"bridge.connectBsc": "Sambung dompet BSC",
	"bridge.noEvm": "Dompet EVM tidak dikesan",
	"bridge.disconnect": "Putuskan",
	"bridge.ok": "OK",
	"bridge.fail": "Ralat",
	"bridge.processing": "Memproses…",
	"bridge.useCurrent": "Guna semasa",
	"bridge.needBscRecipient": "Masukkan atau sambung alamat penerima BSC",
	"bridge.needCpcRecipient": "Masukkan alamat penerima rantai DGC",
	"bridge.escrowDeployHint": "Escrow belum dikonfigurasi: deploy CpcUsdtEscrow di BSC mainnet dahulu",
	"bridge.mainnetTokenOnly": "Konfigurasi semasa menggunakan token BSC mainnet; nyahpilih testnet",
	"bridge.lockedDataOk": "Dikunci {amount} {data}; relayer akan bayar ~{usdtAmount} {usdt} ke {recipient}…",
	"bridge.lockedUsdtOk": "Dikunci {amount} {usdt} → DATA (BSC tx {tx}…)",
	"bridge.noConfigLocalTitle": "Pembangunan tempatan: deploy Bridge dahulu:",
	"bridge.noConfigSource": "Sumber konfigurasi: Push Hub /v1/stack-config (sandaran luar talian docs/generated/cpc-stack-config.json).",
	"send.titleLeading": "On-chain",
	"send.badge": "On-chain transfer",
	"send.fail": "Transfer failed",
	"send.listSaved": "Saved to list",
	"send.recipientRequired": "Enter recipient address",
	"send.amountRequired": "Enter amount",
	"send.amountInvalid": "Invalid amount",
	"send.tokenPreset": "Default",
	"send.tokenCustom": "Custom",
	"send.balanceLine": "Available {balance} {symbol} (address balance) · Total {total}",
	"send.balanceLooseSuffix": " · Loose {loose}",
	"send.decimalsHint": "Decimals (default 9)",
	"home.titleLeading": "My",
	"home.bridgeTitle": "Cross-chain bridge USDT ↔ DGC",
	"home.bridgeSubtitle": "BSC deposit · DGC withdraw to BSC / ETH",
	"common.loadMoreFailed": "Failed to load more",
	"wallet.consolidateSkipped": "No merge needed (no loose coins)",
	"wallet.consolidateDone": "Merge complete",
	"wallet.consolidateLoose": "Merge loose DGC",
	"wallet.looseCoinHint": "You have {amount} DGC in loose coins; merge into address balance before large transfers.",
	"wallet.addressCopied": "Address copied",
	"wallet.addressUnavailable": "Address unavailable",
	"time.relativeDays": "{n} days ago",
	"time.relativeHours": "{n} hours ago",
	"time.relativeMinutes": "{n} minutes ago",
	"time.justNow": "Just now",
	"tx.direction.sent": "Sent",
	"tx.direction.received": "Received",
	"tx.direction.other": "Other",
	"tx.status.success": "Success",
	"tx.status.failure": "Failed",
	"tx.status.unknown": "Unknown",
	"tx.detailLeading": "Transaction",
	"tx.detailHighlight": "details",
	"tx.explorerMissing": "Explorer URL not configured",
	"tx.linkCopied": "Link copied",
	"settings.probing": "Probing…",
	"settings.rpcReachable": "RPC reachable · Chain {chain}",
	"settings.rpcSaved": "RPC saved",
	"settings.addedSwitched": "Added and switched",
	"settings.lockPrefsSaved": "Lock settings saved",
	"settings.exportTitle": "Export wallet",
	"settings.backupInfo": "Backup info",
	"settings.exportNoMnemonic": "(Imported via private key — no mnemonic)\n\nPrivate key:\n{pk}\n\nAddress:\n{addr}",
	"settings.exportWithMnemonic": "Mnemonic:\n{mn}\n\nPrivate key:\n{pk}\n\nAddress:\n{addr}",
	"settings.lockTitle": "Lock wallet",
	"settings.lockMessage": "You will need to enter your password again after locking.",
	"settings.lockNowAction": "Lock now",
	"settings.lockBrowserOnly": "Browser close only",
	"settings.lockMinutes": "{n} minutes",
	"settings.lock1h": "1 hour",
	"settings.lock8h": "8 hours",
	"settings.networkTitleLeading": "Network",
	"settings.networkTitleHighlight": "& RPC",
	"settings.currentNetwork": "Current network",
	"settings.currentNetworkRpc": "Current network RPC",
	"settings.saveRpc": "Save RPC",
	"settings.addCustomNetwork": "Add custom network",
	"settings.networkName": "Name",
	"settings.walletChainOptional": "Wallet chain (optional)",
	"settings.probeRpc": "Probe RPC",
	"settings.addAndSwitch": "Add & switch",
	"settings.noCustomNetwork": "No custom networks",
	"settings.securityTitleLeading": "Wallet",
	"settings.securityTitleHighlight": "security",
	"settings.rememberUnlockDefault": "Check “Stay unlocked” by default",
	"settings.currentLock": "Current: {label}",
	"settings.saveLockPrefs": "Save lock settings",
	"settings.connectedTitleLeading": "Connected",
	"settings.noConnectedSites": "No connected sites",
	"dapp.titleHighlight": "Browser",
	"dapp.tabDiscover": "Discover",
	"dapp.tabBrowser": "Browse",
	"dapp.tabHistory": "History",
	"dapp.vconsoleEnabled": "vConsole enabled",
	"dapp.vconsoleDisabled": "vConsole disabled",
	"dapp.vconsoleEnabledHint": "vConsole enabled (green button bottom-right)",
	"dapp.vconsoleClose": "Turn off vConsole",
	"dapp.vconsoleOpen": "Turn on vConsole",
	"dapp.requestFailed": "DApp request failed: {error}",
	"dapp.addTitle": "Add DApp",
	"dapp.urlLabel": "URL",
	"dapp.addedToMy": "Added to My DApps",
	"dapp.deleteBookmarkTitle": "Delete bookmark",
	"dapp.deleteBookmarkMessage": "Remove \"{name}\"?",
	"dapp.deleteConfirm": "Delete",
	"dapp.clearHistoryTitle": "Clear history",
	"dapp.clearHistoryMessage": "Clear all browsing history?",
	"dapp.clearConfirm": "Clear",
	"dapp.searchHint": "Search or enter DApp URL",
	"dapp.addDapp": "Add DApp",
	"dapp.recommended": "Recommended DApps",
	"dapp.noRecommended": "No recommendations",
	"dapp.myBookmarks": "My bookmarks",
	"dapp.customAdd": "Custom add",
	"dapp.noBookmarksYet": "No bookmarks yet. Add your favorite DApps.",
	"dapp.presetTag": "Preset",
	"dapp.browsingHistory": "Browsing history",
	"dapp.noBrowsingHistory": "No browsing history",
	"dapp.add": "Add",
	"dapp.goBack": "Go back",
	"dapp.goForward": "Go forward",
	"dapp.collapseBookmarks": "Collapse bookmarks",
	"dapp.expandBookmarks": "Expand bookmarks",
	"dapp.urlInputHint": "Enter or paste URL",
	"dapp.go": "Go",
	"dapp.bookmarkCurrentPage": "Bookmark this page",
	"dapp.webViewInitializing": "Initializing WebView…",
	"common.retry": "Retry",
	"wallet.myWallets": "My wallets",
	"wallet.listCount": "{n}",
	"wallet.importNew": "Import new wallet",
	"wallet.importLocalHint": "Keys are stored encrypted locally only. Do not screenshot or share.",
	"wallet.nameOptional": "Wallet name (optional)",
	"wallet.mnemonicHint": "12 / 24 words, space-separated",
	"wallet.privateKeyHint": "dgcprivkey1… or 64-char hex / Base64",
	"wallet.confirmImport": "Confirm import",
	"wallet.enterPrivateKey": "Enter private key",
	"wallet.enterMnemonic": "Enter mnemonic",
	"wallet.added": "Wallet added",
	"wallet.currentAccount": "Current account",
	"wallet.currentBadge": "Current",
	"wallet.hdAccountCount": "{n} HD accounts",
	"wallet.exportMnemonic": "Export mnemonic",
	"wallet.exportPrivateKey": "Export private key",
	"wallet.exportPasswordTitle": "Verify security password",
	"wallet.exportPasswordHint": "Enter your extension password to continue. Never share the secret.",
	"wallet.exportPasswordEmpty": "Enter the extension password",
	"wallet.exportWarning": "Anyone with this can control your assets. Do not screenshot or send it.",
	"wallet.exportCopied": "Copied",
	"wallet.noMnemonicToExport": "This wallet was imported from a private key and has no mnemonic",
	"wallet.exportVerify": "Verify",
	"stake.confirmClaimMessage": "Rewards credit to address balance (not loose coins).\nEstimated rewards {amount} DGC",
	"stake.confirmRedeemMessage": "About {amount} DGC principal will credit to address balance.\nThis cannot be undone.",
	"stake.redeemSuccess": "Principal redeemed",
	"stake.claimSuccess": "Rewards claimed",
	"stake.networkStakeBadge": "Network stake",
	"stake.validatorPoolTotalCaption": "Total DGC in validator pools",
	"stake.avgCommission": "Avg commission",
	"stake.lockedPrincipal": "Locked principal",
	"stake.positionValueEst": "Position value (est.)",
	"stake.lockedChip": "Locked",
	"stake.redeemableChip": "Redeemable",
	"stake.unlockedChip": "Matured",
	"stake.statusActive": "Active",
	"stake.statusPending": "Pending activation",
	"stake.principalLabel": "Principal",
	"trade.tabTrade": "Trade",
	"trade.tabMarket": "Market",
	"trade.loadMarketFailed": "Failed to load market. Please try again.",
	"trade.enterQtyShort": "Enter quantity",
	"trade.orderBookUnavailable": "Order book unavailable",
	"trade.noOrdersInBook": "No orders in book",
	"trade.turnover24hData": "24h turnover (DATA)",
	"trade.kline": "Candles",
	"trade.noKlineData": "No candle data",
	"trade.klineLegend": "MA(7) · Volume",
	"trade.fillDetailLeading": "Fill",
	"trade.fillDetailHighlight": "details",
	"trade.noOnchainDigest": "No on-chain digest",
	"trade.copyDigest": "Copy digest",
	"trade.digestCopied": "Digest copied",
	"trade.onchainDetail": "On-chain details",
	"tx.sender": "Sender",
	"tx.checkpoint": "Checkpoint",
	"tx.gasBudget": "Gas budget",
	"tx.computation": "Computation",
	"tx.storage": "Storage",
	"tx.rebate": "Rebate",
	"tx.balanceChanges": "Balance changes",
	"tx.commands": "Commands",
	"tx.digestCopied": "Digest copied",
	"tx.onchainDetail": "On-chain details",
	"receive.title": "Receive",
	"receive.networkOnlyHint": "DGC network assets only",
	"receive.copyAddress": "Copy address",
	"receive.saveImage": "Save image",
	"receive.shareText": "DGC receive address {address}",
	"receive.imageFailed": "Could not generate image",
	"receive.encodeFailed": "Image encode failed",
	"receive.saveFailed": "Save failed: {error}",
	"recipient.needValidAddress": "Enter a valid recipient address first",
	"recipient.saveContact": "Save contact",
	"recipient.editLabel": "Edit label",
	"recipient.labelName": "Label",
	"recipient.labelHint": "e.g. Alice, exchange",
	"recipient.savedOk": "Contact saved",
	"recipient.deleteContact": "Delete contact",
	"recipient.removeRecent": "Remove from recent",
	"recipient.deleteContactMessage": "Delete saved contact “{name}”.",
	"recipient.removeRecentMessage": "Remove this address from recent recipients.",
	"recipient.saveAsContact": "Save as contact",
	"recipient.noSaved": "No saved contacts",
	"recipient.noRecent": "No recent addresses",
	"recipient.hint": "Successful sends are added to recent; tap Save to add a labeled contact.",
	"recipient.contactsTab": "Contacts{count}",
	"recipient.recentTab": "Recent{count}",
	"common.paste": "Paste",
	"common.delete": "Delete",
	"common.new": "New",
	"dapp.connectTitle": "Connect DApp",
	"dapp.connectFailed": "Connection failed",
	"dapp.walletLockedHint": "Wallet is locked. Unlock before connecting.",
	"dapp.signFailed": "Signing failed",
	"dapp.signRequest": "Signature request",
	"dapp.signAndExecute": "Sign & execute",
	"dapp.signOnly": "Sign",
	"mall.payLeading": "Mall",
	"mall.payHighlight": "Pay",
	"mall.amountDueData": "Amount due (DATA)",
	"mall.orderNumber": "Order No.",
	"mall.merchantAddress": "Merchant",
	"mall.payerAddress": "Payer",
	"mall.dataBalance": "DATA balance",
	"mall.confirmPay": "Confirm payment",
	"mall.walletLocked": "Wallet is locked",
	"mall.returnAppFailed": "Could not return to the mall app. Switch manually.",
	"mall.paySuccess": "Payment successful",
	"account.switchTitle": "Switch wallet / account",
	"account.count": "{n} accounts",
	"account.hdAccounts": "HD accounts",
	"account.numbered": "Account {n}",
	"account.inUse": "In use",
	"account.tapToSwitch": "Tap to switch",
	"stake.principalMatured": "Principal matured — redeemable",
	"stake.lockHintWithActive": "Active epoch {activeEpoch} · Unlock epoch {unlockEpoch} · {epochsLeft} epochs left",
	"stake.lockHintUnlockOnly": "Unlock epoch {unlockEpoch} · {epochsLeft} epochs left",
	"stake.poolTokenShare": "Pool token share {amount}",
	"stake.requestEpoch": "Request epoch",
	"stake.claimRewardsBtn": "Claim rewards",
	"stake.redeemPrincipalBtn": "Redeem principal",
	"stake.noValidatorsAvailable": "No validators available",
	"stake.validatorFieldLabel": "Validator",
	"stake.addressLabel": "Address",
	"stake.stakePool": "Stake pool",
	"stake.commission": "Commission",
	"stake.votingPower": "Weight",
	"stake.validatorAddressCopied": "Validator address copied",
	"mall.returnFailed": "Cannot return to mall app — switch manually",
	"mall.titleLeading": "Mall",
	"mall.titleHighlight": "Pay",
	"mall.amountDue": "Amount due (DATA)",
	"bridge.usdtLockedSnack": "USDT locked · tx {digest}",
	"bridge.dgcLockedSnack": "DGC locked · digest {digest}",
	"common.cannotOpenBrowser": "Cannot open browser",
	"tx.explorerLinkFailed": "Failed to open explorer link",
	"bridge.pageTitleHighlight": "Bridge",
	"bridge.walletAccountLine": "{wallet} · {account}",
	"bridge.tabSwap": "Swap",
	"bridge.directionUsdtToDgc": "USDT → DGC",
	"bridge.ethRelayerHint": "ETH withdrawals are settled by the relayer after DGC lock.",
	"bridge.fromBsc": "From (BSC USDT)",
	"bridge.fromDgc": "From (DGC DATA)",
	"bridge.evmRecipientLabel": "{chain} recipient",
	"bridge.lockUsdtToDgc": "Lock USDT → DGC",
	"bridge.lockDgcToTarget": "Lock DGC → {target}",
	"bridge.myBridgeRecords": "My bridge records",
	"bridge.noLocalRecords": "No local bridge records yet",
	"bridge.onChainLocksAccount": "On-chain locks (this account)",
	"bridge.noOnChainLockEvents": "No on-chain lock events",
	"bridge.networkRecentLocks": "Recent network locks",
	"connect.failed": "Connection failed",
	"connect.lockedHint": "Wallet locked — unlock before connecting",
	"sign.failed": "Signing failed",
	"sign.signAndExecute": "Sign and execute",
	"sign.signOnly": "Sign",
	"recipient.noSavedContacts": "No saved contacts",
	"recipient.noRecentAddresses": "No recent addresses",
	"recipient.contacts": "Contacts",
	"recipient.recent": "Recent",
	"receive.dgcOnly": "DGC network assets only",
	"bridge.statusConfirmed": "Confirmed",
	"bridge.introInboundTitle": "Deposit USDT → DATA",
	"bridge.introInboundBody": "Lock BNB-chain USDT in escrow; Relayer mints DATA 1:1 on DGC.",
	"bridge.introOutboundEthBody": "Lock DATA on DGC; Relayer pays USDT on Ethereum.",
	"bridge.introOutboundBscBody": "Lock DATA on DGC; Relayer pays USDT on BNB Chain.",
	"bridge.webVersion": "Web version",
	"bridge.inboundEscrowUnavailable": "BSC escrow unavailable — check bridge config.",
	"bridge.balanceWithAmount": "Balance {amount}",
	"bridge.exchangeRate": "Exchange rate",
	"bridge.exchangeRateValue": "1 DATA ≈ {rate} USDT",
	"bridge.bscInbound": "BSC inbound",
	"bridge.ethOutbound": "ETH outbound",
	"bridge.statusReady": "Ready",
	"bridge.txIdLabel": "Tx ID",
	"bridge.txIdCopied": "Tx ID copied",
	"bridge.copyTxId": "Copy Tx ID",
	"trade.unlockToViewOrders": "Unlock wallet to view orders",
	"trade.partialQtyLine": "Filled {filled} / {total}",
	"trade.orderHistoryLine": "{side} · {qty} @ {price}",
	"trade.fillQtyLine": "{qty} DGC",
	"trade.estimateSpendAmount": "Est. cost {amount} DATA",
	"trade.estimateReceiveAmount": "Est. receive {amount} DATA",
	"receive.imageRenderFailed": "Could not generate image",
	"receive.imageEncodeFailed": "Image encode failed",
	"recipient.validRequired": "Enter a valid recipient address first",
	"recipient.contactSaved": "Contact saved",
	"recipient.removeFromHistory": "Remove from recent",
	"recipient.deleteSavedMessage": "Delete contact {name}?",
	"recipient.hintEmpty": "Paste an address or pick a contact",
	"tx.computationCost": "Computation",
	"tx.storageCost": "Storage",
	"tx.storageRebate": "Rebate",
	"tx.onChainDetail": "On-chain details",
	"tx.noDigest": "No on-chain digest",
	"tx.copyDigest": "Copy digest",
	"trade.marketLoadFailed": "Failed to load market. Please try again later.",
	"bridge.tabRecords": "Records",
	"bridge.directionDgcWithdraw": "DGC withdraw",
	"bridge.introOutboundTitle": "Withdraw DATA → EVM",
	"bridge.statusNotConfigured": "Not configured",
	"wallet.shellSubtitle": "Address balance · staking · custom networks",
	"wallet.totalBalanceLine": "Total {total} DGC · {chain}",
	"trade.clobToken": "CLOB token",
	"trade.openOrderMeta": "{time} · Order {qty} DGC · Remaining {remaining} DGC",
	"trade.orderTimeQtyLine": "{time} · Qty {qty}",
	"trade.fillTimeQtyLine": "{time} · Qty {qty} DGC",
	"qr.title": "Scan",
	"qr.flashlight": "Flashlight",
	"qr.unrecognized": "Unrecognized: scan mall pay code or a DGC receive address",
	"qr.hint": "Supports mall pay codes (fixed DATA amount) or DGC receive addresses",
	"home.multiChainAssets": "Multi-chain assets",
	"home.refreshBalances": "Refresh balances",
	"home.suiMainnet": "Sui mainnet",
	"home.rpcUnavailable": "RPC unavailable",
	"wallet.addressLabel": "Wallet address",
	"wallet.looseBalance": "Loose",
	"stake.poolBalanceLine": "Pool balance {balance} DGC",
	"depth.liveBook": "Live order book",
	"depth.noData": "No depth data",
	"sign.gasEstimating": "Estimating gas…",
	"dapp.tagOfficial": "Official",
	"dapp.tagRecommended": "Featured",
	"dapp.discover.explorerDesc": "Block explorer · txs & objects",
	"dapp.discover.shopName": "GlobalData Shop",
	"dapp.discover.shopDesc": "Data Global cross-border shop",
	"dapp.openExplorer": "Open DGC Explorer",
	"dapp.quickLinks": "Quick links",
	"dapp.nameLabel": "Name",
	"dapp.urlEmpty": "URL cannot be empty",
	"dapp.urlInvalid": "Invalid URL",
	"dapp.urlAlreadyBookmarked": "URL already in bookmarks",
	"dapp.preconnectSkipped": "DGC preconnect skipped: {error}",
	"dapp.scanQr": "Scan",
	"bridge.historyTitle": "Sejarah rentas rantai",
	"bridge.historySubtitle": "Kedua-dua arah: DATA → USDT dan USDT → DATA",
	"bridge.colDirection": "Arah",
	"bridge.dirDataToUsdt": "DATA → USDT",
	"bridge.dirUsdtToData": "USDT → DATA",
	"bridge.historyNeedWallet": "Sambung DGC Wallet untuk lihat sejarah jambatan alamat ini",
	"bridge.historyOpen": "Rekod saya",
	"bridge.historyBackToBridge": "Kembali ke jambatan",
	"bridge.colTime": "Masa",
	"bridge.historyAddress": "Alamat",
	"bridge.historyAutoRefresh": "Auto-muat semula",
};

const vi: MessageCatalog = {
	"common.language": "Ngôn ngữ",
	"common.network": "Mạng",
	"common.wallet": "Ví",
	"common.cancel": "Hủy",
	"common.confirm": "Xác nhận",
	"common.refresh": "Làm mới",
	"common.loading": "Đang tải…",
	"common.save": "Lưu",
	"common.lock": "Khóa",
	"common.close": "Đóng",
	"common.back": "Quay lại",
	"common.copy": "Sao chép",
	"common.error": "Đã xảy ra lỗi",
	"common.spot": "Giao ngay",
	"common.buy": "Mua",
	"common.sell": "Bán",
	"common.price": "Giá",
	"common.quantity": "Số lượng",
	"common.available": "Khả dụng",
	"common.settings": "Cài đặt",
	"common.detect": "Kiểm tra",
	"nav.dex": "DEX",
	"nav.bridge": "Cầu nối",
	"nav.stake": "Stake",
	"nav.genesis": "Genesis",
	"nav.apps": "Ứng dụng",
	"nav.assets": "Tài sản",
	"nav.send": "Gửi",
	"nav.trade": "Giao dịch",
	"nav.network": "Mạng",
	"nav.dapp": "DApp",
	"nav.crossChain": "Cross-chain",
	"nav.market": "Thị trường",
	"explorer.title": "DGC Explorer",
	"explorer.tagline": "Explorer",
	"wallet.title": "DGC Wallet",
	"wallet.tagline": "Mainnet · số dư địa chỉ · staking",
	"wallet.welcome": "Chào mừng đến DGC Wallet",
	"wallet.welcomeDesc": "Đặt mật khẩu tiện ích để bảo vệ ví của bạn.",
	"wallet.unlock": "Mở khóa ví",
	"wallet.unlockDesc": "Nhập mật khẩu tiện ích để sử dụng ví.",
	"wallet.password": "Mật khẩu tiện ích",
	"wallet.passwordConfirm": "Xác nhận mật khẩu",
	"wallet.passwordPlaceholder": "Ít nhất 8 ký tự",
	"wallet.rememberUnlock": "Giữ mở khóa",
	"wallet.create": "Tạo ví",
	"wallet.import": "Nhập ví",
	"wallet.generateMnemonic": "Tạo cụm từ khôi phục",
	"wallet.mnemonic": "Cụm từ (12 / 24 từ)",
	"wallet.privateKey": "Khóa riêng",
	"wallet.backupTitle": "Sao lưu cụm từ",
	"wallet.backupDesc": "Ghi lại ở nơi an toàn. Mất khóa sẽ không khôi phục được.",
	"wallet.backupAck": "Tôi đã sao lưu an toàn cụm từ",
	"wallet.backupDone": "Hoàn tất tạo",
	"wallet.addressBalance": "Số dư địa chỉ",
	"wallet.totalBalance": "Tổng số dư",
	"wallet.lockNow": "Khóa ví ngay",
	"wallet.export": "Xuất ví",
	"wallet.security": "Bảo mật ví",
	"wallet.autoLock": "Tự động khóa",
	"wallet.connectedSites": "Trang đã kết nối",
	"wallet.txHistory": "Lịch sử giao dịch",
	"wallet.noTx": "Chưa có giao dịch",
	"wallet.loadingWallet": "Đang tải ví…",
	"trade.pair": "DGC / DATA",
	"trade.buyDgc": "Mua DGC",
	"trade.sellDgc": "Bán DGC",
	"trade.limitPrice": "Giá giới hạn",
	"trade.quantity": "Số lượng",
	"trade.estimateSpend": "Ước tính chi — DATA",
	"trade.estimateReceive": "Ước tính nhận — DATA (sau phí)",
	"trade.bids": "Mua",
	"trade.asks": "Bán",
	"trade.marketTrades": "Giao dịch thị trường",
	"trade.myTrades": "Giao dịch của tôi",
	"trade.openOrders": "Lệnh mở",
	"trade.priceData": "Giá (DATA)",
	"trade.qtyDgc": "SL (DGC)",
	"trade.lastPrice": "Giá mới nhất",
	"trade.loadingMarket": "Đang tải thị trường…",
	"trade.refresh": "Làm mới thị trường",
	"sign.request": "Yêu cầu ký",
	"sign.approve": "Duyệt & ký",
	"sign.reject": "Từ chối",
	"connect.request": "Yêu cầu kết nối",
	"connect.approve": "Cho phép kết nối",
	"connect.reject": "Từ chối",
	"connect.desc": "Trang này có thể xem địa chỉ DGC và yêu cầu chữ ký. Thu hồi bất cứ lúc nào trong Mạng → Trang đã kết nối.",
	"language.title": "Ngôn ngữ",
	"language.subtitle": "Chọn ngôn ngữ hiển thị. Mặc định là English.",
	"settings.networkRpc": "Mạng & RPC",
	"settings.walletSecurity": "Bảo mật ví",
	"settings.walletManage": "Quản lý ví",
	"settings.connectedDapps": "DApp đã kết nối",
	"common.time": "Thời gian",
	"common.side": "Phía",
	"common.action": "Thao tác",
	"common.status": "Trạng thái",
	"common.account": "Tài khoản",
	"common.amount": "Số lượng",
	"common.max": "Tất cả",
	"common.empty": "Trống",
	"common.submitting": "Đang gửi…",
	"common.connectWallet": "Kết nối ví",
	"common.disconnect": "Ngắt kết nối",
	"common.connecting": "Đang kết nối…",
	"common.loadMore": "Tải thêm",
	"common.all": "Tất cả",
	"common.balance": "Số dư",
	"common.spread": "Chênh lệch",
	"trade.orderBook": "Sổ lệnh",
	"trade.recentTrades": "Giao dịch gần đây",
	"trade.orderHistory": "Lịch sử lệnh",
	"trade.tradeHistory": "Lịch sử giao dịch",
	"trade.bestBid": "Giá mua",
	"trade.bestAsk": "Giá bán",
	"trade.change24h": "Biến động 24h",
	"trade.volume24h": "KL 24h",
	"trade.turnover24h": "Doanh thu 24h",
	"trade.trades24h": "Số GD 24h",
	"trade.noTrades": "Chưa có giao dịch",
	"trade.cancelOrder": "Hủy",
	"trade.cancelling": "Đang hủy…",
	"trade.noOpenOrders": "Không có lệnh mở",
	"trade.noOrderHistory": "Không có lịch sử lệnh",
	"trade.connectToViewOrders": "Kết nối ví để xem lệnh mở",
	"trade.statusOpen": "Đang mở",
	"trade.statusFilled": "Đã khớp",
	"trade.statusCancelled": "Đã hủy",
	"trade.statusPartial": "Khớp một phần",
	"trade.invalidPrice": "Giá giới hạn không hợp lệ",
	"trade.enterQty": "Nhập số lượng DGC",
	"trade.qtyPositive": "Số lượng phải là số nguyên dương",
	"trade.bidSubmitted": "Đã gửi lệnh mua",
	"trade.askSubmitted": "Đã gửi lệnh bán",
	"trade.cancelSubmitted": "Đã gửi hủy lệnh",
	"trade.remaining": "Còn lại",
	"trade.orderId": "Mã lệnh",
	"trade.taker": "Bên chủ động",
	"trade.noClob": "Chưa cấu hình CLOB",
	"wallet.connect": "Kết nối DGC Wallet",
	"wallet.notDetected": "Không tìm thấy DGC Wallet",
	"wallet.downloadExt": "Tải tiện ích DGC Wallet",
	"wallet.downloadApp": "Tải DGC Wallet",
	"wallet.appsCenter": "Trung tâm ứng dụng",
	"wallet.wrongWallet": "Vui lòng kết nối DGC Wallet",
	"wallet.disconnecting": "Đang ngắt…",
	"wallet.viewBalance": "Kết nối DGC Wallet để xem số dư",
	"send.recipient": "Người nhận",
	"send.confirm": "Xác nhận gửi",
	"send.token": "Token",
	"stake.selectValidator": "Chọn validator",
	"stake.amount": "Số lượng stake",
	"stake.myStakes": "Stake của tôi",
	"stake.stakeDgc": "Stake DGC",
	"stake.noStakes": "Chưa có stake",
	"stake.refreshValidators": "Làm mới",
	"trade.orderQty": "KL lệnh",
	"trade.noTradeHistory": "Chưa có lịch sử giao dịch",
	"trade.remainingShort": "còn",
	"trade.clickFillPrice": "Bấm để điền giá giới hạn",
	"trade.klineWindow": "Cửa sổ biểu đồ",
	"trade.open24h": "Mở 24h",
	"trade.high24h": "Cao 24h",
	"trade.low24h": "Thấp 24h",
	"trade.volume24hDgc": "KL 24h (DGC)",
	"trade.txExpired": "Giao dịch hết hạn, vui lòng thử lại",
	"trade.balanceLabel": "Số dư {symbol}",
	"wallet.connectFirst": "Vui lòng kết nối DGC Wallet trước",
	"wallet.notFoundAlert": "Không tìm thấy tiện ích DGC Wallet. Cài đặt, bật rồi làm mới trang.",
	"wallet.installHint": "Cài tiện ích Chrome, hoặc mở trang này trong trình duyệt APP DGC Wallet.",
	"wallet.siteEnabledHint": "Trang hiện tại {origin}. Sau khi cài, bật trong chrome://extensions và làm mới.",
	"wallet.notDetectedExt": "Không phát hiện tiện ích DGC Wallet",
	"send.success": "Gửi thành công",
	"send.availableDash": "Khả dụng —",
	"send.uxHint": "Ưu tiên số dư địa chỉ; gas trả từ số dư địa chỉ DGC",
	"send.addCustomToken": "Thêm token CLOB tùy chỉnh",
	"send.symbol": "Ký hiệu",
	"send.typeTag": "TypeTag",
	"send.decimals": "Số thập phân",
	"send.saveToList": "Lưu vào danh sách",
	"stake.submitted": "Đã gửi stake",
	"stake.success": "Stake thành công",
	"stake.confirmTitle": "Xác nhận stake",
	"stake.confirmAction": "Xác nhận stake",
	"stake.selectValidatorLabel": "Chọn validator",
	"stake.positions": "Vị thế stake",
	"stake.noPositions": "Chưa có vị thế stake",
	"stake.lockHintShort": "Khóa gốc 180 epoch. Có thể nhận thưởng bất kỳ lúc nào; rút gốc sau khi mở khóa.",
	"stake.newStake": "Stake mới",
	"stake.enterAmount": "Nhập số lượng stake",
	"stake.confirmMessage": "Stake {amount} DGC vào validator đã chọn.\nKhóa gốc 180 epoch; có thể nhận thưởng bất kỳ lúc nào.",
	"stake.claimRewards": "Nhận thưởng stake",
	"stake.redeemPrincipal": "Rút gốc stake",
	"stake.noPositionCount": "Chưa có vị thế",
	"stake.positionCount": "{count} vị thế",
	"apps.title": "Ứng dụng",
	"apps.titleSuffix": "/ Hệ sinh thái",
	"apps.subtitle": "Truy cập ứng dụng DGC: Global Shop, RWAX Super App, DGC Wallet và công cụ on-chain.",
	"apps.mobileSubtitle": "Global Shop · RWAX · DGC Wallet",
	"apps.viewAccount": "Xem tài khoản →",
	"apps.featured": "Ứng dụng nổi bật",
	"apps.scanDownload": "Quét để tải",
	"apps.scanDownloadApk": "Quét tải APK",
	"apps.scanDownloadRwax": "Quét tải RWAX",
	"apps.mirrorDownload": "Tải dự phòng",
	"apps.chromeExt": "Tiện ích Chrome",
	"apps.globalShop": "Global Shop",
	"apps.globalShopDesc": "Thương mại xuyên biên giới Data Global, đa ngôn ngữ và đa tiền tệ. Duyệt thời trang và thương hiệu; thanh toán bằng DGC Wallet.",
	"apps.openGlobalShop": "Mở Global Shop",
	"apps.tagEcommerce": "Thương mại",
	"apps.globalShopApp": "Global Shop APP",
	"apps.globalShopAppDesc": "Ứng dụng Global Shop trên di động — mua sắm, theo dõi đơn và khuyến mãi. Quét QR để cài.",
	"apps.downloadGlobalShopApp": "Tải Global Shop APP",
	"apps.tagMobile": "Di động",
	"apps.walletDesc": "Ví gốc DGC: quản lý tài sản và ký giao dịch DApp. Cài APK Android qua tải, gương hoặc QR; có tiện ích Chrome.",
	"apps.tagWallet": "Ví",
	"apps.rwaxDesc": "RWAX Super App: ví đa chuỗi, mạng xã hội, trình duyệt DApp và trình duyệt chính thức DGC. Nhập dgcprivkey / mnemonic; mặc định hệ sinh thái DGC.",
	"apps.downloadRwax": "Tải RWAX",
	"apps.tagSuperApp": "Super App",
	"apps.onchainShortcuts": "Lối tắt on-chain",
	"apps.dexTrade": "Giao dịch DEX",
	"apps.dexTradeDesc": "Giao dịch spot DGC",
	"apps.bridge": "Cầu nối",
	"apps.bridgeDesc": "BNB USDT ↔ DATA (1:1)",
	"apps.stake": "Stake",
	"apps.stakeDesc": "Ủy thác validator và nhận thưởng",
	"apps.explorer": "Trình khám phá khối",
	"apps.explorerDesc": "Tra cứu tx và địa chỉ",
	"apps.myStatus": "Trạng thái on-chain",
	"apps.totalBalance": "Tổng số dư",
	"apps.viewAddress": "Xem địa chỉ",
	"apps.connectToSeeBalance": "Kết nối DGC Wallet để xem số dư",
	"stake.pageTitle": "Stake",
	"stake.pageSubtitle": "Ủy thác DGC cho validator, bảo mật mạng và nhận thưởng. Số lượng tính bằng DGC (1 DGC = 10⁹ MIST).",
	"stake.epochProgress": "Tiến độ epoch",
	"stake.currentEpoch": "Epoch hiện tại",
	"stake.epochCycleAbout": "Chu kỳ ~ {duration}",
	"stake.latestCheckpoint": "Checkpoint mới nhất",
	"stake.checkpointHint": "Tham chiếu tiến độ on-chain",
	"stake.connectHint": "Kết nối DGC Wallet ở thanh bên để xem số dư, vị thế và stake.",
	"stake.staked": "Đã stake",
	"stake.viewAccount": "Xem chi tiết tài khoản",
	"stake.delegationDetails": "Chi tiết ủy thác",
	"stake.tipGas": "• Stake và gas dùng DGC gốc; giữ một ít số dư cho phí.",
	"stake.tipUnlock": "• Unstake chờ chu kỳ mở khóa epoch (xem lock_until_epoch).",
	"stake.tipLeaderboard": "• Xếp hạng pool validator ở Leaderboards trang chủ; xếp hạng người dùng cần Indexer.",
	"stake.validatorsNetwork": "Mạng validator",
	"stake.networkStake": "Stake {symbol} toàn mạng",
	"stake.networkStakeTip": "Tổng DGC được stake bởi validator và người ủy thác",
	"stake.avgDailyYield": "Lợi suất ngày TB",
	"stake.avgDailyYieldTip": "APY validator ÷ 365; ước tính từ trợ cấp khi mẫu ít",
	"stake.lastEpochReward": "Thưởng epoch trước",
	"stake.lastEpochRewardTip": "Tổng thưởng stake các pool epoch trước",
	"stake.activeValidators": "Validator hoạt động",
	"stake.activeValidatorsTip": "Số validator hoạt động trong epoch hiện tại",
	"stake.validatorMap": "Bản đồ validator",
	"stake.mapLoading": "Đang tải bản đồ…",
	"stake.allValidators": "Tất cả validator",
	"stake.validatorsLoadFailed": "Không tải được dữ liệu validator",
	"stake.colName": "Tên",
	"stake.colStake": "Stake",
	"stake.colDaily": "Ngày",
	"stake.epochLoading": "Đang tải tiến độ epoch…",
	"stake.epochProgressOf": "Tiến độ epoch {epoch}",
	"stake.remaining": "còn lại",
	"stake.lockProgress": "Tiến độ mở khóa gốc",
	"stake.noDelegations": "Chưa có ủy thác",
	"stake.fungibleCert": "Chứng chỉ fungible",
	"stake.claimable": "Có thể nhận",
	"stake.activeEpoch": "Epoch kích hoạt",
	"stake.unlockEpoch": "Epoch mở khóa",
	"stake.epochsLeft": "Epoch còn lại",
	"stake.lockPeriod": "Kỳ khóa",
	"stake.claimableRewards": "Thưởng có thể nhận",
	"stake.principalUnlocked": "Gốc đã mở khóa — có thể rút",
	"stake.redeemAfterUnlock": "Rút sau khi mở khóa (Epoch {epoch})",
	"genesis.title": "Phát hành genesis",
	"genesis.subtitle": "Phân bổ genesis DGC công khai để cộng đồng giám sát. Tổng {total} (coin chính {symbol}). Nhấn địa chỉ để xem số dư on-chain.",
	"genesis.mobileSubtitle": "Phân bổ genesis",
	"genesis.supplyCheck": "Đối chiếu tổng",
	"genesis.totalSupply": "Tổng genesis",
	"genesis.tableSum": "Tổng bảng phân bổ",
	"genesis.equalsTotal": "Khớp tổng",
	"genesis.notEqualsTotal": "Không khớp tổng",
	"genesis.liveValidators": "Validator đang hoạt động",
	"genesis.reading": "Đang tải…",
	"genesis.unavailable": "Không khả dụng",
	"genesis.expected": "dự kiến {count}",
	"genesis.compareConfig": "So với cấu hình genesis (đã kết nối RPC)",
	"genesis.allocationDetail": "Chi tiết phân bổ",
	"genesis.allocationIntro": "“Phân bổ genesis” là số kế hoạch, không phải số dư realtime. Mở địa chỉ để xem nắm giữ thực. Bốn pool ",
	"genesis.linear10yStrong": "tuyến tính 10 năm",
	"genesis.allocationIntro2": " được nạp vào ",
	"genesis.allocationIntro3": " on-chain sau bootstrap và claim tuyến tính; hệ sinh thái nền tảng không vesting. “Khóa stake” là self-stake validator.",
	"genesis.colPurpose": "Mục đích",
	"genesis.colAmount": "Phân bổ genesis (DGC)",
	"genesis.colPct": "Tỷ lệ",
	"genesis.colVesting": "Quy tắc mở / khóa",
	"genesis.colAddress": "Địa chỉ pool (số dư on-chain)",
	"genesis.seeStakePage": "Xem trang validator / stake",
	"genesis.pendingSync": "Chờ đồng bộ",
	"genesis.total": "Tổng",
	"genesis.footerHint": "Số dư pool có thể vẫn là Coin. Sau bootstrap-vesting, mở trang địa chỉ pool để xem claimable, tiến độ, lịch sử và claim bằng ví tương ứng.",
	"genesis.poolAddressPage": "trang địa chỉ pool",
	"genesis.vesting.linear_10y": "Tuyến tính 10 năm",
	"genesis.vesting.none": "Không khóa (lưu thông)",
	"genesis.vesting.system": "Pool hệ thống",
	"genesis.vesting.self_stake": "Khóa stake {epochs} epoch",
	"genesis.hint.linear_10y": "vesting::linear::Wallet on-chain; claim theo thời gian. Mở trang địa chỉ pool để claim. Trước bootstrap có thể vẫn là Coin.",
	"genesis.hint.none": "Không vesting on-chain; chuyển theo quy tắc vận hành",
	"genesis.hint.system": "Chi trả theo tham số trợ cấp epoch, không phải số dư địa chỉ thường",
	"genesis.hint.self_stake": "Trong pool stake validator; chịu ràng buộc epoch mở khóa",
	"genesis.pool.community": "Cộng đồng",
	"genesis.pool.communityNote": "Tuyến tính 10 năm; bootstrap nạp Wallet sau mint genesis",
	"genesis.pool.foundation": "Quỹ",
	"genesis.pool.foundationNote": "Khóa on-chain tuyến tính 10 năm",
	"genesis.pool.tech_support": "Hỗ trợ kỹ thuật",
	"genesis.pool.tech_supportNote": "Khóa on-chain tuyến tính 10 năm",
	"genesis.pool.platform_ecosystem": "Hệ sinh thái nền tảng",
	"genesis.pool.platform_ecosystemNote": "Không vesting; vận hành / lưu thông (multisig)",
	"genesis.pool.user_rewards": "Thưởng người dùng",
	"genesis.pool.user_rewardsNote": "Khóa on-chain tuyến tính 10 năm",
	"genesis.pool.validators": "Self-stake validator genesis",
	"genesis.pool.validatorsNote": "{count} validator × {each} DGC; khóa gốc {epochs} epoch",
	"genesis.pool.stake_subsidy_fund": "Quỹ trợ cấp stake",
	"genesis.pool.stake_subsidy_fundNote": "Pool trợ cấp hệ thống (genesis tới 0x0)",
	"bridge.subtitle": "Tài sản cầu nối là DATA (không phải DGC), tỷ lệ 1:1. Phía BSC là Binance-Peg USDT chính thức; phía DGC là DATA. Relayer tự quyết toán.",
	"bridge.mobileSubtitle": "DATA ↔ BNB USDT · 1:1",
	"bridge.buyTitle": "Mua DATA bằng BNB USDT",
	"bridge.sellTitle": "Bán DATA lấy BNB USDT",
	"bridge.balance": "Số dư",
	"bridge.toReceiveData": "Đến (DATA ước tính)",
	"bridge.toReceiveUsdt": "Đến (BNB USDT ước tính)",
	"bridge.fromLockData": "Từ (khóa DATA)",
	"bridge.cpcRecipient": "Địa chỉ nhận chuỗi DGC",
	"bridge.bscRecipient": "Địa chỉ nhận BNB USDT",
	"bridge.recipientPlaceholder": "Nhập địa chỉ 0x… hoặc D…",
	"bridge.currentWallet": "Ví hiện tại",
	"bridge.connectBscFirst": "Hãy kết nối ví BSC trước",
	"bridge.connectCpcFirst": "Hãy kết nối DGC Wallet trước",
	"bridge.switchMainnet": "Chuyển sang BSC mainnet",
	"bridge.escrowMissing": "Hợp đồng escrow chưa triển khai",
	"bridge.lockUsdtToData": "Khóa {amount} {usdt} → DATA",
	"bridge.lockDataToUsdt": "Khóa {amount} {data} → {usdt}",
	"bridge.bscBusy": "Đang tương tác hợp đồng BSC…",
	"bridge.cpcBusy": "Đang gửi giao dịch…",
	"bridge.dataBridgeStatus": "Trạng thái cầu DATA",
	"bridge.treasuryLocked": "Kho đã khóa",
	"bridge.gatewayRpc": "RPC gateway",
	"bridge.detecting": "Đang kiểm tra",
	"bridge.bnbUsdtStatus": "Trạng thái BNB / USDT",
	"bridge.targetNetwork": "Mạng đích",
	"bridge.usdtContract": "Hợp đồng BNB USDT",
	"bridge.escrow": "Escrow",
	"bridge.configMissing": "Chưa cấu hình",
	"bridge.nodeStatus": "Trạng thái node",
	"bridge.networkMatch": "Mạng khớp",
	"bridge.switchNetwork": "Hãy đổi mạng",
	"bridge.notConnected": "Chưa kết nối",
	"bridge.recentLocks": "Khóa DATA gần đây",
	"bridge.forUsdt": "→ đổi BNB USDT",
	"bridge.noLocks": "Chưa có bản ghi khóa cầu trên mạng này",
	"bridge.colAmount": "Số khóa",
	"bridge.colEstimate": "Ước nhận",
	"bridge.colRecipient": "Người nhận",
	"bridge.colAction": "Thao tác",
	"bridge.details": "Chi tiết →",
	"bridge.showRecent5": "Hiển thị 5 gần nhất",
	"bridge.refreshStatus": "Làm mới trạng thái",
	"bridge.backHome": "← Về trang chủ",
	"bridge.noConfig": "Chưa thấy cấu hình cầu. Deploy Bridge on-chain rồi chạy ./cpc.sh stack start hoặc fetch-stack-config.",
	"bridge.connectMetaMask": "Kết nối MetaMask",
	"bridge.installEvm": "Cài MetaMask hoặc ví EVM khác",
	"bridge.connectBsc": "Kết nối ví BSC",
	"bridge.noEvm": "Không phát hiện ví EVM",
	"bridge.disconnect": "Ngắt kết nối",
	"bridge.ok": "OK",
	"bridge.fail": "Lỗi",
	"bridge.processing": "Đang xử lý…",
	"bridge.useCurrent": "Dùng hiện tại",
	"bridge.needBscRecipient": "Nhập hoặc kết nối địa chỉ nhận BSC",
	"bridge.needCpcRecipient": "Nhập địa chỉ nhận chuỗi DGC",
	"bridge.escrowDeployHint": "Chưa cấu hình Escrow: deploy CpcUsdtEscrow trên BSC mainnet trước",
	"bridge.mainnetTokenOnly": "Cấu hình hiện dùng token BSC mainnet; bỏ chọn testnet",
	"bridge.lockedDataOk": "Đã khóa {amount} {data}; relayer sẽ trả ~{usdtAmount} {usdt} tới {recipient}…",
	"bridge.lockedUsdtOk": "Đã khóa {amount} {usdt} → DATA (BSC tx {tx}…)",
	"bridge.noConfigLocalTitle": "Phát triển local: deploy Bridge trước:",
	"bridge.noConfigSource": "Nguồn cấu hình: Push Hub /v1/stack-config (dự phòng offline docs/generated/cpc-stack-config.json).",
	"send.titleLeading": "On-chain",
	"send.badge": "On-chain transfer",
	"send.fail": "Transfer failed",
	"send.listSaved": "Saved to list",
	"send.recipientRequired": "Enter recipient address",
	"send.amountRequired": "Enter amount",
	"send.amountInvalid": "Invalid amount",
	"send.tokenPreset": "Default",
	"send.tokenCustom": "Custom",
	"send.balanceLine": "Available {balance} {symbol} (address balance) · Total {total}",
	"send.balanceLooseSuffix": " · Loose {loose}",
	"send.decimalsHint": "Decimals (default 9)",
	"home.titleLeading": "My",
	"home.bridgeTitle": "Cross-chain bridge USDT ↔ DGC",
	"home.bridgeSubtitle": "BSC deposit · DGC withdraw to BSC / ETH",
	"common.loadMoreFailed": "Failed to load more",
	"wallet.consolidateSkipped": "No merge needed (no loose coins)",
	"wallet.consolidateDone": "Merge complete",
	"wallet.consolidateLoose": "Merge loose DGC",
	"wallet.looseCoinHint": "You have {amount} DGC in loose coins; merge into address balance before large transfers.",
	"wallet.addressCopied": "Address copied",
	"wallet.addressUnavailable": "Address unavailable",
	"time.relativeDays": "{n} days ago",
	"time.relativeHours": "{n} hours ago",
	"time.relativeMinutes": "{n} minutes ago",
	"time.justNow": "Just now",
	"tx.direction.sent": "Sent",
	"tx.direction.received": "Received",
	"tx.direction.other": "Other",
	"tx.status.success": "Success",
	"tx.status.failure": "Failed",
	"tx.status.unknown": "Unknown",
	"tx.detailLeading": "Transaction",
	"tx.detailHighlight": "details",
	"tx.explorerMissing": "Explorer URL not configured",
	"tx.linkCopied": "Link copied",
	"settings.probing": "Probing…",
	"settings.rpcReachable": "RPC reachable · Chain {chain}",
	"settings.rpcSaved": "RPC saved",
	"settings.addedSwitched": "Added and switched",
	"settings.lockPrefsSaved": "Lock settings saved",
	"settings.exportTitle": "Export wallet",
	"settings.backupInfo": "Backup info",
	"settings.exportNoMnemonic": "(Imported via private key — no mnemonic)\n\nPrivate key:\n{pk}\n\nAddress:\n{addr}",
	"settings.exportWithMnemonic": "Mnemonic:\n{mn}\n\nPrivate key:\n{pk}\n\nAddress:\n{addr}",
	"settings.lockTitle": "Lock wallet",
	"settings.lockMessage": "You will need to enter your password again after locking.",
	"settings.lockNowAction": "Lock now",
	"settings.lockBrowserOnly": "Browser close only",
	"settings.lockMinutes": "{n} minutes",
	"settings.lock1h": "1 hour",
	"settings.lock8h": "8 hours",
	"settings.networkTitleLeading": "Network",
	"settings.networkTitleHighlight": "& RPC",
	"settings.currentNetwork": "Current network",
	"settings.currentNetworkRpc": "Current network RPC",
	"settings.saveRpc": "Save RPC",
	"settings.addCustomNetwork": "Add custom network",
	"settings.networkName": "Name",
	"settings.walletChainOptional": "Wallet chain (optional)",
	"settings.probeRpc": "Probe RPC",
	"settings.addAndSwitch": "Add & switch",
	"settings.noCustomNetwork": "No custom networks",
	"settings.securityTitleLeading": "Wallet",
	"settings.securityTitleHighlight": "security",
	"settings.rememberUnlockDefault": "Check “Stay unlocked” by default",
	"settings.currentLock": "Current: {label}",
	"settings.saveLockPrefs": "Save lock settings",
	"settings.connectedTitleLeading": "Connected",
	"settings.noConnectedSites": "No connected sites",
	"dapp.titleHighlight": "Browser",
	"dapp.tabDiscover": "Discover",
	"dapp.tabBrowser": "Browse",
	"dapp.tabHistory": "History",
	"dapp.vconsoleEnabled": "vConsole enabled",
	"dapp.vconsoleDisabled": "vConsole disabled",
	"dapp.vconsoleEnabledHint": "vConsole enabled (green button bottom-right)",
	"dapp.vconsoleClose": "Turn off vConsole",
	"dapp.vconsoleOpen": "Turn on vConsole",
	"dapp.requestFailed": "DApp request failed: {error}",
	"dapp.addTitle": "Add DApp",
	"dapp.urlLabel": "URL",
	"dapp.addedToMy": "Added to My DApps",
	"dapp.deleteBookmarkTitle": "Delete bookmark",
	"dapp.deleteBookmarkMessage": "Remove \"{name}\"?",
	"dapp.deleteConfirm": "Delete",
	"dapp.clearHistoryTitle": "Clear history",
	"dapp.clearHistoryMessage": "Clear all browsing history?",
	"dapp.clearConfirm": "Clear",
	"dapp.searchHint": "Search or enter DApp URL",
	"dapp.addDapp": "Add DApp",
	"dapp.recommended": "Recommended DApps",
	"dapp.noRecommended": "No recommendations",
	"dapp.myBookmarks": "My bookmarks",
	"dapp.customAdd": "Custom add",
	"dapp.noBookmarksYet": "No bookmarks yet. Add your favorite DApps.",
	"dapp.presetTag": "Preset",
	"dapp.browsingHistory": "Browsing history",
	"dapp.noBrowsingHistory": "No browsing history",
	"dapp.add": "Add",
	"dapp.goBack": "Go back",
	"dapp.goForward": "Go forward",
	"dapp.collapseBookmarks": "Collapse bookmarks",
	"dapp.expandBookmarks": "Expand bookmarks",
	"dapp.urlInputHint": "Enter or paste URL",
	"dapp.go": "Go",
	"dapp.bookmarkCurrentPage": "Bookmark this page",
	"dapp.webViewInitializing": "Initializing WebView…",
	"common.retry": "Retry",
	"wallet.myWallets": "My wallets",
	"wallet.listCount": "{n}",
	"wallet.importNew": "Import new wallet",
	"wallet.importLocalHint": "Keys are stored encrypted locally only. Do not screenshot or share.",
	"wallet.nameOptional": "Wallet name (optional)",
	"wallet.mnemonicHint": "12 / 24 words, space-separated",
	"wallet.privateKeyHint": "dgcprivkey1… or 64-char hex / Base64",
	"wallet.confirmImport": "Confirm import",
	"wallet.enterPrivateKey": "Enter private key",
	"wallet.enterMnemonic": "Enter mnemonic",
	"wallet.added": "Wallet added",
	"wallet.currentAccount": "Current account",
	"wallet.currentBadge": "Current",
	"wallet.hdAccountCount": "{n} HD accounts",
	"wallet.exportMnemonic": "Export mnemonic",
	"wallet.exportPrivateKey": "Export private key",
	"wallet.exportPasswordTitle": "Verify security password",
	"wallet.exportPasswordHint": "Enter your extension password to continue. Never share the secret.",
	"wallet.exportPasswordEmpty": "Enter the extension password",
	"wallet.exportWarning": "Anyone with this can control your assets. Do not screenshot or send it.",
	"wallet.exportCopied": "Copied",
	"wallet.noMnemonicToExport": "This wallet was imported from a private key and has no mnemonic",
	"wallet.exportVerify": "Verify",
	"stake.confirmClaimMessage": "Rewards credit to address balance (not loose coins).\nEstimated rewards {amount} DGC",
	"stake.confirmRedeemMessage": "About {amount} DGC principal will credit to address balance.\nThis cannot be undone.",
	"stake.redeemSuccess": "Principal redeemed",
	"stake.claimSuccess": "Rewards claimed",
	"stake.networkStakeBadge": "Network stake",
	"stake.validatorPoolTotalCaption": "Total DGC in validator pools",
	"stake.avgCommission": "Avg commission",
	"stake.lockedPrincipal": "Locked principal",
	"stake.positionValueEst": "Position value (est.)",
	"stake.lockedChip": "Locked",
	"stake.redeemableChip": "Redeemable",
	"stake.unlockedChip": "Matured",
	"stake.statusActive": "Active",
	"stake.statusPending": "Pending activation",
	"stake.principalLabel": "Principal",
	"trade.tabTrade": "Trade",
	"trade.tabMarket": "Market",
	"trade.loadMarketFailed": "Failed to load market. Please try again.",
	"trade.enterQtyShort": "Enter quantity",
	"trade.orderBookUnavailable": "Order book unavailable",
	"trade.noOrdersInBook": "No orders in book",
	"trade.turnover24hData": "24h turnover (DATA)",
	"trade.kline": "Candles",
	"trade.noKlineData": "No candle data",
	"trade.klineLegend": "MA(7) · Volume",
	"trade.fillDetailLeading": "Fill",
	"trade.fillDetailHighlight": "details",
	"trade.noOnchainDigest": "No on-chain digest",
	"trade.copyDigest": "Copy digest",
	"trade.digestCopied": "Digest copied",
	"trade.onchainDetail": "On-chain details",
	"tx.sender": "Sender",
	"tx.checkpoint": "Checkpoint",
	"tx.gasBudget": "Gas budget",
	"tx.computation": "Computation",
	"tx.storage": "Storage",
	"tx.rebate": "Rebate",
	"tx.balanceChanges": "Balance changes",
	"tx.commands": "Commands",
	"tx.digestCopied": "Digest copied",
	"tx.onchainDetail": "On-chain details",
	"receive.title": "Receive",
	"receive.networkOnlyHint": "DGC network assets only",
	"receive.copyAddress": "Copy address",
	"receive.saveImage": "Save image",
	"receive.shareText": "DGC receive address {address}",
	"receive.imageFailed": "Could not generate image",
	"receive.encodeFailed": "Image encode failed",
	"receive.saveFailed": "Save failed: {error}",
	"recipient.needValidAddress": "Enter a valid recipient address first",
	"recipient.saveContact": "Save contact",
	"recipient.editLabel": "Edit label",
	"recipient.labelName": "Label",
	"recipient.labelHint": "e.g. Alice, exchange",
	"recipient.savedOk": "Contact saved",
	"recipient.deleteContact": "Delete contact",
	"recipient.removeRecent": "Remove from recent",
	"recipient.deleteContactMessage": "Delete saved contact “{name}”.",
	"recipient.removeRecentMessage": "Remove this address from recent recipients.",
	"recipient.saveAsContact": "Save as contact",
	"recipient.noSaved": "No saved contacts",
	"recipient.noRecent": "No recent addresses",
	"recipient.hint": "Successful sends are added to recent; tap Save to add a labeled contact.",
	"recipient.contactsTab": "Contacts{count}",
	"recipient.recentTab": "Recent{count}",
	"common.paste": "Paste",
	"common.delete": "Delete",
	"common.new": "New",
	"dapp.connectTitle": "Connect DApp",
	"dapp.connectFailed": "Connection failed",
	"dapp.walletLockedHint": "Wallet is locked. Unlock before connecting.",
	"dapp.signFailed": "Signing failed",
	"dapp.signRequest": "Signature request",
	"dapp.signAndExecute": "Sign & execute",
	"dapp.signOnly": "Sign",
	"mall.payLeading": "Mall",
	"mall.payHighlight": "Pay",
	"mall.amountDueData": "Amount due (DATA)",
	"mall.orderNumber": "Order No.",
	"mall.merchantAddress": "Merchant",
	"mall.payerAddress": "Payer",
	"mall.dataBalance": "DATA balance",
	"mall.confirmPay": "Confirm payment",
	"mall.walletLocked": "Wallet is locked",
	"mall.returnAppFailed": "Could not return to the mall app. Switch manually.",
	"mall.paySuccess": "Payment successful",
	"account.switchTitle": "Switch wallet / account",
	"account.count": "{n} accounts",
	"account.hdAccounts": "HD accounts",
	"account.numbered": "Account {n}",
	"account.inUse": "In use",
	"account.tapToSwitch": "Tap to switch",
	"stake.principalMatured": "Principal matured — redeemable",
	"stake.lockHintWithActive": "Active epoch {activeEpoch} · Unlock epoch {unlockEpoch} · {epochsLeft} epochs left",
	"stake.lockHintUnlockOnly": "Unlock epoch {unlockEpoch} · {epochsLeft} epochs left",
	"stake.poolTokenShare": "Pool token share {amount}",
	"stake.requestEpoch": "Request epoch",
	"stake.claimRewardsBtn": "Claim rewards",
	"stake.redeemPrincipalBtn": "Redeem principal",
	"stake.noValidatorsAvailable": "No validators available",
	"stake.validatorFieldLabel": "Validator",
	"stake.addressLabel": "Address",
	"stake.stakePool": "Stake pool",
	"stake.commission": "Commission",
	"stake.votingPower": "Weight",
	"stake.validatorAddressCopied": "Validator address copied",
	"mall.returnFailed": "Cannot return to mall app — switch manually",
	"mall.titleLeading": "Mall",
	"mall.titleHighlight": "Pay",
	"mall.amountDue": "Amount due (DATA)",
	"bridge.usdtLockedSnack": "USDT locked · tx {digest}",
	"bridge.dgcLockedSnack": "DGC locked · digest {digest}",
	"common.cannotOpenBrowser": "Cannot open browser",
	"tx.explorerLinkFailed": "Failed to open explorer link",
	"bridge.pageTitleHighlight": "Bridge",
	"bridge.walletAccountLine": "{wallet} · {account}",
	"bridge.tabSwap": "Swap",
	"bridge.directionUsdtToDgc": "USDT → DGC",
	"bridge.ethRelayerHint": "ETH withdrawals are settled by the relayer after DGC lock.",
	"bridge.fromBsc": "From (BSC USDT)",
	"bridge.fromDgc": "From (DGC DATA)",
	"bridge.evmRecipientLabel": "{chain} recipient",
	"bridge.lockUsdtToDgc": "Lock USDT → DGC",
	"bridge.lockDgcToTarget": "Lock DGC → {target}",
	"bridge.myBridgeRecords": "My bridge records",
	"bridge.noLocalRecords": "No local bridge records yet",
	"bridge.onChainLocksAccount": "On-chain locks (this account)",
	"bridge.noOnChainLockEvents": "No on-chain lock events",
	"bridge.networkRecentLocks": "Recent network locks",
	"connect.failed": "Connection failed",
	"connect.lockedHint": "Wallet locked — unlock before connecting",
	"sign.failed": "Signing failed",
	"sign.signAndExecute": "Sign and execute",
	"sign.signOnly": "Sign",
	"recipient.noSavedContacts": "No saved contacts",
	"recipient.noRecentAddresses": "No recent addresses",
	"recipient.contacts": "Contacts",
	"recipient.recent": "Recent",
	"receive.dgcOnly": "DGC network assets only",
	"bridge.statusConfirmed": "Confirmed",
	"bridge.introInboundTitle": "Deposit USDT → DATA",
	"bridge.introInboundBody": "Lock BNB-chain USDT in escrow; Relayer mints DATA 1:1 on DGC.",
	"bridge.introOutboundEthBody": "Lock DATA on DGC; Relayer pays USDT on Ethereum.",
	"bridge.introOutboundBscBody": "Lock DATA on DGC; Relayer pays USDT on BNB Chain.",
	"bridge.webVersion": "Web version",
	"bridge.inboundEscrowUnavailable": "BSC escrow unavailable — check bridge config.",
	"bridge.balanceWithAmount": "Balance {amount}",
	"bridge.exchangeRate": "Exchange rate",
	"bridge.exchangeRateValue": "1 DATA ≈ {rate} USDT",
	"bridge.bscInbound": "BSC inbound",
	"bridge.ethOutbound": "ETH outbound",
	"bridge.statusReady": "Ready",
	"bridge.txIdLabel": "Tx ID",
	"bridge.txIdCopied": "Tx ID copied",
	"bridge.copyTxId": "Copy Tx ID",
	"trade.unlockToViewOrders": "Unlock wallet to view orders",
	"trade.partialQtyLine": "Filled {filled} / {total}",
	"trade.orderHistoryLine": "{side} · {qty} @ {price}",
	"trade.fillQtyLine": "{qty} DGC",
	"trade.estimateSpendAmount": "Est. cost {amount} DATA",
	"trade.estimateReceiveAmount": "Est. receive {amount} DATA",
	"receive.imageRenderFailed": "Could not generate image",
	"receive.imageEncodeFailed": "Image encode failed",
	"recipient.validRequired": "Enter a valid recipient address first",
	"recipient.contactSaved": "Contact saved",
	"recipient.removeFromHistory": "Remove from recent",
	"recipient.deleteSavedMessage": "Delete contact {name}?",
	"recipient.hintEmpty": "Paste an address or pick a contact",
	"tx.computationCost": "Computation",
	"tx.storageCost": "Storage",
	"tx.storageRebate": "Rebate",
	"tx.onChainDetail": "On-chain details",
	"tx.noDigest": "No on-chain digest",
	"tx.copyDigest": "Copy digest",
	"trade.marketLoadFailed": "Failed to load market. Please try again later.",
	"bridge.tabRecords": "Records",
	"bridge.directionDgcWithdraw": "DGC withdraw",
	"bridge.introOutboundTitle": "Withdraw DATA → EVM",
	"bridge.statusNotConfigured": "Not configured",
	"wallet.shellSubtitle": "Address balance · staking · custom networks",
	"wallet.totalBalanceLine": "Total {total} DGC · {chain}",
	"trade.clobToken": "CLOB token",
	"trade.openOrderMeta": "{time} · Order {qty} DGC · Remaining {remaining} DGC",
	"trade.orderTimeQtyLine": "{time} · Qty {qty}",
	"trade.fillTimeQtyLine": "{time} · Qty {qty} DGC",
	"qr.title": "Scan",
	"qr.flashlight": "Flashlight",
	"qr.unrecognized": "Unrecognized: scan mall pay code or a DGC receive address",
	"qr.hint": "Supports mall pay codes (fixed DATA amount) or DGC receive addresses",
	"home.multiChainAssets": "Multi-chain assets",
	"home.refreshBalances": "Refresh balances",
	"home.suiMainnet": "Sui mainnet",
	"home.rpcUnavailable": "RPC unavailable",
	"wallet.addressLabel": "Wallet address",
	"wallet.looseBalance": "Loose",
	"stake.poolBalanceLine": "Pool balance {balance} DGC",
	"depth.liveBook": "Live order book",
	"depth.noData": "No depth data",
	"sign.gasEstimating": "Estimating gas…",
	"dapp.tagOfficial": "Official",
	"dapp.tagRecommended": "Featured",
	"dapp.discover.explorerDesc": "Block explorer · txs & objects",
	"dapp.discover.shopName": "GlobalData Shop",
	"dapp.discover.shopDesc": "Data Global cross-border shop",
	"dapp.openExplorer": "Open DGC Explorer",
	"dapp.quickLinks": "Quick links",
	"dapp.nameLabel": "Name",
	"dapp.urlEmpty": "URL cannot be empty",
	"dapp.urlInvalid": "Invalid URL",
	"dapp.urlAlreadyBookmarked": "URL already in bookmarks",
	"dapp.preconnectSkipped": "DGC preconnect skipped: {error}",
	"dapp.scanQr": "Scan",
	"bridge.historyTitle": "Lịch sử cầu nối",
	"bridge.historySubtitle": "Hai chiều: DATA → USDT và USDT → DATA",
	"bridge.colDirection": "Hướng",
	"bridge.dirDataToUsdt": "DATA → USDT",
	"bridge.dirUsdtToData": "USDT → DATA",
	"bridge.historyNeedWallet": "Kết nối DGC Wallet để xem lịch sử cầu nối của địa chỉ này",
	"bridge.historyOpen": "Hồ sơ của tôi",
	"bridge.historyBackToBridge": "Quay lại cầu nối",
	"bridge.colTime": "Thời gian",
	"bridge.historyAddress": "Địa chỉ",
	"bridge.historyAutoRefresh": "Tự làm mới",
};

const th: MessageCatalog = {
	"common.language": "ภาษา",
	"common.network": "เครือข่าย",
	"common.wallet": "กระเป๋า",
	"common.cancel": "ยกเลิก",
	"common.confirm": "ยืนยัน",
	"common.refresh": "รีเฟรช",
	"common.loading": "กำลังโหลด…",
	"common.save": "บันทึก",
	"common.lock": "ล็อก",
	"common.close": "ปิด",
	"common.back": "กลับ",
	"common.copy": "คัดลอก",
	"common.error": "เกิดข้อผิดพลาด",
	"common.spot": "สปอต",
	"common.buy": "ซื้อ",
	"common.sell": "ขาย",
	"common.price": "ราคา",
	"common.quantity": "จำนวน",
	"common.available": "ใช้ได้",
	"common.settings": "การตั้งค่า",
	"common.detect": "ตรวจสอบ",
	"nav.dex": "DEX",
	"nav.bridge": "บริดจ์",
	"nav.stake": "Stake",
	"nav.genesis": "Genesis",
	"nav.apps": "แอป",
	"nav.assets": "สินทรัพย์",
	"nav.send": "ส่ง",
	"nav.trade": "เทรด",
	"nav.network": "เครือข่าย",
	"nav.dapp": "DApp",
	"nav.crossChain": "ข้ามเชน",
	"nav.market": "ตลาด",
	"explorer.title": "DGC Explorer",
	"explorer.tagline": "Explorer",
	"wallet.title": "DGC Wallet",
	"wallet.tagline": "เมนเน็ต · ยอดที่อยู่ · สเตก",
	"wallet.welcome": "ยินดีต้อนรับสู่ DGC Wallet",
	"wallet.welcomeDesc": "ตั้งรหัสผ่านส่วนขยายเพื่อปกป้องกระเป๋าของคุณ",
	"wallet.unlock": "ปลดล็อกกระเป๋า",
	"wallet.unlockDesc": "กรอกรหัสผ่านส่วนขยายเพื่อใช้กระเป๋า",
	"wallet.password": "รหัสผ่านส่วนขยาย",
	"wallet.passwordConfirm": "ยืนยันรหัสผ่าน",
	"wallet.passwordPlaceholder": "อย่างน้อย 8 ตัวอักษร",
	"wallet.rememberUnlock": "คงสถานะปลดล็อก",
	"wallet.create": "สร้างกระเป๋า",
	"wallet.import": "นำเข้ากระเป๋า",
	"wallet.generateMnemonic": "สร้างวลีกู้คืน",
	"wallet.mnemonic": "วลี (12 / 24 คำ)",
	"wallet.privateKey": "คีย์ส่วนตัว",
	"wallet.backupTitle": "สำรองวลีกู้คืน",
	"wallet.backupDesc": "จดไว้ในที่ปลอดภัย หากสูญหายจะกู้คืนไม่ได้",
	"wallet.backupAck": "ฉันสำรองวลีอย่างปลอดภัยแล้ว",
	"wallet.backupDone": "สร้างเสร็จสิ้น",
	"wallet.addressBalance": "ยอดที่อยู่",
	"wallet.totalBalance": "ยอดรวม",
	"wallet.lockNow": "ล็อกกระเป๋าทันที",
	"wallet.export": "ส่งออกกระเป๋า",
	"wallet.security": "ความปลอดภัย",
	"wallet.autoLock": "ล็อกอัตโนมัติ",
	"wallet.connectedSites": "เว็บที่เชื่อมต่อ",
	"wallet.txHistory": "ประวัติธุรกรรม",
	"wallet.noTx": "ยังไม่มีธุรกรรม",
	"wallet.loadingWallet": "กำลังโหลดกระเป๋า…",
	"trade.pair": "DGC / DATA",
	"trade.buyDgc": "ซื้อ DGC",
	"trade.sellDgc": "ขาย DGC",
	"trade.limitPrice": "ราคาจำกัด",
	"trade.quantity": "จำนวน",
	"trade.estimateSpend": "ประมาณการใช้ — DATA",
	"trade.estimateReceive": "ประมาณได้รับ — DATA (หลังค่าธรรมเนียม)",
	"trade.bids": "ฝั่งซื้อ",
	"trade.asks": "ฝั่งขาย",
	"trade.marketTrades": "การเทรดตลาด",
	"trade.myTrades": "การเทรดของฉัน",
	"trade.openOrders": "คำสั่งเปิด",
	"trade.priceData": "ราคา (DATA)",
	"trade.qtyDgc": "จำนวน (DGC)",
	"trade.lastPrice": "ราคาล่าสุด",
	"trade.loadingMarket": "กำลังโหลดตลาด…",
	"trade.refresh": "รีเฟรชตลาด",
	"sign.request": "คำขอลงนาม",
	"sign.approve": "อนุมัติและลงนาม",
	"sign.reject": "ปฏิเสธ",
	"connect.request": "คำขอเชื่อมต่อ",
	"connect.approve": "อนุญาตการเชื่อมต่อ",
	"connect.reject": "ปฏิเสธ",
	"connect.desc": "เว็บไซต์นี้สามารถดูที่อยู่ DGC และขอลงนามได้ ยกเลิกได้ทุกเมื่อที่ เครือข่าย → เว็บที่เชื่อมต่อ",
	"language.title": "ภาษา",
	"language.subtitle": "เลือกภาษาที่ใช้แสดง ค่าเริ่มต้นคือ English",
	"settings.networkRpc": "เครือข่ายและ RPC",
	"settings.walletSecurity": "ความปลอดภัยกระเป๋า",
	"settings.walletManage": "จัดการกระเป๋า",
	"settings.connectedDapps": "DApp ที่เชื่อมต่อ",
	"common.time": "เวลา",
	"common.side": "ฝั่ง",
	"common.action": "การดำเนินการ",
	"common.status": "สถานะ",
	"common.account": "บัญชี",
	"common.amount": "จำนวน",
	"common.max": "ทั้งหมด",
	"common.empty": "ว่าง",
	"common.submitting": "กำลังส่ง…",
	"common.connectWallet": "เชื่อมต่อกระเป๋า",
	"common.disconnect": "ตัดการเชื่อมต่อ",
	"common.connecting": "กำลังเชื่อมต่อ…",
	"common.loadMore": "โหลดเพิ่ม",
	"common.all": "ทั้งหมด",
	"common.balance": "ยอดคงเหลือ",
	"common.spread": "สเปรด",
	"trade.orderBook": "สมุดคำสั่ง",
	"trade.recentTrades": "การเทรดล่าสุด",
	"trade.orderHistory": "ประวัติคำสั่ง",
	"trade.tradeHistory": "ประวัติการเทรด",
	"trade.bestBid": "ราคาซื้อ",
	"trade.bestAsk": "ราคาขาย",
	"trade.change24h": "เปลี่ยนแปลง 24 ชม.",
	"trade.volume24h": "ปริมาณ 24 ชม.",
	"trade.turnover24h": "มูลค่า 24 ชม.",
	"trade.trades24h": "จำนวนเทรด 24 ชม.",
	"trade.noTrades": "ยังไม่มีการเทรด",
	"trade.cancelOrder": "ยกเลิก",
	"trade.cancelling": "กำลังยกเลิก…",
	"trade.noOpenOrders": "ไม่มีคำสั่งเปิด",
	"trade.noOrderHistory": "ไม่มีประวัติคำสั่ง",
	"trade.connectToViewOrders": "เชื่อมต่อกระเป๋าเพื่อดูคำสั่ง",
	"trade.statusOpen": "เปิดอยู่",
	"trade.statusFilled": "จับคู่แล้ว",
	"trade.statusCancelled": "ยกเลิกแล้ว",
	"trade.statusPartial": "จับคู่บางส่วน",
	"trade.invalidPrice": "ราคาลิมิตไม่ถูกต้อง",
	"trade.enterQty": "กรอกจำนวน DGC",
	"trade.qtyPositive": "จำนวนต้องเป็นจำนวนเต็มบวก",
	"trade.bidSubmitted": "ส่งคำสั่งซื้อแล้ว",
	"trade.askSubmitted": "ส่งคำสั่งขายแล้ว",
	"trade.cancelSubmitted": "ส่งการยกเลิกแล้ว",
	"trade.remaining": "คงเหลือ",
	"trade.orderId": "รหัสคำสั่ง",
	"trade.taker": "ฝั่งจับคู่",
	"trade.noClob": "ยังไม่ได้ตั้งค่า CLOB",
	"wallet.connect": "เชื่อมต่อ DGC Wallet",
	"wallet.notDetected": "ไม่พบ DGC Wallet",
	"wallet.downloadExt": "ดาวน์โหลดส่วนขยาย DGC Wallet",
	"wallet.downloadApp": "ดาวน์โหลด DGC Wallet",
	"wallet.appsCenter": "ศูนย์แอป",
	"wallet.wrongWallet": "โปรดเชื่อมต่อ DGC Wallet",
	"wallet.disconnecting": "กำลังตัดการเชื่อมต่อ…",
	"wallet.viewBalance": "เชื่อมต่อ DGC Wallet เพื่อดูยอด",
	"send.recipient": "ผู้รับ",
	"send.confirm": "ยืนยันการส่ง",
	"send.token": "โทเค็น",
	"stake.selectValidator": "เลือกตัวตรวจสอบ",
	"stake.amount": "จำนวนสเตค",
	"stake.myStakes": "สเตคของฉัน",
	"stake.stakeDgc": "สเตค DGC",
	"stake.noStakes": "ไม่มีบันทึกสเตค",
	"stake.refreshValidators": "รีเฟรช",
	"trade.orderQty": "ปริมาณคำสั่ง",
	"trade.noTradeHistory": "ไม่มีประวัติการเทรด",
	"trade.remainingShort": "เหลือ",
	"trade.clickFillPrice": "คลิกเพื่อใส่ราคาลิมิต",
	"trade.klineWindow": "หน้าต่างชาร์ต",
	"trade.open24h": "เปิด 24 ชม.",
	"trade.high24h": "สูง 24 ชม.",
	"trade.low24h": "ต่ำ 24 ชม.",
	"trade.volume24hDgc": "ปริมาณ 24 ชม. (DGC)",
	"trade.txExpired": "ธุรกรรมหมดอายุ โปรดลองใหม่",
	"trade.balanceLabel": "ยอด {symbol}",
	"wallet.connectFirst": "โปรดเชื่อมต่อ DGC Wallet ก่อน",
	"wallet.notFoundAlert": "ไม่พบส่วนขยาย DGC Wallet กรุณาติดตั้ง เปิดใช้ แล้วรีเฟรชหน้านี้",
	"wallet.installHint": "ติดตั้งส่วนขยาย Chrome หรือเปิดหน้านี้ในเบราว์เซอร์ของแอป DGC Wallet",
	"wallet.siteEnabledHint": "ไซต์ปัจจุบัน {origin} หลังติดตั้ง ให้เปิดใช้ใน chrome://extensions แล้วรีเฟรช",
	"wallet.notDetectedExt": "ไม่พบส่วนขยาย DGC Wallet",
	"send.success": "ส่งสำเร็จ",
	"send.availableDash": "ใช้ได้ —",
	"send.uxHint": "ใช้ยอดที่อยู่เป็นหลัก ก๊าซจ่ายจากยอดที่อยู่ DGC",
	"send.addCustomToken": "เพิ่มโทเค็น CLOB กำหนดเอง",
	"send.symbol": "สัญลักษณ์",
	"send.typeTag": "TypeTag",
	"send.decimals": "ทศนิยม",
	"send.saveToList": "บันทึกลงรายการ",
	"stake.submitted": "ส่งสเตคแล้ว",
	"stake.success": "สเตคสำเร็จ",
	"stake.confirmTitle": "ยืนยันสเตค",
	"stake.confirmAction": "ยืนยันสเตค",
	"stake.selectValidatorLabel": "เลือกตัวตรวจสอบ",
	"stake.positions": "ตำแหน่งสเตค",
	"stake.noPositions": "ไม่มีตำแหน่งสเตค",
	"stake.lockHintShort": "ล็อกเงินต้น 180 epoch รับรางวัลได้ตลอดเวลา ไถ่ถอนเงินต้นหลังปลดล็อก",
	"stake.newStake": "สเตคใหม่",
	"stake.enterAmount": "กรอกจำนวนสเตค",
	"stake.confirmMessage": "สเตค {amount} DGC ไปยังตัวตรวจสอบที่เลือก\nล็อกเงินต้น 180 epoch รับรางวัลได้ตลอดเวลา",
	"stake.claimRewards": "รับรางวัลสเตค",
	"stake.redeemPrincipal": "ไถ่ถอนเงินต้นสเตค",
	"stake.noPositionCount": "ไม่มีตำแหน่ง",
	"stake.positionCount": "{count} ตำแหน่ง",
	"apps.title": "แอป",
	"apps.titleSuffix": "/ ระบบนิเวศ",
	"apps.subtitle": "เข้าถึงแอป DGC: Global Shop, RWAX Super App, DGC Wallet และเครื่องมือ on-chain",
	"apps.mobileSubtitle": "Global Shop · RWAX · DGC Wallet",
	"apps.viewAccount": "ดูบัญชีของฉัน →",
	"apps.featured": "แอปแนะนำ",
	"apps.scanDownload": "สแกนเพื่อดาวน์โหลด",
	"apps.scanDownloadApk": "สแกนดาวน์โหลด APK",
	"apps.scanDownloadRwax": "สแกนดาวน์โหลด RWAX",
	"apps.mirrorDownload": "ดาวน์โหลดสำรอง",
	"apps.chromeExt": "ส่วนขยาย Chrome",
	"apps.globalShop": "Global Shop",
	"apps.globalShopDesc": "แพลตฟอร์มค้าข้ามพรมแดน Data Global รองรับหลายภาษาและสกุลเงิน ช้อปแฟชั่นและแบรนด์ จ่ายด้วย DGC Wallet",
	"apps.openGlobalShop": "เปิด Global Shop",
	"apps.tagEcommerce": "ค้าปลีก",
	"apps.globalShopApp": "Global Shop APP",
	"apps.globalShopAppDesc": "แอป Global Shop บนมือถือ — ช้อป ติดตามออเดอร์ และโปรโมชัน สแกน QR เพื่อติดตั้ง",
	"apps.downloadGlobalShopApp": "ดาวน์โหลด Global Shop APP",
	"apps.tagMobile": "มือถือ",
	"apps.walletDesc": "กระเป๋า DGC พื้นเมือง: จัดการสินทรัพย์และลงนาม DApp ติดตั้ง APK ผ่านดาวน์โหลด กระจก หรือ QR รวมถึงส่วนขยาย Chrome",
	"apps.tagWallet": "กระเป๋า",
	"apps.rwaxDesc": "RWAX Super App: กระเป๋าหลายเชน โซเชียล เบราว์เซอร์ DApp และเบราว์เซอร์ทางการ DGC นำเข้า dgcprivkey / วลีช่วยจำ",
	"apps.downloadRwax": "ดาวน์โหลด RWAX",
	"apps.tagSuperApp": "Super App",
	"apps.onchainShortcuts": "ทางลัด on-chain",
	"apps.dexTrade": "เทรด DEX",
	"apps.dexTradeDesc": "เทรดสปอต DGC",
	"apps.bridge": "บริดจ์",
	"apps.bridgeDesc": "BNB USDT ↔ DATA (1:1)",
	"apps.stake": "สเตค",
	"apps.stakeDesc": "มอบหมายตัวตรวจสอบและรับรางวัล",
	"apps.explorer": "สำรวจบล็อก",
	"apps.explorerDesc": "ค้นหา tx และที่อยู่",
	"apps.myStatus": "สถานะ on-chain ของฉัน",
	"apps.totalBalance": "ยอดรวม",
	"apps.viewAddress": "ดูที่อยู่",
	"apps.connectToSeeBalance": "เชื่อมต่อ DGC Wallet เพื่อดูยอด",
	"stake.pageTitle": "สเตค",
	"stake.pageSubtitle": "มอบหมาย DGC ให้ตัวตรวจสอบ รักษาความปลอดภัยเครือข่ายและรับรางวัล แสดงเป็น DGC (1 DGC = 10⁹ MIST)",
	"stake.epochProgress": "ความคืบหน้า epoch",
	"stake.currentEpoch": "Epoch ปัจจุบัน",
	"stake.epochCycleAbout": "รอบ ~ {duration}",
	"stake.latestCheckpoint": "Checkpoint ล่าสุด",
	"stake.checkpointHint": "อ้างอิงความคืบหน้า on-chain",
	"stake.connectHint": "เชื่อมต่อ DGC Wallet ที่แถบข้างเพื่อดูยอด ตำแหน่ง และสเตค",
	"stake.staked": "สเตคแล้ว",
	"stake.viewAccount": "ดูรายละเอียดบัญชี",
	"stake.delegationDetails": "รายละเอียดการมอบหมาย",
	"stake.tipGas": "• สเตคและก๊าซใช้ DGC พื้นเมือง เก็บยอดเล็กน้อยสำหรับค่าธรรมเนียม",
	"stake.tipUnlock": "• ยกเลิกสเตคต้องรอช่วงปลดล็อก epoch (ดู lock_until_epoch)",
	"stake.tipLeaderboard": "• อันดับพูลตัวตรวจสอบอยู่ที่ Leaderboards หน้าแรก อันดับผู้ใช้ต้องมี Indexer",
	"stake.validatorsNetwork": "เครือข่ายตัวตรวจสอบ",
	"stake.networkStake": "สเตค {symbol} ทั้งเครือข่าย",
	"stake.networkStakeTip": "DGC รวมที่สเตคโดยตัวตรวจสอบและผู้มอบหมาย",
	"stake.avgDailyYield": "ผลตอบแทนรายวันเฉลี่ย",
	"stake.avgDailyYieldTip": "APY ตัวตรวจสอบ ÷ 365 ประมาณจากพารามิเตอร์เมื่อตัวอย่างน้อย",
	"stake.lastEpochReward": "รางวัล epoch ก่อน",
	"stake.lastEpochRewardTip": "ผลรวมรางวัลสเตคทุกพูล epoch ก่อน",
	"stake.activeValidators": "ตัวตรวจสอบที่ใช้งาน",
	"stake.activeValidatorsTip": "จำนวนตัวตรวจสอบที่ใช้งานใน epoch ปัจจุบัน",
	"stake.validatorMap": "แผนที่ตัวตรวจสอบ",
	"stake.mapLoading": "กำลังโหลดแผนที่…",
	"stake.allValidators": "ตัวตรวจสอบทั้งหมด",
	"stake.validatorsLoadFailed": "โหลดข้อมูลตัวตรวจสอบไม่สำเร็จ",
	"stake.colName": "ชื่อ",
	"stake.colStake": "สเตค",
	"stake.colDaily": "รายวัน",
	"stake.epochLoading": "กำลังโหลดความคืบหน้า epoch…",
	"stake.epochProgressOf": "ความคืบหน้า epoch {epoch}",
	"stake.remaining": "เหลือ",
	"stake.lockProgress": "ความคืบหน้าปลดล็อกเงินต้น",
	"stake.noDelegations": "ยังไม่มีการมอบหมาย",
	"stake.fungibleCert": "ใบรับรอง fungible",
	"stake.claimable": "รับได้",
	"stake.activeEpoch": "Epoch เริ่มใช้",
	"stake.unlockEpoch": "Epoch ปลดล็อก",
	"stake.epochsLeft": "Epoch ที่เหลือ",
	"stake.lockPeriod": "ระยะล็อก",
	"stake.claimableRewards": "รางวัลที่รับได้",
	"stake.principalUnlocked": "ปลดล็อกเงินต้นแล้ว — ไถ่ถอนได้",
	"stake.redeemAfterUnlock": "ไถ่ถอนหลังปลดล็อก (Epoch {epoch})",
	"genesis.title": "การออก genesis",
	"genesis.subtitle": "การจัดสรร genesis DGC สาธารณะเพื่อการตรวจสอบของชุมชน รวม {total} (เหรียญหลัก {symbol}) แตะที่อยู่เพื่อดูยอด on-chain",
	"genesis.mobileSubtitle": "การจัดสรร genesis",
	"genesis.supplyCheck": "ตรวจยอดรวม",
	"genesis.totalSupply": "ยอด genesis",
	"genesis.tableSum": "ผลรวมตาราง",
	"genesis.equalsTotal": "ตรงยอดรวม",
	"genesis.notEqualsTotal": "ไม่ตรงยอดรวม",
	"genesis.liveValidators": "ตัวตรวจสอบที่ใช้งาน",
	"genesis.reading": "กำลังโหลด…",
	"genesis.unavailable": "ไม่พร้อมใช้",
	"genesis.expected": "คาดหวัง {count}",
	"genesis.compareConfig": "เทียบกับคอนฟิก genesis (เชื่อม RPC แล้ว)",
	"genesis.allocationDetail": "รายละเอียดการจัดสรร",
	"genesis.allocationIntro": "“การจัดสรร genesis” คือจำนวนตามแผน ไม่ใช่ยอดสด เปิดที่อยู่เพื่อดูการถือครองจริง พูลทั้งสี่แบบ ",
	"genesis.linear10yStrong": "เชิงเส้น 10 ปี",
	"genesis.allocationIntro2": " ถูกโหลดเข้า ",
	"genesis.allocationIntro3": " บนเชนหลัง bootstrap และ claim เชิงเส้น ระบบนิเวศแพลตฟอร์มไม่มี vesting “ล็อกสเตค” คือ self-stake ของตัวตรวจสอบ",
	"genesis.colPurpose": "วัตถุประสงค์",
	"genesis.colAmount": "จัดสรร genesis (DGC)",
	"genesis.colPct": "สัดส่วน",
	"genesis.colVesting": "กฎปลดล็อก / ล็อก",
	"genesis.colAddress": "ที่อยู่พูล (ยอด on-chain)",
	"genesis.seeStakePage": "ดูหน้าตัวตรวจสอบ / สเตค",
	"genesis.pendingSync": "รอซิงก์",
	"genesis.total": "รวม",
	"genesis.footerHint": "ยอดพูลอาจยังเป็น Coin หลัง bootstrap-vesting เปิดหน้าที่อยู่พูลเพื่อดูยอด claimable ความคืบหน้า ประวัติ และ claim ด้วยกระเป๋าที่ตรงกัน",
	"genesis.poolAddressPage": "หน้าที่อยู่พูล",
	"genesis.vesting.linear_10y": "เชิงเส้น 10 ปี",
	"genesis.vesting.none": "ไม่ล็อก (หมุนเวียน)",
	"genesis.vesting.system": "พูลระบบ",
	"genesis.vesting.self_stake": "ล็อกสเตค {epochs} epoch",
	"genesis.hint.linear_10y": "vesting::linear::Wallet บนเชน claim ตามเวลา เปิดหน้าที่อยู่พูลเพื่อ claim ก่อน bootstrap อาจยังเป็น Coin",
	"genesis.hint.none": "ไม่มี vesting บนเชน โอนตามกฎปฏิบัติการได้",
	"genesis.hint.system": "จ่ายตามพารามิเตอร์เงินอุดหนุน epoch ไม่ใช่ยอดที่อยู่ทั่วไป",
	"genesis.hint.self_stake": "อยู่ในพูลสเตคตัวตรวจสอบ อยู่ภายใต้ epoch ปลดล็อก",
	"genesis.pool.community": "ชุมชน",
	"genesis.pool.communityNote": "เชิงเส้น 10 ปี bootstrap โหลด Wallet หลัง mint genesis",
	"genesis.pool.foundation": "มูลนิธิ",
	"genesis.pool.foundationNote": "ล็อกบนเชนเชิงเส้น 10 ปี",
	"genesis.pool.tech_support": "สนับสนุนทางเทคนิค",
	"genesis.pool.tech_supportNote": "ล็อกบนเชนเชิงเส้น 10 ปี",
	"genesis.pool.platform_ecosystem": "ระบบนิเวศแพลตฟอร์ม",
	"genesis.pool.platform_ecosystemNote": "ไม่มี vesting ปฏิบัติการ / หมุนเวียน (multisig)",
	"genesis.pool.user_rewards": "รางวัลผู้ใช้",
	"genesis.pool.user_rewardsNote": "ล็อกบนเชนเชิงเส้น 10 ปี",
	"genesis.pool.validators": "Self-stake ตัวตรวจสอบ genesis",
	"genesis.pool.validatorsNote": "{count} ตัวตรวจสอบ × {each} DGC ล็อกเงินต้น {epochs} epoch",
	"genesis.pool.stake_subsidy_fund": "กองทุนอุดหนุนสเตค",
	"genesis.pool.stake_subsidy_fundNote": "พูลอุดหนุนระบบ (genesis ไป 0x0)",
	"bridge.subtitle": "สินทรัพย์บริดจ์คือ DATA (ไม่ใช่ DGC) อัตรา 1:1 ฝั่ง BSC เป็น Binance-Peg USDT ทางการ ฝั่ง DGC เป็น DATA Relayer ชำระอัตโนมัติ",
	"bridge.mobileSubtitle": "DATA ↔ BNB USDT · 1:1",
	"bridge.buyTitle": "ซื้อ DATA ด้วย BNB USDT",
	"bridge.sellTitle": "ขาย DATA เป็น BNB USDT",
	"bridge.balance": "ยอดคงเหลือ",
	"bridge.toReceiveData": "ถึง (DATA โดยประมาณ)",
	"bridge.toReceiveUsdt": "ถึง (BNB USDT โดยประมาณ)",
	"bridge.fromLockData": "จาก (ล็อก DATA)",
	"bridge.cpcRecipient": "ที่อยู่รับบนเชน DGC",
	"bridge.bscRecipient": "ที่อยู่รับ BNB USDT",
	"bridge.recipientPlaceholder": "กรอกที่อยู่ 0x… หรือ D…",
	"bridge.currentWallet": "กระเป๋าปัจจุบัน",
	"bridge.connectBscFirst": "เชื่อมต่อกระเป๋า BSC ก่อน",
	"bridge.connectCpcFirst": "เชื่อมต่อ DGC Wallet ก่อน",
	"bridge.switchMainnet": "สลับเป็น BSC mainnet",
	"bridge.escrowMissing": "ยังไม่ได้ deploy สัญญา escrow",
	"bridge.lockUsdtToData": "ล็อก {amount} {usdt} → DATA",
	"bridge.lockDataToUsdt": "ล็อก {amount} {data} → {usdt}",
	"bridge.bscBusy": "กำลังโต้ตอบสัญญา BSC…",
	"bridge.cpcBusy": "กำลังส่งธุรกรรม…",
	"bridge.dataBridgeStatus": "สถานะบริดจ์ DATA",
	"bridge.treasuryLocked": "คลังที่ล็อก",
	"bridge.gatewayRpc": "เกตเวย์ RPC",
	"bridge.detecting": "กำลังตรวจ",
	"bridge.bnbUsdtStatus": "สถานะ BNB / USDT",
	"bridge.targetNetwork": "เครือข่ายเป้าหมาย",
	"bridge.usdtContract": "สัญญา BNB USDT",
	"bridge.escrow": "Escrow",
	"bridge.configMissing": "ยังไม่ได้ตั้งค่า",
	"bridge.nodeStatus": "สถานะโหนด",
	"bridge.networkMatch": "เครือข่ายตรงกัน",
	"bridge.switchNetwork": "โปรดสลับเครือข่าย",
	"bridge.notConnected": "ยังไม่เชื่อมต่อ",
	"bridge.recentLocks": "การล็อก DATA ล่าสุด",
	"bridge.forUsdt": "→ แลก BNB USDT",
	"bridge.noLocks": "ยังไม่มีบันทึกล็อกบริดจ์บนเครือข่ายนี้",
	"bridge.colAmount": "จำนวนที่ล็อก",
	"bridge.colEstimate": "ประมาณรับ",
	"bridge.colRecipient": "ผู้รับ",
	"bridge.colAction": "การดำเนินการ",
	"bridge.details": "รายละเอียด →",
	"bridge.showRecent5": "แสดง 5 รายการล่าสุด",
	"bridge.refreshStatus": "รีเฟรชสถานะ",
	"bridge.backHome": "← กลับหน้าแรก",
	"bridge.noConfig": "ไม่พบการตั้งค่าบริดจ์ Deploy Bridge บนเชน แล้วรัน ./cpc.sh stack start หรือ fetch-stack-config",
	"bridge.connectMetaMask": "เชื่อมต่อ MetaMask",
	"bridge.installEvm": "ติดตั้ง MetaMask หรือกระเป๋า EVM อื่น",
	"bridge.connectBsc": "เชื่อมต่อกระเป๋า BSC",
	"bridge.noEvm": "ไม่พบกระเป๋า EVM",
	"bridge.disconnect": "ตัดการเชื่อมต่อ",
	"bridge.ok": "ปกติ",
	"bridge.fail": "ผิดพลาด",
	"bridge.processing": "กำลังประมวลผล…",
	"bridge.useCurrent": "ใช้ปัจจุบัน",
	"bridge.needBscRecipient": "กรอกหรือเชื่อมต่อที่อยู่รับ BSC",
	"bridge.needCpcRecipient": "กรอกที่อยู่รับบนเชน DGC",
	"bridge.escrowDeployHint": "ยังไม่ได้ตั้งค่า Escrow: deploy CpcUsdtEscrow บน BSC mainnet ก่อน",
	"bridge.mainnetTokenOnly": "การตั้งค่าปัจจุบันใช้โทเคน BSC mainnet; ยกเลิกเลือก testnet",
	"bridge.lockedDataOk": "ล็อกแล้ว {amount} {data}; relayer จะจ่าย ~{usdtAmount} {usdt} ไปยัง {recipient}…",
	"bridge.lockedUsdtOk": "ล็อกแล้ว {amount} {usdt} → DATA (BSC tx {tx}…)",
	"bridge.noConfigLocalTitle": "พัฒนาในเครื่อง: deploy Bridge ก่อน:",
	"bridge.noConfigSource": "แหล่งการตั้งค่า: Push Hub /v1/stack-config (สำรองออฟไลน์ docs/generated/cpc-stack-config.json)",
	"send.titleLeading": "On-chain",
	"send.badge": "On-chain transfer",
	"send.fail": "Transfer failed",
	"send.listSaved": "Saved to list",
	"send.recipientRequired": "Enter recipient address",
	"send.amountRequired": "Enter amount",
	"send.amountInvalid": "Invalid amount",
	"send.tokenPreset": "Default",
	"send.tokenCustom": "Custom",
	"send.balanceLine": "Available {balance} {symbol} (address balance) · Total {total}",
	"send.balanceLooseSuffix": " · Loose {loose}",
	"send.decimalsHint": "Decimals (default 9)",
	"home.titleLeading": "My",
	"home.bridgeTitle": "Cross-chain bridge USDT ↔ DGC",
	"home.bridgeSubtitle": "BSC deposit · DGC withdraw to BSC / ETH",
	"common.loadMoreFailed": "Failed to load more",
	"wallet.consolidateSkipped": "No merge needed (no loose coins)",
	"wallet.consolidateDone": "Merge complete",
	"wallet.consolidateLoose": "Merge loose DGC",
	"wallet.looseCoinHint": "You have {amount} DGC in loose coins; merge into address balance before large transfers.",
	"wallet.addressCopied": "Address copied",
	"wallet.addressUnavailable": "Address unavailable",
	"time.relativeDays": "{n} days ago",
	"time.relativeHours": "{n} hours ago",
	"time.relativeMinutes": "{n} minutes ago",
	"time.justNow": "Just now",
	"tx.direction.sent": "Sent",
	"tx.direction.received": "Received",
	"tx.direction.other": "Other",
	"tx.status.success": "Success",
	"tx.status.failure": "Failed",
	"tx.status.unknown": "Unknown",
	"tx.detailLeading": "Transaction",
	"tx.detailHighlight": "details",
	"tx.explorerMissing": "Explorer URL not configured",
	"tx.linkCopied": "Link copied",
	"settings.probing": "Probing…",
	"settings.rpcReachable": "RPC reachable · Chain {chain}",
	"settings.rpcSaved": "RPC saved",
	"settings.addedSwitched": "Added and switched",
	"settings.lockPrefsSaved": "Lock settings saved",
	"settings.exportTitle": "Export wallet",
	"settings.backupInfo": "Backup info",
	"settings.exportNoMnemonic": "(Imported via private key — no mnemonic)\n\nPrivate key:\n{pk}\n\nAddress:\n{addr}",
	"settings.exportWithMnemonic": "Mnemonic:\n{mn}\n\nPrivate key:\n{pk}\n\nAddress:\n{addr}",
	"settings.lockTitle": "Lock wallet",
	"settings.lockMessage": "You will need to enter your password again after locking.",
	"settings.lockNowAction": "Lock now",
	"settings.lockBrowserOnly": "Browser close only",
	"settings.lockMinutes": "{n} minutes",
	"settings.lock1h": "1 hour",
	"settings.lock8h": "8 hours",
	"settings.networkTitleLeading": "Network",
	"settings.networkTitleHighlight": "& RPC",
	"settings.currentNetwork": "Current network",
	"settings.currentNetworkRpc": "Current network RPC",
	"settings.saveRpc": "Save RPC",
	"settings.addCustomNetwork": "Add custom network",
	"settings.networkName": "Name",
	"settings.walletChainOptional": "Wallet chain (optional)",
	"settings.probeRpc": "Probe RPC",
	"settings.addAndSwitch": "Add & switch",
	"settings.noCustomNetwork": "No custom networks",
	"settings.securityTitleLeading": "Wallet",
	"settings.securityTitleHighlight": "security",
	"settings.rememberUnlockDefault": "Check “Stay unlocked” by default",
	"settings.currentLock": "Current: {label}",
	"settings.saveLockPrefs": "Save lock settings",
	"settings.connectedTitleLeading": "Connected",
	"settings.noConnectedSites": "No connected sites",
	"dapp.titleHighlight": "Browser",
	"dapp.tabDiscover": "Discover",
	"dapp.tabBrowser": "Browse",
	"dapp.tabHistory": "History",
	"dapp.vconsoleEnabled": "vConsole enabled",
	"dapp.vconsoleDisabled": "vConsole disabled",
	"dapp.vconsoleEnabledHint": "vConsole enabled (green button bottom-right)",
	"dapp.vconsoleClose": "Turn off vConsole",
	"dapp.vconsoleOpen": "Turn on vConsole",
	"dapp.requestFailed": "DApp request failed: {error}",
	"dapp.addTitle": "Add DApp",
	"dapp.urlLabel": "URL",
	"dapp.addedToMy": "Added to My DApps",
	"dapp.deleteBookmarkTitle": "Delete bookmark",
	"dapp.deleteBookmarkMessage": "Remove \"{name}\"?",
	"dapp.deleteConfirm": "Delete",
	"dapp.clearHistoryTitle": "Clear history",
	"dapp.clearHistoryMessage": "Clear all browsing history?",
	"dapp.clearConfirm": "Clear",
	"dapp.searchHint": "Search or enter DApp URL",
	"dapp.addDapp": "Add DApp",
	"dapp.recommended": "Recommended DApps",
	"dapp.noRecommended": "No recommendations",
	"dapp.myBookmarks": "My bookmarks",
	"dapp.customAdd": "Custom add",
	"dapp.noBookmarksYet": "No bookmarks yet. Add your favorite DApps.",
	"dapp.presetTag": "Preset",
	"dapp.browsingHistory": "Browsing history",
	"dapp.noBrowsingHistory": "No browsing history",
	"dapp.add": "Add",
	"dapp.goBack": "Go back",
	"dapp.goForward": "Go forward",
	"dapp.collapseBookmarks": "Collapse bookmarks",
	"dapp.expandBookmarks": "Expand bookmarks",
	"dapp.urlInputHint": "Enter or paste URL",
	"dapp.go": "Go",
	"dapp.bookmarkCurrentPage": "Bookmark this page",
	"dapp.webViewInitializing": "Initializing WebView…",
	"common.retry": "Retry",
	"wallet.myWallets": "My wallets",
	"wallet.listCount": "{n}",
	"wallet.importNew": "Import new wallet",
	"wallet.importLocalHint": "Keys are stored encrypted locally only. Do not screenshot or share.",
	"wallet.nameOptional": "Wallet name (optional)",
	"wallet.mnemonicHint": "12 / 24 words, space-separated",
	"wallet.privateKeyHint": "dgcprivkey1… or 64-char hex / Base64",
	"wallet.confirmImport": "Confirm import",
	"wallet.enterPrivateKey": "Enter private key",
	"wallet.enterMnemonic": "Enter mnemonic",
	"wallet.added": "Wallet added",
	"wallet.currentAccount": "Current account",
	"wallet.currentBadge": "Current",
	"wallet.hdAccountCount": "{n} HD accounts",
	"wallet.exportMnemonic": "Export mnemonic",
	"wallet.exportPrivateKey": "Export private key",
	"wallet.exportPasswordTitle": "Verify security password",
	"wallet.exportPasswordHint": "Enter your extension password to continue. Never share the secret.",
	"wallet.exportPasswordEmpty": "Enter the extension password",
	"wallet.exportWarning": "Anyone with this can control your assets. Do not screenshot or send it.",
	"wallet.exportCopied": "Copied",
	"wallet.noMnemonicToExport": "This wallet was imported from a private key and has no mnemonic",
	"wallet.exportVerify": "Verify",
	"stake.confirmClaimMessage": "Rewards credit to address balance (not loose coins).\nEstimated rewards {amount} DGC",
	"stake.confirmRedeemMessage": "About {amount} DGC principal will credit to address balance.\nThis cannot be undone.",
	"stake.redeemSuccess": "Principal redeemed",
	"stake.claimSuccess": "Rewards claimed",
	"stake.networkStakeBadge": "Network stake",
	"stake.validatorPoolTotalCaption": "Total DGC in validator pools",
	"stake.avgCommission": "Avg commission",
	"stake.lockedPrincipal": "Locked principal",
	"stake.positionValueEst": "Position value (est.)",
	"stake.lockedChip": "Locked",
	"stake.redeemableChip": "Redeemable",
	"stake.unlockedChip": "Matured",
	"stake.statusActive": "Active",
	"stake.statusPending": "Pending activation",
	"stake.principalLabel": "Principal",
	"trade.tabTrade": "Trade",
	"trade.tabMarket": "Market",
	"trade.loadMarketFailed": "Failed to load market. Please try again.",
	"trade.enterQtyShort": "Enter quantity",
	"trade.orderBookUnavailable": "Order book unavailable",
	"trade.noOrdersInBook": "No orders in book",
	"trade.turnover24hData": "24h turnover (DATA)",
	"trade.kline": "Candles",
	"trade.noKlineData": "No candle data",
	"trade.klineLegend": "MA(7) · Volume",
	"trade.fillDetailLeading": "Fill",
	"trade.fillDetailHighlight": "details",
	"trade.noOnchainDigest": "No on-chain digest",
	"trade.copyDigest": "Copy digest",
	"trade.digestCopied": "Digest copied",
	"trade.onchainDetail": "On-chain details",
	"tx.sender": "Sender",
	"tx.checkpoint": "Checkpoint",
	"tx.gasBudget": "Gas budget",
	"tx.computation": "Computation",
	"tx.storage": "Storage",
	"tx.rebate": "Rebate",
	"tx.balanceChanges": "Balance changes",
	"tx.commands": "Commands",
	"tx.digestCopied": "Digest copied",
	"tx.onchainDetail": "On-chain details",
	"receive.title": "Receive",
	"receive.networkOnlyHint": "DGC network assets only",
	"receive.copyAddress": "Copy address",
	"receive.saveImage": "Save image",
	"receive.shareText": "DGC receive address {address}",
	"receive.imageFailed": "Could not generate image",
	"receive.encodeFailed": "Image encode failed",
	"receive.saveFailed": "Save failed: {error}",
	"recipient.needValidAddress": "Enter a valid recipient address first",
	"recipient.saveContact": "Save contact",
	"recipient.editLabel": "Edit label",
	"recipient.labelName": "Label",
	"recipient.labelHint": "e.g. Alice, exchange",
	"recipient.savedOk": "Contact saved",
	"recipient.deleteContact": "Delete contact",
	"recipient.removeRecent": "Remove from recent",
	"recipient.deleteContactMessage": "Delete saved contact “{name}”.",
	"recipient.removeRecentMessage": "Remove this address from recent recipients.",
	"recipient.saveAsContact": "Save as contact",
	"recipient.noSaved": "No saved contacts",
	"recipient.noRecent": "No recent addresses",
	"recipient.hint": "Successful sends are added to recent; tap Save to add a labeled contact.",
	"recipient.contactsTab": "Contacts{count}",
	"recipient.recentTab": "Recent{count}",
	"common.paste": "Paste",
	"common.delete": "Delete",
	"common.new": "New",
	"dapp.connectTitle": "Connect DApp",
	"dapp.connectFailed": "Connection failed",
	"dapp.walletLockedHint": "Wallet is locked. Unlock before connecting.",
	"dapp.signFailed": "Signing failed",
	"dapp.signRequest": "Signature request",
	"dapp.signAndExecute": "Sign & execute",
	"dapp.signOnly": "Sign",
	"mall.payLeading": "Mall",
	"mall.payHighlight": "Pay",
	"mall.amountDueData": "Amount due (DATA)",
	"mall.orderNumber": "Order No.",
	"mall.merchantAddress": "Merchant",
	"mall.payerAddress": "Payer",
	"mall.dataBalance": "DATA balance",
	"mall.confirmPay": "Confirm payment",
	"mall.walletLocked": "Wallet is locked",
	"mall.returnAppFailed": "Could not return to the mall app. Switch manually.",
	"mall.paySuccess": "Payment successful",
	"account.switchTitle": "Switch wallet / account",
	"account.count": "{n} accounts",
	"account.hdAccounts": "HD accounts",
	"account.numbered": "Account {n}",
	"account.inUse": "In use",
	"account.tapToSwitch": "Tap to switch",
	"stake.principalMatured": "Principal matured — redeemable",
	"stake.lockHintWithActive": "Active epoch {activeEpoch} · Unlock epoch {unlockEpoch} · {epochsLeft} epochs left",
	"stake.lockHintUnlockOnly": "Unlock epoch {unlockEpoch} · {epochsLeft} epochs left",
	"stake.poolTokenShare": "Pool token share {amount}",
	"stake.requestEpoch": "Request epoch",
	"stake.claimRewardsBtn": "Claim rewards",
	"stake.redeemPrincipalBtn": "Redeem principal",
	"stake.noValidatorsAvailable": "No validators available",
	"stake.validatorFieldLabel": "Validator",
	"stake.addressLabel": "Address",
	"stake.stakePool": "Stake pool",
	"stake.commission": "Commission",
	"stake.votingPower": "Weight",
	"stake.validatorAddressCopied": "Validator address copied",
	"mall.returnFailed": "Cannot return to mall app — switch manually",
	"mall.titleLeading": "Mall",
	"mall.titleHighlight": "Pay",
	"mall.amountDue": "Amount due (DATA)",
	"bridge.usdtLockedSnack": "USDT locked · tx {digest}",
	"bridge.dgcLockedSnack": "DGC locked · digest {digest}",
	"common.cannotOpenBrowser": "Cannot open browser",
	"tx.explorerLinkFailed": "Failed to open explorer link",
	"bridge.pageTitleHighlight": "Bridge",
	"bridge.walletAccountLine": "{wallet} · {account}",
	"bridge.tabSwap": "Swap",
	"bridge.directionUsdtToDgc": "USDT → DGC",
	"bridge.ethRelayerHint": "ETH withdrawals are settled by the relayer after DGC lock.",
	"bridge.fromBsc": "From (BSC USDT)",
	"bridge.fromDgc": "From (DGC DATA)",
	"bridge.evmRecipientLabel": "{chain} recipient",
	"bridge.lockUsdtToDgc": "Lock USDT → DGC",
	"bridge.lockDgcToTarget": "Lock DGC → {target}",
	"bridge.myBridgeRecords": "My bridge records",
	"bridge.noLocalRecords": "No local bridge records yet",
	"bridge.onChainLocksAccount": "On-chain locks (this account)",
	"bridge.noOnChainLockEvents": "No on-chain lock events",
	"bridge.networkRecentLocks": "Recent network locks",
	"connect.failed": "Connection failed",
	"connect.lockedHint": "Wallet locked — unlock before connecting",
	"sign.failed": "Signing failed",
	"sign.signAndExecute": "Sign and execute",
	"sign.signOnly": "Sign",
	"recipient.noSavedContacts": "No saved contacts",
	"recipient.noRecentAddresses": "No recent addresses",
	"recipient.contacts": "Contacts",
	"recipient.recent": "Recent",
	"receive.dgcOnly": "DGC network assets only",
	"bridge.statusConfirmed": "Confirmed",
	"bridge.introInboundTitle": "Deposit USDT → DATA",
	"bridge.introInboundBody": "Lock BNB-chain USDT in escrow; Relayer mints DATA 1:1 on DGC.",
	"bridge.introOutboundEthBody": "Lock DATA on DGC; Relayer pays USDT on Ethereum.",
	"bridge.introOutboundBscBody": "Lock DATA on DGC; Relayer pays USDT on BNB Chain.",
	"bridge.webVersion": "Web version",
	"bridge.inboundEscrowUnavailable": "BSC escrow unavailable — check bridge config.",
	"bridge.balanceWithAmount": "Balance {amount}",
	"bridge.exchangeRate": "Exchange rate",
	"bridge.exchangeRateValue": "1 DATA ≈ {rate} USDT",
	"bridge.bscInbound": "BSC inbound",
	"bridge.ethOutbound": "ETH outbound",
	"bridge.statusReady": "Ready",
	"bridge.txIdLabel": "Tx ID",
	"bridge.txIdCopied": "Tx ID copied",
	"bridge.copyTxId": "Copy Tx ID",
	"trade.unlockToViewOrders": "Unlock wallet to view orders",
	"trade.partialQtyLine": "Filled {filled} / {total}",
	"trade.orderHistoryLine": "{side} · {qty} @ {price}",
	"trade.fillQtyLine": "{qty} DGC",
	"trade.estimateSpendAmount": "Est. cost {amount} DATA",
	"trade.estimateReceiveAmount": "Est. receive {amount} DATA",
	"receive.imageRenderFailed": "Could not generate image",
	"receive.imageEncodeFailed": "Image encode failed",
	"recipient.validRequired": "Enter a valid recipient address first",
	"recipient.contactSaved": "Contact saved",
	"recipient.removeFromHistory": "Remove from recent",
	"recipient.deleteSavedMessage": "Delete contact {name}?",
	"recipient.hintEmpty": "Paste an address or pick a contact",
	"tx.computationCost": "Computation",
	"tx.storageCost": "Storage",
	"tx.storageRebate": "Rebate",
	"tx.onChainDetail": "On-chain details",
	"tx.noDigest": "No on-chain digest",
	"tx.copyDigest": "Copy digest",
	"trade.marketLoadFailed": "Failed to load market. Please try again later.",
	"bridge.tabRecords": "Records",
	"bridge.directionDgcWithdraw": "DGC withdraw",
	"bridge.introOutboundTitle": "Withdraw DATA → EVM",
	"bridge.statusNotConfigured": "Not configured",
	"wallet.shellSubtitle": "Address balance · staking · custom networks",
	"wallet.totalBalanceLine": "Total {total} DGC · {chain}",
	"trade.clobToken": "CLOB token",
	"trade.openOrderMeta": "{time} · Order {qty} DGC · Remaining {remaining} DGC",
	"trade.orderTimeQtyLine": "{time} · Qty {qty}",
	"trade.fillTimeQtyLine": "{time} · Qty {qty} DGC",
	"qr.title": "Scan",
	"qr.flashlight": "Flashlight",
	"qr.unrecognized": "Unrecognized: scan mall pay code or a DGC receive address",
	"qr.hint": "Supports mall pay codes (fixed DATA amount) or DGC receive addresses",
	"home.multiChainAssets": "Multi-chain assets",
	"home.refreshBalances": "Refresh balances",
	"home.suiMainnet": "Sui mainnet",
	"home.rpcUnavailable": "RPC unavailable",
	"wallet.addressLabel": "Wallet address",
	"wallet.looseBalance": "Loose",
	"stake.poolBalanceLine": "Pool balance {balance} DGC",
	"depth.liveBook": "Live order book",
	"depth.noData": "No depth data",
	"sign.gasEstimating": "Estimating gas…",
	"dapp.tagOfficial": "Official",
	"dapp.tagRecommended": "Featured",
	"dapp.discover.explorerDesc": "Block explorer · txs & objects",
	"dapp.discover.shopName": "GlobalData Shop",
	"dapp.discover.shopDesc": "Data Global cross-border shop",
	"dapp.openExplorer": "Open DGC Explorer",
	"dapp.quickLinks": "Quick links",
	"dapp.nameLabel": "Name",
	"dapp.urlEmpty": "URL cannot be empty",
	"dapp.urlInvalid": "Invalid URL",
	"dapp.urlAlreadyBookmarked": "URL already in bookmarks",
	"dapp.preconnectSkipped": "DGC preconnect skipped: {error}",
	"dapp.scanQr": "Scan",
	"bridge.historyTitle": "ประวัติข้ามเชน",
	"bridge.historySubtitle": "สองทิศทาง: DATA → USDT และ USDT → DATA",
	"bridge.colDirection": "ทิศทาง",
	"bridge.dirDataToUsdt": "DATA → USDT",
	"bridge.dirUsdtToData": "USDT → DATA",
	"bridge.historyNeedWallet": "เชื่อม DGC Wallet เพื่อดูประวัติบริดจ์ของที่อยู่นี้",
	"bridge.historyOpen": "รายการของฉัน",
	"bridge.historyBackToBridge": "กลับไปบริดจ์",
	"bridge.colTime": "เวลา",
	"bridge.historyAddress": "ที่อยู่",
	"bridge.historyAutoRefresh": "รีเฟรชอัตโนมัติ",
};

const ko: MessageCatalog = {
	"common.language": "언어",
	"common.network": "네트워크",
	"common.wallet": "지갑",
	"common.cancel": "취소",
	"common.confirm": "확인",
	"common.refresh": "새로고침",
	"common.loading": "로딩 중…",
	"common.save": "저장",
	"common.lock": "잠금",
	"common.close": "닫기",
	"common.back": "뒤로",
	"common.copy": "복사",
	"common.error": "오류가 발생했습니다",
	"common.spot": "현물",
	"common.buy": "매수",
	"common.sell": "매도",
	"common.price": "가격",
	"common.quantity": "수량",
	"common.available": "사용 가능",
	"common.settings": "설정",
	"common.detect": "검사",
	"nav.dex": "DEX",
	"nav.bridge": "브리지",
	"nav.stake": "스테이킹",
	"nav.genesis": "제네시스",
	"nav.apps": "앱",
	"nav.assets": "자산",
	"nav.send": "보내기",
	"nav.trade": "거래",
	"nav.network": "네트워크",
	"nav.dapp": "DApp",
	"nav.crossChain": "크로스체인",
	"nav.market": "시세",
	"explorer.title": "DGC Explorer",
	"explorer.tagline": "Explorer",
	"wallet.title": "DGC Wallet",
	"wallet.tagline": "메인넷 · 주소 잔액 · 스테이킹",
	"wallet.welcome": "DGC Wallet에 오신 것을 환영합니다",
	"wallet.welcomeDesc": "확장 프로그램 비밀번호로 지갑을 보호하세요.",
	"wallet.unlock": "지갑 잠금 해제",
	"wallet.unlockDesc": "확장 프로그램 비밀번호를 입력하세요.",
	"wallet.password": "확장 비밀번호",
	"wallet.passwordConfirm": "비밀번호 확인",
	"wallet.passwordPlaceholder": "최소 8자",
	"wallet.rememberUnlock": "잠금 해제 유지",
	"wallet.create": "지갑 만들기",
	"wallet.import": "지갑 가져오기",
	"wallet.generateMnemonic": "니모닉 생성",
	"wallet.mnemonic": "니모닉 (12 / 24단어)",
	"wallet.privateKey": "개인키",
	"wallet.backupTitle": "니모닉 백업",
	"wallet.backupDesc": "안전한 곳에 적어 두세요. 분실 시 복구할 수 없습니다.",
	"wallet.backupAck": "니모닉을 안전하게 백업했습니다",
	"wallet.backupDone": "생성 완료",
	"wallet.addressBalance": "주소 잔액",
	"wallet.totalBalance": "총 잔액",
	"wallet.lockNow": "지금 잠그기",
	"wallet.export": "지갑 내보내기",
	"wallet.security": "지갑 보안",
	"wallet.autoLock": "자동 잠금",
	"wallet.connectedSites": "연결된 사이트",
	"wallet.txHistory": "거래 내역",
	"wallet.noTx": "거래 없음",
	"wallet.loadingWallet": "지갑 로딩 중…",
	"trade.pair": "DGC / DATA",
	"trade.buyDgc": "DGC 매수",
	"trade.sellDgc": "DGC 매도",
	"trade.limitPrice": "지정가",
	"trade.quantity": "수량",
	"trade.estimateSpend": "예상 소모 — DATA",
	"trade.estimateReceive": "예상 수령 — DATA (수수료 후)",
	"trade.bids": "매수",
	"trade.asks": "매도",
	"trade.marketTrades": "시장 체결",
	"trade.myTrades": "내 체결",
	"trade.openOrders": "미체결",
	"trade.priceData": "가격(DATA)",
	"trade.qtyDgc": "수량(DGC)",
	"trade.lastPrice": "최근가",
	"trade.loadingMarket": "시장 로딩 중…",
	"trade.refresh": "시장 새로고침",
	"sign.request": "서명 요청",
	"sign.approve": "승인 및 서명",
	"sign.reject": "거부",
	"connect.request": "연결 요청",
	"connect.approve": "연결 허용",
	"connect.reject": "거부",
	"connect.desc": "이 사이트는 DGC 주소를 보고 서명을 요청할 수 있습니다. 네트워크 → 연결된 사이트에서 언제든 취소하세요.",
	"language.title": "언어",
	"language.subtitle": "표시 언어를 선택하세요. 기본값은 English입니다.",
	"settings.networkRpc": "네트워크 & RPC",
	"settings.walletSecurity": "지갑 보안",
	"settings.walletManage": "지갑 관리",
	"settings.connectedDapps": "연결된 DApp",
	"common.time": "시간",
	"common.side": "방향",
	"common.action": "작업",
	"common.status": "상태",
	"common.account": "계정",
	"common.amount": "금액",
	"common.max": "최대",
	"common.empty": "없음",
	"common.submitting": "제출 중…",
	"common.connectWallet": "지갑 연결",
	"common.disconnect": "연결 해제",
	"common.connecting": "연결 중…",
	"common.loadMore": "더 보기",
	"common.all": "전체",
	"common.balance": "잔액",
	"common.spread": "스프레드",
	"trade.orderBook": "호가창",
	"trade.recentTrades": "최근 체결",
	"trade.orderHistory": "주문 내역",
	"trade.tradeHistory": "체결 내역",
	"trade.bestBid": "매수1",
	"trade.bestAsk": "매도1",
	"trade.change24h": "24시간 변동",
	"trade.volume24h": "24시간 거래량",
	"trade.turnover24h": "24시간 거래대금",
	"trade.trades24h": "24시간 체결수",
	"trade.noTrades": "체결 없음",
	"trade.cancelOrder": "취소",
	"trade.cancelling": "취소 중…",
	"trade.noOpenOrders": "미체결 주문 없음",
	"trade.noOrderHistory": "주문 내역 없음",
	"trade.connectToViewOrders": "지갑을 연결해 미체결을 확인하세요",
	"trade.statusOpen": "미체결",
	"trade.statusFilled": "체결",
	"trade.statusCancelled": "취소됨",
	"trade.statusPartial": "부분 체결",
	"trade.invalidPrice": "지정가 형식이 잘못됨",
	"trade.enterQty": "DGC 수량을 입력하세요",
	"trade.qtyPositive": "수량은 양의 정수여야 합니다",
	"trade.bidSubmitted": "매수 주문 제출됨",
	"trade.askSubmitted": "매도 주문 제출됨",
	"trade.cancelSubmitted": "취소 제출됨",
	"trade.remaining": "잔량",
	"trade.orderId": "주문 ID",
	"trade.taker": "테이커",
	"trade.noClob": "CLOB 미설정",
	"wallet.connect": "DGC Wallet 연결",
	"wallet.notDetected": "DGC Wallet을 찾을 수 없음",
	"wallet.downloadExt": "DGC Wallet 확장 다운로드",
	"wallet.downloadApp": "DGC Wallet 다운로드",
	"wallet.appsCenter": "앱 센터",
	"wallet.wrongWallet": "DGC Wallet을 연결하세요",
	"wallet.disconnecting": "연결 해제 중…",
	"wallet.viewBalance": "잔액을 보려면 DGC Wallet을 연결하세요",
	"send.recipient": "수신 주소",
	"send.confirm": "전송 확인",
	"send.token": "토큰",
	"stake.selectValidator": "검증자를 선택하세요",
	"stake.amount": "스테이킹 수량",
	"stake.myStakes": "내 스테이킹",
	"stake.stakeDgc": "DGC 스테이킹",
	"stake.noStakes": "스테이킹 기록 없음",
	"stake.refreshValidators": "새로고침",
	"trade.orderQty": "주문 수량",
	"trade.noTradeHistory": "체결 내역 없음",
	"trade.remainingShort": "잔량",
	"trade.clickFillPrice": "클릭하여 지정가 입력",
	"trade.klineWindow": "차트 창",
	"trade.open24h": "24시간 시가",
	"trade.high24h": "24시간 고가",
	"trade.low24h": "24시간 저가",
	"trade.volume24hDgc": "24시간 거래량 (DGC)",
	"trade.txExpired": "거래가 만료되었습니다. 다시 시도하세요",
	"trade.balanceLabel": "{symbol} 잔액",
	"wallet.connectFirst": "먼저 DGC Wallet을 연결하세요",
	"wallet.notFoundAlert": "DGC Wallet 확장을 찾을 수 없습니다. 설치·활성화 후 페이지를 새로고침하세요.",
	"wallet.installHint": "Chrome 확장을 설치하거나 DGC Wallet 앱 브라우저에서 이 페이지를 여세요.",
	"wallet.siteEnabledHint": "현재 사이트 {origin}. 설치 후 chrome://extensions에서 활성화하고 새로고침하세요.",
	"wallet.notDetectedExt": "DGC Wallet 확장이 감지되지 않음",
	"send.success": "전송 성공",
	"send.availableDash": "사용 가능 —",
	"send.uxHint": "주소 잔액을 우선 사용하며, 가스는 DGC 주소 잔액에서 지불됩니다",
	"send.addCustomToken": "맞춤 CLOB 토큰 추가",
	"send.symbol": "심볼",
	"send.typeTag": "TypeTag",
	"send.decimals": "소수점",
	"send.saveToList": "목록에 저장",
	"stake.submitted": "스테이킹 제출됨",
	"stake.success": "스테이킹 성공",
	"stake.confirmTitle": "스테이킹 확인",
	"stake.confirmAction": "스테이킹 확인",
	"stake.selectValidatorLabel": "검증자 선택",
	"stake.positions": "스테이킹 포지션",
	"stake.noPositions": "스테이킹 포지션 없음",
	"stake.lockHintShort": "원금은 180 epoch 잠금. 보상은 언제든 수령 가능하며, 잠금 해제 후 원금 상환.",
	"stake.newStake": "새 스테이킹",
	"stake.enterAmount": "스테이킹 수량을 입력하세요",
	"stake.confirmMessage": "선택한 검증자에 {amount} DGC를 스테이킹합니다.\n원금은 180 epoch 잠금이며, 보상은 언제든 수령할 수 있습니다.",
	"stake.claimRewards": "스테이킹 보상 수령",
	"stake.redeemPrincipal": "스테이킹 원금 상환",
	"stake.noPositionCount": "포지션 없음",
	"stake.positionCount": "{count}개 포지션",
	"apps.title": "앱",
	"apps.titleSuffix": "/ 생태계",
	"apps.subtitle": "DGC 앱을 한곳에서: Global Shop, RWAX Super App, DGC Wallet 및 온체인 도구.",
	"apps.mobileSubtitle": "Global Shop · RWAX · DGC Wallet",
	"apps.viewAccount": "내 계정 보기 →",
	"apps.featured": "추천 앱",
	"apps.scanDownload": "스캔하여 다운로드",
	"apps.scanDownloadApk": "APK 스캔 다운로드",
	"apps.scanDownloadRwax": "RWAX 스캔 다운로드",
	"apps.mirrorDownload": "미러 다운로드",
	"apps.chromeExt": "Chrome 확장",
	"apps.globalShop": "Global Shop",
	"apps.globalShopDesc": "다국어·다통화 Data Global 크로스보더 커머스. 패션과 브랜드를 둘러보고 DGC Wallet으로 결제하세요.",
	"apps.openGlobalShop": "Global Shop 열기",
	"apps.tagEcommerce": "커머스",
	"apps.globalShopApp": "Global Shop APP",
	"apps.globalShopAppDesc": "모바일 Global Shop — 쇼핑, 주문 추적, 프로모션. QR을 스캔해 설치하세요.",
	"apps.downloadGlobalShopApp": "Global Shop APP 다운로드",
	"apps.tagMobile": "모바일",
	"apps.walletDesc": "네이티브 DGC 지갑: 자산 관리 및 DApp 서명. 다운로드·미러·QR로 Android APK 설치, Chrome 확장도 제공.",
	"apps.tagWallet": "지갑",
	"apps.rwaxDesc": "RWAX Super App: 멀티체인 지갑, 소셜, DApp 브라우저 및 공식 DGC 브라우저. dgcprivkey / 니모닉 가져오기, 기본 DGC 생태계.",
	"apps.downloadRwax": "RWAX 다운로드",
	"apps.tagSuperApp": "Super App",
	"apps.onchainShortcuts": "온체인 바로가기",
	"apps.dexTrade": "DEX 거래",
	"apps.dexTradeDesc": "DGC 현물 거래",
	"apps.bridge": "브리지",
	"apps.bridgeDesc": "BNB USDT ↔ DATA (1:1)",
	"apps.stake": "스테이킹",
	"apps.stakeDesc": "검증자에 위임하고 보상 받기",
	"apps.explorer": "블록 탐색기",
	"apps.explorerDesc": "트랜잭션·주소 조회",
	"apps.myStatus": "내 온체인 상태",
	"apps.totalBalance": "총 잔액",
	"apps.viewAddress": "주소 보기",
	"apps.connectToSeeBalance": "잔액을 보려면 DGC Wallet을 연결하세요",
	"stake.pageTitle": "스테이킹",
	"stake.pageSubtitle": "검증자에 DGC를 위임해 네트워크를 보호하고 보상을 받으세요. 수량은 DGC로 표시됩니다 (1 DGC = 10⁹ MIST).",
	"stake.epochProgress": "Epoch 진행",
	"stake.currentEpoch": "현재 epoch",
	"stake.epochCycleAbout": "주기 ~ {duration}",
	"stake.latestCheckpoint": "최신 체크포인트",
	"stake.checkpointHint": "온체인 진행 참고",
	"stake.connectHint": "사이드바에서 DGC Wallet을 연결해 잔액, 포지션, 스테이킹을 확인하세요.",
	"stake.staked": "스테이킹됨",
	"stake.viewAccount": "계정 상세 보기",
	"stake.delegationDetails": "위임 상세",
	"stake.tipGas": "• 스테이킹과 가스는 네이티브 DGC를 사용합니다. 수수료용으로 소액을 남겨 두세요.",
	"stake.tipUnlock": "• 언스테이킹은 epoch 잠금 해제 기간을 기다립니다 (lock_until_epoch 참고).",
	"stake.tipLeaderboard": "• 검증자 풀 순위는 홈 Leaderboards에 있습니다. 사용자 위임 순위는 Indexer가 필요합니다.",
	"stake.validatorsNetwork": "검증자 네트워크",
	"stake.networkStake": "네트워크 {symbol} 스테이킹",
	"stake.networkStakeTip": "검증자와 위임자가 스테이킹한 DGC 합계",
	"stake.avgDailyYield": "평균 일일 수익률",
	"stake.avgDailyYieldTip": "검증자 APY ÷ 365; 표본이 적을 때 보조금 파라미터로 추정",
	"stake.lastEpochReward": "이전 epoch 보상",
	"stake.lastEpochRewardTip": "이전 epoch 검증자 풀 스테이킹 보상 합계",
	"stake.activeValidators": "활성 검증자",
	"stake.activeValidatorsTip": "현재 epoch 활성 검증자 수",
	"stake.validatorMap": "검증자 지도",
	"stake.mapLoading": "지도 로딩 중…",
	"stake.allValidators": "전체 검증자",
	"stake.validatorsLoadFailed": "검증자 데이터를 불러오지 못했습니다",
	"stake.colName": "이름",
	"stake.colStake": "스테이킹",
	"stake.colDaily": "일일",
	"stake.epochLoading": "Epoch 진행 로딩 중…",
	"stake.epochProgressOf": "Epoch {epoch} 진행",
	"stake.remaining": "남음",
	"stake.lockProgress": "원금 잠금 해제 진행",
	"stake.noDelegations": "위임 기록이 없습니다",
	"stake.fungibleCert": "Fungible 증명",
	"stake.claimable": "수령 가능",
	"stake.activeEpoch": "활성 epoch",
	"stake.unlockEpoch": "잠금 해제 epoch",
	"stake.epochsLeft": "남은 epoch",
	"stake.lockPeriod": "잠금 기간",
	"stake.claimableRewards": "수령 가능 보상",
	"stake.principalUnlocked": "원금 잠금 해제됨 — 상환 가능",
	"stake.redeemAfterUnlock": "잠금 해제 후 상환 (Epoch {epoch})",
	"genesis.title": "제네시스 발행 공시",
	"genesis.subtitle": "커뮤니티 감독을 위한 DGC 제네시스 배분 공개. 총량 {total} (메인 코인 {symbol}). 주소를 눌러 온체인 잔액을 확인하세요.",
	"genesis.mobileSubtitle": "제네시스 배분",
	"genesis.supplyCheck": "총량 검증",
	"genesis.totalSupply": "제네시스 총량",
	"genesis.tableSum": "배분표 합계",
	"genesis.equalsTotal": "총량과 일치",
	"genesis.notEqualsTotal": "총량과 불일치",
	"genesis.liveValidators": "온체인 활성 검증자",
	"genesis.reading": "로딩 중…",
	"genesis.unavailable": "사용 불가",
	"genesis.expected": "예상 {count}",
	"genesis.compareConfig": "제네시스 설정과 비교 (RPC 연결 필요)",
	"genesis.allocationDetail": "발행 배분 상세",
	"genesis.allocationIntro": "“제네시스 배분”은 계획 수량이며 실시간 잔액이 아닙니다. 주소를 열어 실제 보유량을 확인하세요. 네 개의 ",
	"genesis.linear10yStrong": "선형 10년",
	"genesis.allocationIntro2": " 풀은 부트스트랩 후 온체인 ",
	"genesis.allocationIntro3": "에 적재되어 시간에 따라 선형 claim됩니다. 플랫폼 생태계는 vesting 없음. “스테이크 잠금”은 검증자 셀프 스테이크입니다.",
	"genesis.colPurpose": "용도",
	"genesis.colAmount": "제네시스 배분 (DGC)",
	"genesis.colPct": "비중",
	"genesis.colVesting": "해제 / 잠금 규칙",
	"genesis.colAddress": "풀 주소 (온체인 잔액)",
	"genesis.seeStakePage": "검증자 / 스테이킹 페이지 참고",
	"genesis.pendingSync": "동기화 대기",
	"genesis.total": "합계",
	"genesis.footerHint": "풀 잔액이 아직 Coin 객체일 수 있습니다. bootstrap-vesting 후 풀 주소 페이지에서 수령 가능액·진행·기록·claim을 확인하세요.",
	"genesis.poolAddressPage": "풀 주소 페이지",
	"genesis.vesting.linear_10y": "선형 10년",
	"genesis.vesting.none": "잠금 없음 (유통)",
	"genesis.vesting.system": "시스템 풀",
	"genesis.vesting.self_stake": "스테이크 잠금 {epochs} epoch",
	"genesis.hint.linear_10y": "온체인 vesting::linear::Wallet; 시간에 따라 claim. 풀 주소 페이지에서 수령. 부트스트랩 전에는 Coin일 수 있음.",
	"genesis.hint.none": "온체인 vesting 없음; 운영 규칙에 따라 전송 가능",
	"genesis.hint.system": "epoch 보조금 파라미터로 지급; 일반 주소 잔액 아님",
	"genesis.hint.self_stake": "검증자 스테이크 풀에 있음; 잠금 해제 epoch 적용",
	"genesis.pool.community": "커뮤니티",
	"genesis.pool.communityNote": "선형 10년; 제네시스 민트 후 부트스트랩이 Wallet 적재",
	"genesis.pool.foundation": "재단",
	"genesis.pool.foundationNote": "선형 10년 온체인 잠금",
	"genesis.pool.tech_support": "기술 지원",
	"genesis.pool.tech_supportNote": "선형 10년 온체인 잠금",
	"genesis.pool.platform_ecosystem": "플랫폼 생태계",
	"genesis.pool.platform_ecosystemNote": "vesting 없음; 운영 / 유통 (멀티시그)",
	"genesis.pool.user_rewards": "사용자 보상",
	"genesis.pool.user_rewardsNote": "선형 10년 온체인 잠금",
	"genesis.pool.validators": "제네시스 검증자 셀프 스테이크",
	"genesis.pool.validatorsNote": "{count}명 검증자 × {each} DGC; 원금 잠금 {epochs} epoch",
	"genesis.pool.stake_subsidy_fund": "스테이크 보조금 펀드",
	"genesis.pool.stake_subsidy_fundNote": "시스템 보조금 풀 (제네시스 → 0x0)",
	"bridge.subtitle": "브리지 자산은 DATA(메인코인 DGC 아님), 1:1. BSC 측은 공식 Binance-Peg USDT, DGC 측은 DATA. Relayer가 자동 정산합니다.",
	"bridge.mobileSubtitle": "DATA ↔ BNB USDT · 1:1",
	"bridge.buyTitle": "BNB USDT로 DATA 구매",
	"bridge.sellTitle": "DATA를 BNB USDT로 판매",
	"bridge.balance": "잔액",
	"bridge.toReceiveData": "받는 쪽 (DATA 예상)",
	"bridge.toReceiveUsdt": "받는 쪽 (BNB USDT 예상)",
	"bridge.fromLockData": "보내는 쪽 (DATA 잠금)",
	"bridge.cpcRecipient": "DGC 체인 수신 주소",
	"bridge.bscRecipient": "BNB USDT 수신 주소",
	"bridge.recipientPlaceholder": "0x… 또는 D… 수신 주소 입력",
	"bridge.currentWallet": "현재 지갑",
	"bridge.connectBscFirst": "먼저 BSC 지갑을 연결하세요",
	"bridge.connectCpcFirst": "먼저 DGC Wallet을 연결하세요",
	"bridge.switchMainnet": "BSC 메인넷으로 전환하세요",
	"bridge.escrowMissing": "Escrow 계약 미배포",
	"bridge.lockUsdtToData": "{amount} {usdt} 잠금 → DATA",
	"bridge.lockDataToUsdt": "{amount} {data} 잠금 → {usdt}",
	"bridge.bscBusy": "BSC 계약 상호작용 중…",
	"bridge.cpcBusy": "트랜잭션 제출 중…",
	"bridge.dataBridgeStatus": "DATA 브리지 상태",
	"bridge.treasuryLocked": "금고 잠금",
	"bridge.gatewayRpc": "게이트웨이 RPC",
	"bridge.detecting": "확인 중",
	"bridge.bnbUsdtStatus": "BNB / USDT 상태",
	"bridge.targetNetwork": "대상 네트워크",
	"bridge.usdtContract": "BNB USDT 계약",
	"bridge.escrow": "Escrow",
	"bridge.configMissing": "설정 없음",
	"bridge.nodeStatus": "노드 상태",
	"bridge.networkMatch": "네트워크 일치",
	"bridge.switchNetwork": "네트워크를 전환하세요",
	"bridge.notConnected": "연결 안 됨",
	"bridge.recentLocks": "최근 DATA 잠금",
	"bridge.forUsdt": "→ BNB USDT로",
	"bridge.noLocks": "이 네트워크에 브리지 잠금 기록이 없습니다",
	"bridge.colAmount": "잠금 수량",
	"bridge.colEstimate": "예상 수령",
	"bridge.colRecipient": "수신 주소",
	"bridge.colAction": "작업",
	"bridge.details": "상세 →",
	"bridge.showRecent5": "최근 5건 표시",
	"bridge.refreshStatus": "상태 새로고침",
	"bridge.backHome": "← 홈으로",
	"bridge.noConfig": "브리지 설정을 찾을 수 없습니다. 온체인 Bridge를 배포한 뒤 ./cpc.sh stack start 또는 fetch-stack-config를 실행하세요.",
	"bridge.connectMetaMask": "MetaMask 연결",
	"bridge.installEvm": "MetaMask 또는 다른 EVM 지갑을 설치하세요",
	"bridge.connectBsc": "BSC 지갑 연결",
	"bridge.noEvm": "EVM 지갑이 감지되지 않음",
	"bridge.disconnect": "연결 해제",
	"bridge.ok": "정상",
	"bridge.fail": "오류",
	"bridge.processing": "처리 중…",
	"bridge.useCurrent": "현재 사용",
	"bridge.needBscRecipient": "BSC 수령 주소를 입력하거나 연결하세요",
	"bridge.needCpcRecipient": "DGC 체인 수령 주소를 입력하세요",
	"bridge.escrowDeployHint": "Escrow 미설정: BSC 메인넷에 CpcUsdtEscrow를 먼저 배포하세요",
	"bridge.mainnetTokenOnly": "현재 설정은 BSC 메인넷 토큰입니다. 테스트넷 체크를 해제하세요",
	"bridge.lockedDataOk": "{amount} {data} 잠금 완료; relayer가 {recipient}… 로 약 {usdtAmount} {usdt} 지급",
	"bridge.lockedUsdtOk": "{amount} {usdt} → DATA 잠금 완료 (BSC tx {tx}…)",
	"bridge.noConfigLocalTitle": "로컬 개발: Bridge를 먼저 배포하세요:",
	"bridge.noConfigSource": "설정 원본: Push Hub /v1/stack-config (오프라인 폴백 docs/generated/cpc-stack-config.json).",
	"send.titleLeading": "On-chain",
	"send.badge": "On-chain transfer",
	"send.fail": "Transfer failed",
	"send.listSaved": "Saved to list",
	"send.recipientRequired": "Enter recipient address",
	"send.amountRequired": "Enter amount",
	"send.amountInvalid": "Invalid amount",
	"send.tokenPreset": "Default",
	"send.tokenCustom": "Custom",
	"send.balanceLine": "Available {balance} {symbol} (address balance) · Total {total}",
	"send.balanceLooseSuffix": " · Loose {loose}",
	"send.decimalsHint": "Decimals (default 9)",
	"home.titleLeading": "My",
	"home.bridgeTitle": "Cross-chain bridge USDT ↔ DGC",
	"home.bridgeSubtitle": "BSC deposit · DGC withdraw to BSC / ETH",
	"common.loadMoreFailed": "Failed to load more",
	"wallet.consolidateSkipped": "No merge needed (no loose coins)",
	"wallet.consolidateDone": "Merge complete",
	"wallet.consolidateLoose": "Merge loose DGC",
	"wallet.looseCoinHint": "You have {amount} DGC in loose coins; merge into address balance before large transfers.",
	"wallet.addressCopied": "Address copied",
	"wallet.addressUnavailable": "Address unavailable",
	"time.relativeDays": "{n} days ago",
	"time.relativeHours": "{n} hours ago",
	"time.relativeMinutes": "{n} minutes ago",
	"time.justNow": "Just now",
	"tx.direction.sent": "Sent",
	"tx.direction.received": "Received",
	"tx.direction.other": "Other",
	"tx.status.success": "Success",
	"tx.status.failure": "Failed",
	"tx.status.unknown": "Unknown",
	"tx.detailLeading": "Transaction",
	"tx.detailHighlight": "details",
	"tx.explorerMissing": "Explorer URL not configured",
	"tx.linkCopied": "Link copied",
	"settings.probing": "Probing…",
	"settings.rpcReachable": "RPC reachable · Chain {chain}",
	"settings.rpcSaved": "RPC saved",
	"settings.addedSwitched": "Added and switched",
	"settings.lockPrefsSaved": "Lock settings saved",
	"settings.exportTitle": "Export wallet",
	"settings.backupInfo": "Backup info",
	"settings.exportNoMnemonic": "(Imported via private key — no mnemonic)\n\nPrivate key:\n{pk}\n\nAddress:\n{addr}",
	"settings.exportWithMnemonic": "Mnemonic:\n{mn}\n\nPrivate key:\n{pk}\n\nAddress:\n{addr}",
	"settings.lockTitle": "Lock wallet",
	"settings.lockMessage": "You will need to enter your password again after locking.",
	"settings.lockNowAction": "Lock now",
	"settings.lockBrowserOnly": "Browser close only",
	"settings.lockMinutes": "{n} minutes",
	"settings.lock1h": "1 hour",
	"settings.lock8h": "8 hours",
	"settings.networkTitleLeading": "Network",
	"settings.networkTitleHighlight": "& RPC",
	"settings.currentNetwork": "Current network",
	"settings.currentNetworkRpc": "Current network RPC",
	"settings.saveRpc": "Save RPC",
	"settings.addCustomNetwork": "Add custom network",
	"settings.networkName": "Name",
	"settings.walletChainOptional": "Wallet chain (optional)",
	"settings.probeRpc": "Probe RPC",
	"settings.addAndSwitch": "Add & switch",
	"settings.noCustomNetwork": "No custom networks",
	"settings.securityTitleLeading": "Wallet",
	"settings.securityTitleHighlight": "security",
	"settings.rememberUnlockDefault": "Check “Stay unlocked” by default",
	"settings.currentLock": "Current: {label}",
	"settings.saveLockPrefs": "Save lock settings",
	"settings.connectedTitleLeading": "Connected",
	"settings.noConnectedSites": "No connected sites",
	"dapp.titleHighlight": "Browser",
	"dapp.tabDiscover": "Discover",
	"dapp.tabBrowser": "Browse",
	"dapp.tabHistory": "History",
	"dapp.vconsoleEnabled": "vConsole enabled",
	"dapp.vconsoleDisabled": "vConsole disabled",
	"dapp.vconsoleEnabledHint": "vConsole enabled (green button bottom-right)",
	"dapp.vconsoleClose": "Turn off vConsole",
	"dapp.vconsoleOpen": "Turn on vConsole",
	"dapp.requestFailed": "DApp request failed: {error}",
	"dapp.addTitle": "Add DApp",
	"dapp.urlLabel": "URL",
	"dapp.addedToMy": "Added to My DApps",
	"dapp.deleteBookmarkTitle": "Delete bookmark",
	"dapp.deleteBookmarkMessage": "Remove \"{name}\"?",
	"dapp.deleteConfirm": "Delete",
	"dapp.clearHistoryTitle": "Clear history",
	"dapp.clearHistoryMessage": "Clear all browsing history?",
	"dapp.clearConfirm": "Clear",
	"dapp.searchHint": "Search or enter DApp URL",
	"dapp.addDapp": "Add DApp",
	"dapp.recommended": "Recommended DApps",
	"dapp.noRecommended": "No recommendations",
	"dapp.myBookmarks": "My bookmarks",
	"dapp.customAdd": "Custom add",
	"dapp.noBookmarksYet": "No bookmarks yet. Add your favorite DApps.",
	"dapp.presetTag": "Preset",
	"dapp.browsingHistory": "Browsing history",
	"dapp.noBrowsingHistory": "No browsing history",
	"dapp.add": "Add",
	"dapp.goBack": "Go back",
	"dapp.goForward": "Go forward",
	"dapp.collapseBookmarks": "Collapse bookmarks",
	"dapp.expandBookmarks": "Expand bookmarks",
	"dapp.urlInputHint": "Enter or paste URL",
	"dapp.go": "Go",
	"dapp.bookmarkCurrentPage": "Bookmark this page",
	"dapp.webViewInitializing": "Initializing WebView…",
	"common.retry": "Retry",
	"wallet.myWallets": "My wallets",
	"wallet.listCount": "{n}",
	"wallet.importNew": "Import new wallet",
	"wallet.importLocalHint": "Keys are stored encrypted locally only. Do not screenshot or share.",
	"wallet.nameOptional": "Wallet name (optional)",
	"wallet.mnemonicHint": "12 / 24 words, space-separated",
	"wallet.privateKeyHint": "dgcprivkey1… or 64-char hex / Base64",
	"wallet.confirmImport": "Confirm import",
	"wallet.enterPrivateKey": "Enter private key",
	"wallet.enterMnemonic": "Enter mnemonic",
	"wallet.added": "Wallet added",
	"wallet.currentAccount": "Current account",
	"wallet.currentBadge": "Current",
	"wallet.hdAccountCount": "{n} HD accounts",
	"wallet.exportMnemonic": "Export mnemonic",
	"wallet.exportPrivateKey": "Export private key",
	"wallet.exportPasswordTitle": "Verify security password",
	"wallet.exportPasswordHint": "Enter your extension password to continue. Never share the secret.",
	"wallet.exportPasswordEmpty": "Enter the extension password",
	"wallet.exportWarning": "Anyone with this can control your assets. Do not screenshot or send it.",
	"wallet.exportCopied": "Copied",
	"wallet.noMnemonicToExport": "This wallet was imported from a private key and has no mnemonic",
	"wallet.exportVerify": "Verify",
	"stake.confirmClaimMessage": "Rewards credit to address balance (not loose coins).\nEstimated rewards {amount} DGC",
	"stake.confirmRedeemMessage": "About {amount} DGC principal will credit to address balance.\nThis cannot be undone.",
	"stake.redeemSuccess": "Principal redeemed",
	"stake.claimSuccess": "Rewards claimed",
	"stake.networkStakeBadge": "Network stake",
	"stake.validatorPoolTotalCaption": "Total DGC in validator pools",
	"stake.avgCommission": "Avg commission",
	"stake.lockedPrincipal": "Locked principal",
	"stake.positionValueEst": "Position value (est.)",
	"stake.lockedChip": "Locked",
	"stake.redeemableChip": "Redeemable",
	"stake.unlockedChip": "Matured",
	"stake.statusActive": "Active",
	"stake.statusPending": "Pending activation",
	"stake.principalLabel": "Principal",
	"trade.tabTrade": "Trade",
	"trade.tabMarket": "Market",
	"trade.loadMarketFailed": "Failed to load market. Please try again.",
	"trade.enterQtyShort": "Enter quantity",
	"trade.orderBookUnavailable": "Order book unavailable",
	"trade.noOrdersInBook": "No orders in book",
	"trade.turnover24hData": "24h turnover (DATA)",
	"trade.kline": "Candles",
	"trade.noKlineData": "No candle data",
	"trade.klineLegend": "MA(7) · Volume",
	"trade.fillDetailLeading": "Fill",
	"trade.fillDetailHighlight": "details",
	"trade.noOnchainDigest": "No on-chain digest",
	"trade.copyDigest": "Copy digest",
	"trade.digestCopied": "Digest copied",
	"trade.onchainDetail": "On-chain details",
	"tx.sender": "Sender",
	"tx.checkpoint": "Checkpoint",
	"tx.gasBudget": "Gas budget",
	"tx.computation": "Computation",
	"tx.storage": "Storage",
	"tx.rebate": "Rebate",
	"tx.balanceChanges": "Balance changes",
	"tx.commands": "Commands",
	"tx.digestCopied": "Digest copied",
	"tx.onchainDetail": "On-chain details",
	"receive.title": "Receive",
	"receive.networkOnlyHint": "DGC network assets only",
	"receive.copyAddress": "Copy address",
	"receive.saveImage": "Save image",
	"receive.shareText": "DGC receive address {address}",
	"receive.imageFailed": "Could not generate image",
	"receive.encodeFailed": "Image encode failed",
	"receive.saveFailed": "Save failed: {error}",
	"recipient.needValidAddress": "Enter a valid recipient address first",
	"recipient.saveContact": "Save contact",
	"recipient.editLabel": "Edit label",
	"recipient.labelName": "Label",
	"recipient.labelHint": "e.g. Alice, exchange",
	"recipient.savedOk": "Contact saved",
	"recipient.deleteContact": "Delete contact",
	"recipient.removeRecent": "Remove from recent",
	"recipient.deleteContactMessage": "Delete saved contact “{name}”.",
	"recipient.removeRecentMessage": "Remove this address from recent recipients.",
	"recipient.saveAsContact": "Save as contact",
	"recipient.noSaved": "No saved contacts",
	"recipient.noRecent": "No recent addresses",
	"recipient.hint": "Successful sends are added to recent; tap Save to add a labeled contact.",
	"recipient.contactsTab": "Contacts{count}",
	"recipient.recentTab": "Recent{count}",
	"common.paste": "Paste",
	"common.delete": "Delete",
	"common.new": "New",
	"dapp.connectTitle": "Connect DApp",
	"dapp.connectFailed": "Connection failed",
	"dapp.walletLockedHint": "Wallet is locked. Unlock before connecting.",
	"dapp.signFailed": "Signing failed",
	"dapp.signRequest": "Signature request",
	"dapp.signAndExecute": "Sign & execute",
	"dapp.signOnly": "Sign",
	"mall.payLeading": "Mall",
	"mall.payHighlight": "Pay",
	"mall.amountDueData": "Amount due (DATA)",
	"mall.orderNumber": "Order No.",
	"mall.merchantAddress": "Merchant",
	"mall.payerAddress": "Payer",
	"mall.dataBalance": "DATA balance",
	"mall.confirmPay": "Confirm payment",
	"mall.walletLocked": "Wallet is locked",
	"mall.returnAppFailed": "Could not return to the mall app. Switch manually.",
	"mall.paySuccess": "Payment successful",
	"account.switchTitle": "Switch wallet / account",
	"account.count": "{n} accounts",
	"account.hdAccounts": "HD accounts",
	"account.numbered": "Account {n}",
	"account.inUse": "In use",
	"account.tapToSwitch": "Tap to switch",
	"stake.principalMatured": "Principal matured — redeemable",
	"stake.lockHintWithActive": "Active epoch {activeEpoch} · Unlock epoch {unlockEpoch} · {epochsLeft} epochs left",
	"stake.lockHintUnlockOnly": "Unlock epoch {unlockEpoch} · {epochsLeft} epochs left",
	"stake.poolTokenShare": "Pool token share {amount}",
	"stake.requestEpoch": "Request epoch",
	"stake.claimRewardsBtn": "Claim rewards",
	"stake.redeemPrincipalBtn": "Redeem principal",
	"stake.noValidatorsAvailable": "No validators available",
	"stake.validatorFieldLabel": "Validator",
	"stake.addressLabel": "Address",
	"stake.stakePool": "Stake pool",
	"stake.commission": "Commission",
	"stake.votingPower": "Weight",
	"stake.validatorAddressCopied": "Validator address copied",
	"mall.returnFailed": "Cannot return to mall app — switch manually",
	"mall.titleLeading": "Mall",
	"mall.titleHighlight": "Pay",
	"mall.amountDue": "Amount due (DATA)",
	"bridge.usdtLockedSnack": "USDT locked · tx {digest}",
	"bridge.dgcLockedSnack": "DGC locked · digest {digest}",
	"common.cannotOpenBrowser": "Cannot open browser",
	"tx.explorerLinkFailed": "Failed to open explorer link",
	"bridge.pageTitleHighlight": "Bridge",
	"bridge.walletAccountLine": "{wallet} · {account}",
	"bridge.tabSwap": "Swap",
	"bridge.directionUsdtToDgc": "USDT → DGC",
	"bridge.ethRelayerHint": "ETH withdrawals are settled by the relayer after DGC lock.",
	"bridge.fromBsc": "From (BSC USDT)",
	"bridge.fromDgc": "From (DGC DATA)",
	"bridge.evmRecipientLabel": "{chain} recipient",
	"bridge.lockUsdtToDgc": "Lock USDT → DGC",
	"bridge.lockDgcToTarget": "Lock DGC → {target}",
	"bridge.myBridgeRecords": "My bridge records",
	"bridge.noLocalRecords": "No local bridge records yet",
	"bridge.onChainLocksAccount": "On-chain locks (this account)",
	"bridge.noOnChainLockEvents": "No on-chain lock events",
	"bridge.networkRecentLocks": "Recent network locks",
	"connect.failed": "Connection failed",
	"connect.lockedHint": "Wallet locked — unlock before connecting",
	"sign.failed": "Signing failed",
	"sign.signAndExecute": "Sign and execute",
	"sign.signOnly": "Sign",
	"recipient.noSavedContacts": "No saved contacts",
	"recipient.noRecentAddresses": "No recent addresses",
	"recipient.contacts": "Contacts",
	"recipient.recent": "Recent",
	"receive.dgcOnly": "DGC network assets only",
	"bridge.statusConfirmed": "Confirmed",
	"bridge.introInboundTitle": "Deposit USDT → DATA",
	"bridge.introInboundBody": "Lock BNB-chain USDT in escrow; Relayer mints DATA 1:1 on DGC.",
	"bridge.introOutboundEthBody": "Lock DATA on DGC; Relayer pays USDT on Ethereum.",
	"bridge.introOutboundBscBody": "Lock DATA on DGC; Relayer pays USDT on BNB Chain.",
	"bridge.webVersion": "Web version",
	"bridge.inboundEscrowUnavailable": "BSC escrow unavailable — check bridge config.",
	"bridge.balanceWithAmount": "Balance {amount}",
	"bridge.exchangeRate": "Exchange rate",
	"bridge.exchangeRateValue": "1 DATA ≈ {rate} USDT",
	"bridge.bscInbound": "BSC inbound",
	"bridge.ethOutbound": "ETH outbound",
	"bridge.statusReady": "Ready",
	"bridge.txIdLabel": "Tx ID",
	"bridge.txIdCopied": "Tx ID copied",
	"bridge.copyTxId": "Copy Tx ID",
	"trade.unlockToViewOrders": "Unlock wallet to view orders",
	"trade.partialQtyLine": "Filled {filled} / {total}",
	"trade.orderHistoryLine": "{side} · {qty} @ {price}",
	"trade.fillQtyLine": "{qty} DGC",
	"trade.estimateSpendAmount": "Est. cost {amount} DATA",
	"trade.estimateReceiveAmount": "Est. receive {amount} DATA",
	"receive.imageRenderFailed": "Could not generate image",
	"receive.imageEncodeFailed": "Image encode failed",
	"recipient.validRequired": "Enter a valid recipient address first",
	"recipient.contactSaved": "Contact saved",
	"recipient.removeFromHistory": "Remove from recent",
	"recipient.deleteSavedMessage": "Delete contact {name}?",
	"recipient.hintEmpty": "Paste an address or pick a contact",
	"tx.computationCost": "Computation",
	"tx.storageCost": "Storage",
	"tx.storageRebate": "Rebate",
	"tx.onChainDetail": "On-chain details",
	"tx.noDigest": "No on-chain digest",
	"tx.copyDigest": "Copy digest",
	"trade.marketLoadFailed": "Failed to load market. Please try again later.",
	"bridge.tabRecords": "Records",
	"bridge.directionDgcWithdraw": "DGC withdraw",
	"bridge.introOutboundTitle": "Withdraw DATA → EVM",
	"bridge.statusNotConfigured": "Not configured",
	"wallet.shellSubtitle": "Address balance · staking · custom networks",
	"wallet.totalBalanceLine": "Total {total} DGC · {chain}",
	"trade.clobToken": "CLOB token",
	"trade.openOrderMeta": "{time} · Order {qty} DGC · Remaining {remaining} DGC",
	"trade.orderTimeQtyLine": "{time} · Qty {qty}",
	"trade.fillTimeQtyLine": "{time} · Qty {qty} DGC",
	"qr.title": "Scan",
	"qr.flashlight": "Flashlight",
	"qr.unrecognized": "Unrecognized: scan mall pay code or a DGC receive address",
	"qr.hint": "Supports mall pay codes (fixed DATA amount) or DGC receive addresses",
	"home.multiChainAssets": "Multi-chain assets",
	"home.refreshBalances": "Refresh balances",
	"home.suiMainnet": "Sui mainnet",
	"home.rpcUnavailable": "RPC unavailable",
	"wallet.addressLabel": "Wallet address",
	"wallet.looseBalance": "Loose",
	"stake.poolBalanceLine": "Pool balance {balance} DGC",
	"depth.liveBook": "Live order book",
	"depth.noData": "No depth data",
	"sign.gasEstimating": "Estimating gas…",
	"dapp.tagOfficial": "Official",
	"dapp.tagRecommended": "Featured",
	"dapp.discover.explorerDesc": "Block explorer · txs & objects",
	"dapp.discover.shopName": "GlobalData Shop",
	"dapp.discover.shopDesc": "Data Global cross-border shop",
	"dapp.openExplorer": "Open DGC Explorer",
	"dapp.quickLinks": "Quick links",
	"dapp.nameLabel": "Name",
	"dapp.urlEmpty": "URL cannot be empty",
	"dapp.urlInvalid": "Invalid URL",
	"dapp.urlAlreadyBookmarked": "URL already in bookmarks",
	"dapp.preconnectSkipped": "DGC preconnect skipped: {error}",
	"dapp.scanQr": "Scan",
	"bridge.historyTitle": "크로스체인 기록",
	"bridge.historySubtitle": "양방향: DATA → USDT, USDT → DATA",
	"bridge.colDirection": "방향",
	"bridge.dirDataToUsdt": "DATA → USDT",
	"bridge.dirUsdtToData": "USDT → DATA",
	"bridge.historyNeedWallet": "DGC Wallet을 연결해 이 주소의 브리지 기록을 보세요",
	"bridge.historyOpen": "내 기록",
	"bridge.historyBackToBridge": "브리지로 돌아가기",
	"bridge.colTime": "시간",
	"bridge.historyAddress": "주소",
	"bridge.historyAutoRefresh": "자동 새로고침",
};

export const CATALOGS: Record<LocaleCode, MessageCatalog> = {
	"zh-Hant": zhHant,
	"en": en,
	"ms": ms,
	"vi": vi,
	"th": th,
	"ko": ko,
};

export function normalizeLocale(raw: string | null | undefined): LocaleCode {
	const s = (raw ?? '').trim();
	if ((LOCALE_CODES as readonly string[]).includes(s)) return s as LocaleCode;
	const lower = s.toLowerCase().replace(/_/g, '-');
	if (lower.startsWith('zh')) return 'zh-Hant';
	if (lower.startsWith('ms')) return 'ms';
	if (lower.startsWith('vi')) return 'vi';
	if (lower.startsWith('th')) return 'th';
	if (lower.startsWith('ko')) return 'ko';
	if (lower.startsWith('en')) return 'en';
	return DEFAULT_LOCALE;
}

export function t(locale: LocaleCode, key: string, fallback?: string): string {
	return CATALOGS[locale]?.[key] ?? CATALOGS.en[key] ?? fallback ?? key;
}
